import Component from 'vue-class-component'
import moduleStore from './store/index'
import Vue from 'vue'
import PageState from './store/state'
import { Dialog, Toast } from 'vant'
import inobounce from '@/utils/inobounce'
import { $deepClone } from '@/bin/util'
import { copy } from '@/utils/util'
// type
import { SpeakerItem } from './types/speaker'
import { VanToast } from 'vant/types/toast'
import { EditorSelection } from './types/editor'
// util
import SelectionUtils from '@/utils/selectionUtil'
import Dom from '@/utils/dom'
import SpeakerUtils from '@/views/index/bussiness/speaker-utils'
import { getQueryString } from '@/utils/location'
import { isArray, isObject } from '@/utils/base'
import { MAudio } from '@/utils/audio'
import { muteTimeList } from './config/muteList'
import { nestableEffectId } from './config/data'
import {updateEffctRange,hasEffectRange,checkRangeValid,getArithmeticVolume,rangeChangeHandler} from './utils/utils'
// components
// import speakerPopupComponent from './components/speakerPopup/speakerPopup'
const speakerPopupComponent = ()=> import('./components/speakerPopup/speakerPopup');
import buyVoicePopupComponent from './components/buyVoicePopup/buyVoicePopup'
import TrialVipTipDialog from './components/buyVoicePopup/TrialVipTipDialog.vue'
import FreeTipDialog from './components/buyVoicePopup/FreeTipDialog.vue'
import StyleSelectPopper from './components/style-select-popper/style-select-popper.vue'
import SpeedSelectPopper from './components/speed-select-popper/speed-select-popper.vue'
import PitchSelectPopper from './components/pitch-select-popper/pitch-select-popper.vue'
import AiXiaomo from './components/ai-xiaomo/ai-xiaomo.vue'
// sheet component
import MuteSheet from './components/sheets/mute-sheet/mute-sheet.vue'
import PhoneticsSheet from './components/sheets/phonetics-sheet/phonetics-sheet.vue'
import lianduSheet from './components/sheets/liandu-sheet/liandu-sheet.vue'
import StressSheet from './components/sheets/stress-sheet/stress-sheet.vue'
// sheet component
import allfuncSheet from './components/sheets/allfunc-sheet/allfunc-sheet.vue'
import MultiToneSheet from './components/sheets/multi-tone-sheet/multi-tone-sheet.vue'
import localSpeedSheet from './components/sheets/local-speed-sheet/local-speed-sheet.vue'
import globalMuteSheet from './components/sheets/globalMute-sheet/globalMute-sheet.vue'
import symbolMuteSheet from './components/sheets/symbol-mute/symbol-mute.vue'
import currencyPopupSheet from './components/currencyPopup/currencyPopup.vue'
import AliasChangeSheet from './components/sheets/alias-change-sheet/alias-change-sheet.vue'
import MultiSpeakerSheet from './components/sheets/multi-speaker-sheet/multi-speaker-sheet.vue'
import sensitiveSheet from './components/sheets/sensitive-sheet/sensitive-sheet.vue'
import localVolumeSheet from './components/sheets/local-volume-sheet/local-volume-sheet.vue'
// effect handler
import getEffectHandler from './effects'
import { Watch } from 'vue-property-decorator'
import { judgeDeviceType, normalizeInputEvent } from '@/utils/device'
import { isSpecialString, removeEmoji } from '@/utils/validate'
import $ from 'jquery'
import {
  uint8arrayToBase64,
  base64ToUint8Array,
  toast,
  debounce,
  isOverlapped,
  isSpaceWord,
  isSetCaret
} from '@/utils/util'
import pako from 'pako'
import LZString from '../../utils/lz-string.min'
import {
  getNextParagraphNode,
  getNextSatisfyNode,
  getPrevSiblingEffectNode,
  getPrevSiblingNonEmptyNode,
  selectNextNodeAll
} from './editor/editor-query'
import {
  clearHighlightSelection,
  highlightSelection
} from './editor/editor-compat-highlight'
import { offlineSpeakerMessage, overListenMessage } from './bussiness/dialog'
import { toVoiceShop, toBeVip } from './iosapp-interface/index'
import { VIP_TYPE } from '@/constants/vip'
import { mapGetters } from 'vuex'
import { VOICE_AUTH_TYPE, getEmotionWeightLabel } from '@/constants/voice'
import {PIC_INPUT,MOYIN_VIP_INPUT} from '@/constants/limitLength'
import {get3sCloneSpeakerById} from '@/api/speaker'
import to from "await-to-js"
export const ImageMap: any = {
  0: require('./images/icon_pause_0.svg'),
  1: require('./images/icon_pause_1.svg'),
  2: require('./images/icon_pause_2.svg'),
  3: require('./images/icon_pause_3.svg')
}

const TAG_CLASS = 'isTag'
const TAG_SELECTOR = `.${TAG_CLASS}`

export let TXT_MAX_LENGTH: number = 5000 // 最大输入文本长度
let TXT_MIN_LENFTH:number = 5;//最少输入文本长度
const NBSP_TEXT = '\u00A0'
const NBSP_HTML = '&nbsp;'
const WINDOW_HEIGHT = window.innerHeight
import {TOOLIST} from '@/constants/toolList'
import { customCollectEvent } from '@/utils/collect'
import { proxyUrl } from '@/utils/axios'
@Component({
  components: {
    speakerPopupComponent,
    buyVoicePopupComponent,
    TrialVipTipDialog,
    FreeTipDialog,
    StyleSelectPopper,
    SpeedSelectPopper,
    PitchSelectPopper,
    MuteSheet,
    lianduSheet,
    StressSheet,
    allfuncSheet,
    MultiToneSheet,
    localSpeedSheet,
    globalMuteSheet,
    symbolMuteSheet,
    currencyPopupSheet,
    MultiSpeakerSheet,
    AliasChangeSheet,
    PhoneticsSheet,
    AiXiaomo,
    localVolumeSheet,
    sensitiveSheet
  },
  provide() {
    return {
      $editorPage: this
    }
  },
	computed: mapGetters(['getVoiceStatus'])
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class indexPage extends Vue {
  VIP_TYPE = VIP_TYPE
  VOICE_AUTH_TYPE = VOICE_AUTH_TYPE
  state = new PageState()
  speakerAudio = null
  speakerAudioPaused: boolean = true
  myAudioPause: boolean = false
  src = ''
  articleSepakerId = ''
  mysms = ''
  isAiEditMode:boolean = false
  lastModifyTime: string = '' //文章最后更新时间
  editStatusShow: number = 0 // 1.保存中 2.已保存 3.保存失败 4.最近修改时间 5.5分钟前
  symbolMuteChecked: boolean = false // 智能分句开关是否打开
  get supportAutoMute() { // 文中发音人是否支持智能分句
    return this.speakersNotSupportAutoMute.length === 0
  }
  speakersNotSupportAutoMute: any[] = []; // 文中不支持智能分句的发音人
  showPopup: boolean = true
  saveStatus: any = {
    0: {
      text: '最新修改：刚刚'
    },
    1: {
      text: '正在保存文字...',
      class: 'moyin-tool_icon_saving'
    },
    2: {
      text: '已经保存到云端',
      class: 'moyin-tool_icon_save'
    },
    3: {
      text: '网络连接异常，请检查网络',
      class: 'moyin-tool_icon_save_failed'
    },
    7: {
      text: '保存失败',
      class: 'moyin-tool_icon_save_failed'
    },
    4: {
      text: '更新于 ',
      class: 'moyin-tool_icon_saving'
    },
    5: {
      text: '更新于 5分钟前',
      class: 'moyin-tool_icon_saving'
    },
    6: {
      text: '编辑内容为空，未保存',
      class: 'moyin-tool_icon_save_failed'
    },
    8: {
      text: '字数超限',
      class: 'moyin-tool_icon_save_failed'
    }
  }
  timer: any = null // 定时器
  editStatusTimer: any = null // 文章保存状态定时器
  articleLength: number = 0 // 文章长度
  isOpen = false // 展开头部列表
  showSpeeds = false //选择倍速
  showPitch = false // 语调弹框状态
  showSpeakerStyle = false // 发音人风格
  showMoreFun = false // 全部功能按钮
  showGlobalMuteSheet = false // 全局段落静音
  articlePunctuations = [
    'semi_200',
    'exclamation_200',
    'question_200',
    'comma_200',
    'stop_200',
    'pause_200'
  ]
  protocolChecked = false
  isEffectUpdate = false
  showPlaceholder: any = false
  playStatus: any = false //  播放 暂停
  isTryAudion: number = 0 //是否是试听
  lastAuditionData: any = null // 上次试听数据
  showPause = false //显示停顿调节
  showMute = false //显示插入静音
  showStress = false //显示重读
  showLiandu = false //显示连读
  showGlobalMute = false //显示段落静音
  globalMuteTime = '200' //显示段落静音
  showLocalSpeed = false //显示局部变速
  showMultiSpeaker = false //显示多发音人
  showMutilTone = false //显示多音字
  showMenuContent = false // 控制菜单内容显示
  wordText = '' //选择的多音字
  pinyin = ''
  stress = '' // 重读选项
  stresshover: number | string = ''
  rangeSelection: Partial<{
    anchorOffset: number
    focusOffset: number
    data: string
    firstRange: Range
    lastRange: Range
  }> = {}
  lastSelection: EditorSelection = {
    range: null,
    rangeText: '',
    isRangeMixed: false,

    caret: null,

    el: null,
    elText: '',
    isElMixed: false,

    wordRangeBeforeCaret: null,
    wordTextBeforeCaret: ''
  } // 上次的选区
  selectedEffectValue:any = '' // 当前点击选中特效节点的值
  muteNorIcon = require('./images/icon_mute_round_nor.png')
  muteSelIcon = require('./images/icon_mute_round_sel.png')
  radio = '1'
  continuousid = null
  tagElement: any = {}
  showBottomNavs: boolean = false
  showAudio: boolean = false // 显示试听描述
  isDownload: boolean = false
  _allSpeakerData: any = {}
  bottomNavItems: any = [
    {
      id: 1,
      name: '多音字',
      active: false,
      type: 'multi-tone',
      authId: 1,
      img: require('./images/icon_tone_color.svg'),
      disabledImg: require('./images/icon_tone_gray.svg')
    },
    {
      id: 2,
      name: '重读',
      active: false,
      type: 'stress',
      authId: 19,
      img: require('./images/icon_read_color.svg'),
      disabledImg: require('./images/icon_read_gray.svg')
    },
    {
      id: 3,
      name: '停顿调节',
      active: false,
      type: 'pause',
      authId: 8,
      img: require('./images/icon_rhythm_color.svg'),
      disabledImg: require('./images/icon_rhythm_gray.svg')
    },
    {
      id: 4,
      name: '插入静音',
      active: false,
      type: 'mute',
      authId: 9,
      img: require('./images/icon_mute_color.svg'),
      disabledImg: require('./images/icon_mute_gray.svg')
    },
    {
      id: 5,
      name: '连读',
      active: false,
      type: 'liandu',
      authId: 3,
      img: require('./images/icon_continuous_color.svg'),
      disabledImg: require('./images/icon_continuous_gray.svg')
    },
    {
      id: 6,
      name: '局部变速',
      active: false,
      type: 'localSpeed',
      authId: 6,
      img: require('./images/icon_changespeed_color.svg'),
      disabledImg: require('./images/icon_changespeed_gray.svg')
    },
    {
      id: 7,
      name: '段落静音',
      active: false,
      type: 'globalMute',
      authId: 12,
      img: require('./images/icon_symbol_color.svg'),
      disabledImg: require('./images/icon_symbol_gray.svg')
    },
    {
      id: 8,
      name: '符号静音',
      active: false,
      type: 'symbolMute',
      authId: 15,
      img: require('./images/icon_symbolmutel_color.svg'),
      disabledImg: require('./images/icon_symbolmute_gray.svg')
    },
    {
      id: 9,
      name: "多人配音",
      active: false,
      type: "multiSpeaker",
      authId: 7,
      img: require("./images/icon_management_color.svg"),
      disabledImg: require("./images/icon_management_color.svg"),
    },
    {
      id: 11,
      name: "别名",
      active: false,
      type: "aliasChange",
      authId: 4,
      img: require("./images/icon_speaker_color.svg"),
      disabledImg: require("./images/icon_speaker_color.svg"),
    },
    {
      id: 10,
      name: "音标",
      active: false,
      type: "phonetics",
      authId: 5,
      img: require("./images/icon_english_color.svg"),
      disabledImg: require("./images/icon_english_gray.svg"),
    },
    {
      id: 12,
      name: "音量",//功能名称
      active: false,//是否选中
      type: "volume",
      global:Boolean(TOOLIST.SLABEL_GLOBAL_VOULME),//是否展示-与发音人无关
      img: require("./images/icon_changevolume_color.svg"),//未选中图
      disabledImg: require("./images/icon_changevolume_color.svg"),//选中图
    }
  ]
  activeSheetType: string = '' // 当前打开的面板类型
  hoverPauseObjs = {
    '0': require('./images/icon_features_pause0_hover.svg'),
    '1': require('./images/icon_features_pause1_hover.svg'),
    '2': require('./images/icon_features_pause2_hover.svg'),
    '3': require('./images/icon_features_pause3_hover.svg')
  }
  // 停顿
  pauseObjs = [
    { id: 1, name: '无停顿', checked: false, value: 0 },
    {
      id: 2,
      name: '短',
      checked: false,
      value: 1,
      icon1: require('./images/pause_short_white.png'),
      icon2: require('./images/pause_short_blue.png')
    },
    {
      id: 3,
      name: '中',
      checked: false,
      value: 2,
      icon1: require('./images/pause_center_white.png'),
      icon2: require('./images/pause_center_blue.png')
    },
    {
      id: 4,
      name: '长',
      checked: false,
      value: 3,
      icon1: require('./images/pause_lang_white.png'),
      icon2: require('./images/pause_lang_blue.png')
    }
  ]
  placeholderText = `请输入文本内容...(最多${TXT_MAX_LENGTH}字)`;
  originPinyinVisible = false // 是否显示编辑器内多音字
  multiToneOptions = [] // 多音字选项

  stressObj = [
    { id: 1, name: '强', checked: false, value: 1 },
    { id: 2, name: '默认', checked: false, value: -1 }
  ]

  muteObjs = muteTimeList.map((item: any, idx: number) => {
    item.checked = false
    item.id = idx + 1
    return item
  })
  wordAndReplaceList: any = []
  selfMute = ''
  mutilToneObjs = []

  /*   @Watch('showMutilTone')
  clearTonesList(bool: boolean) {
    if (bool == false) {
      this.mutilToneObjs = [];
    }
  } */

  selection = new SelectionUtils()
  speakerUtils:SpeakerUtils = null
  cachedDomJson = null
  showbottomfield = true
  showComposing = false
  articleContent = null
  isEditorFocus: boolean = false
  isClickCompose = true // 是否可以点击合成
  sensitiveChecking = false // 敏感词检查请求在途标志（防连点重复请求）
  speaker: string = null
  copyText = null //复制的文字
  isIOS:boolean = judgeDeviceType.isIOS
  isAPP: boolean = judgeDeviceType.isAPP
  editorHtml: string = null
  clipboardData: any = '' // 获取小程序剪切板内容
  mergeSymbol: number = 0
  // isIOS = false;
  loginInvalIText: string = '登录已过期,请重新登录'
  bgmId:string=""
  checkboxChecked: boolean = false
  getVoiceStatus: Function;
  buyVoiceTipVisible: boolean = false; // 免费用户使用未购买声音提示
  trialVipTipVisible: boolean = false; // 体验会员使用未购买声音提示
  btnConfig:any={
    btnTxt:'配音',//配音按钮文字
    showDownBtn:true//是否显示下载按钮
  }
  docTitle:string='魔音工坊';
  isPicIn:string='';//是否是图片-奇妙元照片限制200字
  firstTabFirstSpeaker:any = {};//默认第一个可用发音人
  showBottomAixiaomo:boolean = false;//是否展示AI小魔内容区域
  projectId:number=0;
  aiText:string='';
  aiXiaoMoHide: boolean = window.location.href.indexOf('aiXiaoMoHide=true') > -1
  isTT:any=false;
  getEmotionWeightLabel = getEmotionWeightLabel
  showTimePopover=false;
  is3sclone = false;
  created(moduleData: IinjectDatas) {
    let moyinConfig:any ={
      btnTxt:'配音',//配音按钮文字
      showDownBtn:true//是否显示下载按钮
    }
    let weta356Config:any = {
      btnTxt:'完成',//配音按钮文字
      showDownBtn:false//是否显示下载按钮
    }
    
    this.btnConfig = window.platformSource=='weta365'?weta356Config:moyinConfig;
    this.docTitle = window.platformSource=='weta365'?'奇妙元':'魔音工坊';
    document.title = this.docTitle;
    this.state = <PageState>moduleData.state
    this.state.isWeta365 = window.platformSource=='weta365';
    let [
      ww_token,
      from,
      articleId,
      speakerId,
      articleContent,
      copyText,
      speaker,
      clipboardData,
      platform,
      isPic,
      wwid,
      is3scloneSpeaker
    ] = [
      getQueryString('ww_token'),
      getQueryString('from'),
      getQueryString('articleId'),
      getQueryString('speakerId'),
      getQueryString('articleContent'),
      getQueryString('copyText'),
      getQueryString('speaker'),
      getQueryString('clipboardData'),
      getQueryString('platform'),
      getQueryString('isPic'),
      getQueryString('wwid'),
      getQueryString('is3sclone')
    ]
    this.isPicIn = isPic;
    this.is3sclone = is3scloneSpeaker=='true';
    console.log('是否是3s克隆',this.is3sclone);
    TXT_MAX_LENGTH = isPic =='true'?PIC_INPUT:MOYIN_VIP_INPUT;
    this.placeholderText = this.isPicIn?`请输入配音内容...(不少于${TXT_MIN_LENFTH}字,最多${TXT_MAX_LENGTH}字)`:`请输入文本内容...(最多${TXT_MAX_LENGTH}字)`;
    if (ww_token || localStorage.getItem('ww_token')) {
      if (!ww_token) {
        localStorage.removeItem('ww_token')
      }
      this.state.ww_token = ww_token
    }
    if(wwid){
      localStorage.setItem('wwid',wwid);
    }
    if (from == 'login') {
      this.initDataFromLogin(ww_token)
    } else {
      if (articleId) {
        this.state.articleId = articleId
      } else if (sessionStorage.getItem('articleId')) {
        this.state.articleId = sessionStorage.getItem('articleId')
      }else{
        this.state.articleId = ""
      }
      
      // speakerId = '75027';//测试 -待注释--
      speakerId && (this.articleSepakerId = speakerId)
      articleContent && (this.articleContent = articleContent)
      copyText && (this.copyText = copyText)
      speaker && (this.speaker = speaker)
    }

    this.clipboardData = clipboardData || ''
    // this._getSpeakerTypeList()//情感接口感觉可以不用单独查了
    // this.getArticlePaymentStatus()

    this.initPage()
    if(platform){
      this.isTT = platform==='tt';
      localStorage.setItem('platform',platform)
    }
  }
  initDataFromLogin(ww_token) {
    if (ww_token) {
      localStorage.setItem('ww_token', ww_token)
    }
    if (localStorage.getItem('speakerId')) {
      this.articleSepakerId = localStorage.getItem('speakerId')
    }
    if (localStorage.getItem('editorHtml')) {
      this.editorHtml = localStorage.getItem('editorHtml')
    }
    if (localStorage.getItem('speedSlideVal')) {
      this.state.speedSlideVal = localStorage.getItem('speedSlideVal')
    }
    if (localStorage.getItem('emotionWeight')) {
      this.state.emotionWeight = +localStorage.getItem('emotionWeight') || 1
    }
    if (localStorage.getItem('pitchSlideVal')) {
      this.state.pitchSlideVal = localStorage.getItem('pitchSlideVal')
    }
    window.taroRawSdk.miniProgram.postMessage({
      data: { ww_token: localStorage.getItem('ww_token') }
    })
  }
  gotoLogin() {
    if (this.isAPP) {
      let callAppLogin: any = (<any>window).callAppLogin
      // console.log(1000);
      callAppLogin.postMessage('')
    } else {
      this.$navigateTo({ url: '/pages/login/login?from=audioweb' })
    }
  }
  get articleInfo(){
    return {
      speed: this.state.speedSlideVal,
      pitch: this.state.pitchSlideVal,
      speaker: this.state.currentSelectSpeaker,
      volume: 80,
      audio_type:"wav",
      articleId:this.state.articleId,
      ww_token:this.state.ww_token
    }
  }
  saveArticleToLocal() {
    !!this.state.currentSelectSpeaker &&
      localStorage.setItem('speakerId', this.state.currentSelectSpeaker.id)
    localStorage.setItem('speedSlideVal', this.state.speedSlideVal)
    localStorage.setItem('emotionWeight', "" + this.state.emotionWeight)
    localStorage.setItem('pitchSlideVal', this.state.pitchSlideVal)
    localStorage.setItem('editorHtml', JSON.stringify(this.editor.innerHTML))
  }
  updated() {
    document.title = this.docTitle;
  }

  editor: any = null
  cursor: any = null
  cursorVisible: boolean = false
  cursorPosition: any = {
    top: -999,
    left: -10
  }
  phone = ''
  sms = ''
  aiTipShow = true
  sendCaptchaStatus = true
  num = 60
  countDownTimer = null
  codeMessage = ''
  isShowSmsCode = false
  content: string = ``
  islog = false
  auditionAudio: any = null
  originRenderContent: string = ''
  selectionAddr: any = {}
  sectionType: string = '' // 选区类型
  editer: any = ''
  selRange: any = {}
  auditionAction: boolean = false
  initWinHeight = 0
  lastVolumeValue = 70;//上一次设置的发音人音量
  mounted(moduleData: IinjectDatas) {
    ;(window as any).getIOSClipBordContent = this.getIOSClipBordContent
    //上面的会逐步过渡到下面这个方法；
    ;(window as any).getAppClipBordContent = this.getAppClipBordContent
    ;(window as any).setKeyboardHeight = debounce(
      this.setKeyboardHeight.bind(this),
      50,
      false
    ) // 防抖，只获取最后一次的高度，避免页面不断重新布局
    let href: String = window.location.href
    if (href.indexOf('source=app') != -1) {
      this.loginInvalIText = null
    }
    
    let self = this
    self.state.hasBeenRemind = false
    this.editer = this.$refs.editor
    this.$nextTick(() => {
      this.editor = this.$refs.editor
      this.cursor = this.$refs.cursor
      if (localStorage.getItem('articleDom')) {
        this.editer.innerHTML = localStorage.getItem('articleDom')
        localStorage.removeItem('articleDom')
      }
      this.editor.addEventListener('paste', this.pasteTxt)
      let KeyswrapperRef: any = this.$refs.KeyswrapperRef
      document.addEventListener('scroll',this.scrollEvt,true)
      this.editor.addEventListener(
        'click',
        (e: any) => {
          // console.log('-----click',e.target)
          this.onEditorClick(e)
          e.preventDefault()
        },
        true
      )
    // this.initKeyBoardHeight()
  
      // document.addEventListener("click", this.onEditorMousedown, false)
      //在捕获阶段，点击时清除一些特效
      document.addEventListener('click', this.menuClick, true)
      document.addEventListener('selectionchange', this.selectionchange, false)
      document.addEventListener('focusin', this.onFocusin)
      //手动添加滑选光标挪动事件
      let iosV = this.getIosVersion()
      let iosVNum: number = 0
      if (iosV) {
        iosVNum = iosV.split('_').length > 2
          ? parseInt(iosV.split('_').join(''))
          : parseInt(iosV.split('_').join('')) * 10
      }
      if (iosV && iosVNum >= 1700) {
        const hangdler = new rangeChangeHandler(this.editor)
      }
    })
    inobounce.disable()
  }
 
  getAppClipBordContent(message: string){
    this.clearTxt(false)
    this.insertTxtToDocument(decodeURIComponent(message))
  }
  getIOSClipBordContent(message: string) {
    this.clipboardData = message || ''
    this.dealPasteTxt()
  }
  pasteTxtByButton() {
    if (this.isAPP) {
      let notifyGetCopyText: any = (<any>window).notifyGetCopyText
      //let param:string=JSON.stringify({'articleId':this.state.articleId,'audioLink':this.state.audioOssFile,'videoName':this.editor.textContent.slice(0,11)})
      notifyGetCopyText.postMessage('')
      this.debounce(this.addGlobalMute, 1000, 'timer2')
    } else {
      toast('请点击输入框，长按粘贴内容', 'top')
    }
  
  }
  updatePSetting({modelId,featureId,setting}){
    let formData2 = new FormData()
    formData2.append('modelId', modelId)
    formData2.append('featureId', featureId)
    formData2.append('setting',  setting )
    this.$http('updatePersonalSetting', { body: formData2 })
  }
 
  changeSwitch() {
    let value = this.symbolMuteChecked ? '1' : '0'
    if (!this.state.articleId){
      this.updatePSetting({
        modelId:'1',
        featureId: '24',
        setting : value
      })
      return
    }
    // 开启智能分句检查文中是否有不支持的发音人
    if (this.symbolMuteChecked) {
      const speakersNotSupport = this.getSpeakersNotSupportAutoMute()
      if (speakersNotSupport.length > 0) {
        this.symbolMuteChecked = false
        Dialog.alert({
          title: '温馨提示',
          message: `发音人${speakersNotSupport[0].name}暂不支持智能分句模式，请先修改发音人`,
          confirmButtonText: '知道了',
          className: 'pop-confirm pop-alert',
          getContainer: '#page-audition',
        }).then(() => {
          // 点击知道了，关闭弹框
        })
        return
      }
    }
    
   
    let formdata = new FormData()
    formdata.append('mergeSymbol', value)
    let otherJson= JSON.stringify({
      speed: this.state.speedSlideVal,
      pitch: this.state.pitchSlideVal.replace('+', ''),
      emotionWeight: +this.state.emotionWeight || 1,
      speakerId: this.state.currentSelectSpeaker.id,
      bgmId: this.bgmId?this.bgmId:'',
      volume: 80,
      editedArticle: this.state.isComposed,
      compress_type: 1,
      globalMuteTime: this.globalMuteTime,
      showGlobalMute: this.showGlobalMute,
      mergeSymbol:this.symbolMuteChecked?'1':'0',
    })
    formdata.append('otherJson', otherJson)
    this.state.isComposed = false
    this.$http('updateSomeArticleDetail', {
      id: this.state.articleId,
      body: formdata
    })
      .then(res => {
        if (res.code == 200) {
          this.updatePSetting({
            modelId:'1',
            featureId: '24',
            setting:value
          })
        } else {
          let message = `${
            this.symbolMuteChecked ? '开启' : '关闭'
          }智能分句模式失败，请稍后再试。`
          toast(message, 'top')
          this.symbolMuteChecked = !this.symbolMuteChecked
        }
      })
      .catch(() => {
        let message = `${
          this.symbolMuteChecked ? '开启' : '关闭'
        }智能分句模式失败，请稍后再试。`
        toast(message, 'top')
        this.symbolMuteChecked = !this.symbolMuteChecked
      })
  }
  updateSymbolMute(symbolList) {
    let SymbolMute = symbolList.map(ele => {
      return ele.key + '_' + ele.time
    })
    if (!this.state.articleId){
      this.articlePunctuations = SymbolMute
      this.updatePSetting({
        modelId:'1',
        featureId: '15',
        setting:JSON.stringify(SymbolMute)
      })
      return
    }

    let formdata = new FormData()
    formdata.append('punctuations', JSON.stringify(SymbolMute))
    this.state.isComposed = false
    this.$http('updateSomeArticleDetail', {
      id: this.state.articleId,
      body: formdata
    })
      .then(res => {
        if (res.code == 200) {
          this.articlePunctuations = SymbolMute
          this.updatePSetting({
            modelId:'1',
            featureId: '15',
            setting:JSON.stringify(SymbolMute)
          })
        } else {
          toast('符号静音修改失败，请稍后再试', 'top')
        }
      })
      .catch(() => {
        toast('符号静音修改失败，请稍后再试', 'top')
      })
  }
  //更新全局音量
  changeVolume(newVolume){
    let vm = this;
    if(!this.state.articleId){
      this.updateHistoryVolumeFn(newVolume);//同pc
      return;
    }else{
      this.state.isComposed = false
      let formdata = new FormData();
      let otherJson= JSON.stringify({
        speed: this.state.speedSlideVal,
        pitch: this.state.pitchSlideVal.replace('+', ''),
        emotionWeight: +this.state.emotionWeight || 1,
        speakerId: this.state.currentSelectSpeaker.id,
        bgmId: this.bgmId?this.bgmId:'',
        volume: 80,
        editedArticle: this.state.isComposed,
        compress_type: 1,
        globalMuteTime: this.globalMuteTime,
        showGlobalMute: this.showGlobalMute,
        mergeSymbol:this.symbolMuteChecked?'1':'0',
      })
    formdata.append('otherJson', otherJson)
    this.$http('updateSomeArticleDetail', {
      id: this.state.articleId,
      body: formdata
    }).then(res => {
        if (res.code == 200) {
          vm.updateHistoryVolumeFn(newVolume);//同pc
        }else{
          toast('音量修改失败，请稍后再试', 'top')
        }
      }).catch(() => {
        toast('音量修改失败，请稍后再试', 'top')
      })
    }
  }
  //保存设置的音量信息
  updateHistoryVolumeFn(newVolume){
    this.lastVolumeValue = newVolume;
    let formdata = new FormData()
    formdata.append('volume', newVolume)
    this.$http('updateHistoryVolume',{body:formdata}).then(res=>{
      if(res.code==200){
        toast('音量设置成功','top')
      }else{
        toast('音量修改失败，请稍后再试', 'top')
      }
    }).catch(()=>{
      toast('音量修改失败，请稍后再试', 'top')
    });
  }
  dealPasteTxt() {
    let { clipboardData } = this
    if (clipboardData) {
      clipboardData = LZString.decompressFromBase64(clipboardData)
      this.clearTxt(false)
      this.insertTxtToDocument(clipboardData)
    } else {
      toast('剪切板没有内容', 'top')
    }
  }
  /**
   *
   * @param {string} content 文章内容
   * @returns {string} 处理后的文章
   */
  cutContentValue(content) {
    let num = TXT_MAX_LENGTH
    if (content.length > num) {
      let textCount = 0
      let textContent = '',
        reg = /[\u4E00-\u9FA5a-zA-Z0-9]{1,}/
      for (var i = 0; i < content.length; i++) {
        if (
          content[i] !== '\n' &&
          content[i] !== '\r\n' &&
          content[i] !== '\r'
        ) {
          if (reg.test(content[i])) {
            textCount++
          }
        }
        if (textCount > num) {
          toast(`文章超过${TXT_MAX_LENGTH}字，已自动为您截取`, 'top')
          textContent = content.substring(0, i)

          break
        }
      }
      return textContent || content
    } else {
      return content
    }
  }
  insertTxtToDocument(text) {
    text = removeEmoji(text)
    // text = text.replace(/\</g, '&lt;')
    text = this.replaceSymbol(text)
    // text = text.replace(/[\n]/g, '<br>')
    text = this.cutContentValue(text)

    text = text
      .split('\n')
      .map(str => `<div>${str}</div>`)
      .join('')

    // text = text.replace(/[\s]/g, '&nbsp;');
    this.state.isComposed = false
    this.showPlaceholder = false
    this.editor.innerHTML = text
    this.$nextTick(() => {
      let nodeList = this.editor.childNodes
      let lastIndex = nodeList.length - 1
      // this.setFakeCaretAfter(nodeList[lastIndex])

      setTimeout(() => {
        // 如果安卓设置光标，安卓会出现两个光标
        if (this.isIOS) {
          this.setFakeCaretAfter(nodeList[lastIndex])
          this.scrollToView()
        }
      }, 610)
    })
    setTimeout(() => {
      this.__getValueToState()
      this.getArticleLength()
      this.cursorVisible = false
    }, 605)
    this.debounce(this.onlySaveArticleToServer)
  }
  async pasteTxt(e?: ClipboardEvent) {
    let eventData = e?.clipboardData || window.clipboardData
    let text = eventData?.getData('Text') || ''
    if (!text) {
      try {
        text = await navigator.clipboard.readText()
      } catch (e) {
        console.log(e)
      }
    }
    if (window.location.href.indexOf('mobile-pre') !== -1) {
      this.$http('logger', { log: `[paste:]${encodeURIComponent(text)}` })
    }
    e && e.preventDefault()
    this.doWithPasteTxt(text)
  }
  /**
   *
   * @param text 文本内容
   * @returns {number} 文章长度 大于5000返回5001
   */
  getTxtLength(text) {
    let count = 0
    let reg = /[\u4E00-\u9FA5a-zA-Z0-9]{1,}/
    for (var i = 0; i < text.length; i++) {
      if (reg.test(text[i])) {
        count++
      }
      if (count > TXT_MAX_LENGTH) {
        break
      }
    }
    return count
  }
  // 处理获取到的文本 去除特殊表情字符 \n处理 文本长度等
  doWithPasteTxt(text) {
    text = removeEmoji(text)
    // text = text.replace(/\</g, '&lt;')
    text = this.replaceSymbol(text)
    // 粘贴前先判断文章长度 文章长度加剪切板内容长度和最大长度比较
    this.__getValueToState()
    this.getArticleLength()
    if (this.articleLength === 0) {
      text = this.cutContentValue(text)
    } else if (this.articleLength + this.getTxtLength(text) > TXT_MAX_LENGTH) {
      text = text.substring(0, TXT_MAX_LENGTH)
      toast(`请输入${TXT_MAX_LENGTH}字以内的文本`, 'top')
      return
    }
    this.state.isComposed = false
    text = text
      .split('\n')
      .map(str => `<div>${str}</div>`)
      .join('')
    let isSuccess = document.execCommand('insertHTML', false, text)
    setTimeout(() => {
      if (!isSuccess) {
        this.insertHtml(text)
        if (window.location.href.indexOf('mobile-pre') !== -1) {
          this.$http('logger', {
            log: `[customInsertHtml:]${encodeURIComponent(text)}`
          })
        }
      }
    })
  }
  insertHtml(html) {
    let sel = window.getSelection(),
      range
    if (sel.getRangeAt && sel.rangeCount) {
      //getRangeAt(index) 从当前selection对象中获得一个range对象。
      range = sel.getRangeAt(0)
      //deleteContents()方法,range内容会被删除
      range.deleteContents()
      //将输入的内容写入并加载到 dom 中
      let el = document.createElement('div')
      el.innerHTML = html
      let frag = document.createDocumentFragment(),
        node,
        lastNode
      while ((node = el.firstChild)) {
        lastNode = frag.appendChild(node)
      }
      //insertNode,在range的开始位置插入一 个节点
      range.insertNode(frag)
      //收尾
      if (lastNode) {
        range = range.cloneRange()
        range.setStartAfter(lastNode)
        range.collapse(true)
        sel.removeAllRanges()
        sel.addRange(range)
      }
      setTimeout(() => {
        this.__getValueToState()
        this.getArticleLength()
      }, 605)
      this.debounce(this.onlySaveArticleToServer)
    }
  }
  scrollEvt(e) {
    this.touchmoveindex=e.target.nodeName
    if(e.target==this.$refs.editor){
      if (this.cursorVisible) {
        if(this.selection.savedSelectionRange){
          this.cursorPosition = SelectionUtils.rect2(this.selection.savedSelectionRange)
        }else{
          this.cursorPosition = SelectionUtils.rect
        }
       
      }
    }else if(e.target==document){
      window.scrollTo(0,0)
    }
  }
  beforeDestroy() {
    inobounce.disable()
    this.onlySaveArticleToServer()
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
  destroyed() {
    document.removeEventListener('selectionchange', this.selectionchange, false)
    document.removeEventListener('scroll',this.scrollEvt,true)
    document.removeEventListener('click', this.menuClick, true)
    document.removeEventListener('focusin', this.onFocusin)
  }

  @Watch('showBottomNavs')
  bottomNavVisible(bool: boolean) {
    if (bool == false) {
      this.cursorPosition = {
        top: -999,
        left: -10
      }
    }
  }
  @Watch('showbotomDetail')
  showBottomNavEvt(bool: boolean) {
    if (bool == true) {
      // setTimeout(() => {
      //   this._fitAddr(20)
      // })
    }
  }
  
  @Watch("$route")
  watchRouteParamChange() {
    let { r, clipboardData } = this.$route.query
    if (r) {
      this._getUserVipInfo()
      this.getAllSpeakersData(true); //新版
    }
    if (clipboardData) {
      this.clipboardData = clipboardData
    }
  }
  get txtLengthShow() {
    return `${this.articleLength.toLocaleString()}/${TXT_MAX_LENGTH.toLocaleString()}字`
  }
  get modifyTime() {
    if (this.lastModifyTime) {
      return (
        this.lastModifyTime.slice(5, 7) +
        '月' +
        this.lastModifyTime.slice(8, 10) +
        '日 ' +
        this.lastModifyTime.slice(11, 16)
      )
    }
    return '24小时之前'
  }
  editorKeyboardHeight = 0 // 键盘高度，只记录大于0的情况
  get currentKeyboardHeight() {
    if (this.$store.state.keyboardTrigger === 'editor') {
      // 只有editor的键盘 才更新布局
      if (this.$store.state.cachedKeyboardHeight > 0) {
        this.editorKeyboardHeight = this.$store.state.cachedKeyboardHeight
      }
      return this.editorKeyboardHeight
    }
    return this.editorKeyboardHeight
  }
  get showbotomDetail() {
    return !!(
      (this.showMutilTone || this.showMute || this.showPause) &&
      judgeDeviceType.isIOS &&
      this.showBottomNavs
    )
  }

  get currentSelectedSpeakerStyleList() {
    let vm = this
    if (!this.state.currentSelectSpeaker) return []
    let key = this.state.currentSelectSpeaker.speaker.split('@')[0]
    if (!this.state.allSpeakersMap[key]) {
      if (key.indexOf('_meet') != -1) {
        key = key.replace('_meet', '_lpcnet')
      } else {
        key = key.replace('_lpcnet', '_meet')
      }
    }
    let arr = Object.values(this.state.allSpeakersMap[key] || {}).map(
      (item: any) => {
        let mood = item.speaker.split('@')[1]
        // console.log(vm.state.emotionListMap[mood])
        item.styleAvatar = vm.state.emotionListMap[mood] || item.headerImage
        return item
      }
    )
    arr.map(val => {
      if (val.styleName == '通用') {
        val.styleName = '默认'
      }
    })
    if (arr[0] && arr[0].styleName !== '默认') {
      let itemIndex = arr.findIndex(item => {
          return item.styleName === '默认'
        }),
        item = arr.splice(itemIndex, 1)[0]
      arr = [item, ...arr]
    }
    return arr
  }
  get currentSelectSpeakerStyleName() {
    let name = (this.state.currentSelectSpeaker.styleName || '默认')
    if (name.length > 4) {
      name = name.slice(0, 3) + '...'
    }
    return name
  }

  get supportEmotionWeight() {
    return this.state.currentSelectSpeaker?.hasEmotion || false
  }
    /**本次扣除次数 */
    get deductCount() {
        return Math.ceil(this.state.priceData.contentLength/5000)
    }
  /**
   * 剩余是否可用
   */
  get isResidueCount() {
    return (
      this.state.priceData.leftWordCount >= this.state.priceData.contentLength
    )
  }
  /**
   * 处理字数格式
   */
  get wordCountDesc() {
    let count = this.state.priceData.sumWordCount
    if (count < 1000) {
      return count
    } else if (count >= 1000 && count < 10000) {
      return count / 1000 + '千'
    } else {
      return count / 10000 + '万'
    }
    return 0
  }
  get showAudioProgress() {
    return !this.showBottomNavs &&
      this.showbottomfield &&
      this.showComposing == false &&
      this.state.isComposed == true &&
      !!this.composedAudio
  }
  /**
   * 重读描述
   */
  get stressDesc() {
    let text = judgeDeviceType.isIOS
      ? '双击内容区域激活文字滑选进行设置，最多选中10个文字。'
      : '长按激活文字滑选进行设置，最多选中10个文字。'
    return text
  }
/*   getsms() {
    if (!this.phone) {
      toast('请输入手机号', 'top')
      return
    }
    this.sendCaptchaStatus = false
    this.isShowSmsCode = false
    this.$http('getcustomsms', {
      phone: this.phone,
      usage: 'login',
      origin: 'voice-maker-mini'
    })
      .then(res => {
        if (res.err_code === 0) {
          // this.$message.success(res.data.msg || '短信已发送')
          toast('短信已发送', 'top')
          this.codeMessage = res.msg
          this.isShowSmsCode = true
          this.captchaCountdown()
        } else if (res.err_code === 2007) {
          toast(res.err_msg)
          this.codeMessage = res.err_msg
          this.sendCaptchaStatus = true
        } else if (res.err_msg.indexOf('频繁') !== -1) {
          this.codeMessage = res.err_msg
          this.sendCaptchaStatus = true
          toast(res.err_msg)
        } else if (res.err_msg.indexOf('短信') !== -1) {
          this.codeMessage = res.err_msg
          this.sendCaptchaStatus = true
          toast(res.err_msg)
        } else {
          if (res.err_code === 308) {
            toast('验证码发送失败！请检查手机号是否正确！')
          } else {
            toast(res.err_msg || '服务出错，code94')
          }
          this.sendCaptchaStatus = true
        }
      })
      .catch(() => {
        toast('短信发送失败，请稍后再试')
        try {
        } catch (error) {
          console.log(error)
        }
        this.sendCaptchaStatus = true
      })
  } */
/*   // 倒计时
  captchaCountdown() {
    this.num = 60
    this.countDownTimer = setInterval(() => {
      if (this.num === 0) {
        clearInterval(this.countDownTimer)
        this.sendCaptchaStatus = true
      } else {
        this.num--
      }
    }, 1000)
  }
  // 验证码登录
  captchaLogin() {
    let self = this
    if (!this.phone || !this.mysms) {
      toast('请输入手机号及验证码', 'top')
      return
    }
    if (!this.protocolChecked) {
      toast('请先同意协议', 'top')
      return
    }
    this.$http('getcaptchalogin', {
      phone: this.phone,
      usage: 'login',
      app: 'voice-maker-mini',
      origin: 'voice-maker-mini',
      captcha_value: this.mysms
    })
      .then(res => {
        if (res.err_code === 0) {
          self.state.ww_token = res.token
          localStorage.setItem('ww_token', res.token)
          self.state.isLogined = true
          toast('登录成功')
          window.taroRawSdk.miniProgram.postMessage({
            data: { ww_token: res.token }
          })
          this.initPage(true)
        } else {
          toast(res.err_msg)
        }
      })
      .catch(res => {
        toast(res.err_msg)
      })
  } */

  selectionchange() {
    if(this.showBottomAixiaomo){
      return
    }
    let selection = window.getSelection()
    // 记录上次的选区
    try {
      const lastRange =
        selection.rangeCount == 1 ? selection.getRangeAt(0) : null
      if (lastRange && SelectionUtils.isRangeAtEditor(lastRange)) {
        this.updateLastRange(lastRange)
      }

      // 聚焦到段尾时调整光标
      // this.adjustCaretOnFocusParagraphTail()
    } catch (error) {}

    if (
      selection.type == 'Range' &&
      selection.rangeCount == 1 &&
      SelectionUtils.isRangeAtEditor(selection.getRangeAt(0))
    ) {
      clearHighlightSelection()
      this.cursorVisible = false
      this.rangeSelection.anchorOffset = selection.anchorOffset // 开始位置
      this.rangeSelection.focusOffset = selection.focusOffset // 结束位置
      this.rangeSelection.data = selection.toString()
      this.rangeSelection.firstRange = selection.getRangeAt(0)
      this.rangeSelection.lastRange = selection.getRangeAt(
        selection.rangeCount - 1
      )
    }

    /*   debounce(()=>{
        if(selection.type == "Caret"){

        }
      },100) */
    if (this.editor.contains(selection.focusNode)) {
      this.selectionAddr.anchorNode = selection.focusNode
      this.selectionAddr.anchorOffset = selection.focusOffset
      this.selectionAddr.type = selection.type
    }
    // console.log('--- SelectionUtils.isRangeAtEditor(selection.getRangeAt(0))', SelectionUtils.isRangeAtEditor(selection.getRangeAt(0)))
    if (
      (selection.type == 'Range' || selection.type == 'Caret') &&
      selection.rangeCount == 1 &&
      SelectionUtils.isRangeAtEditor(selection.getRangeAt(0))
    ) {
      this.sectionType = selection.type
      // 选区缓存
      this.selection.savedSelectionRange = selection.getRangeAt(0)
      // 对比编辑器内文章是否变化
      if (this.originRenderContent !== this.__getEditorContent()) {
        this.auditionAudio?.pause()
        this.composedAudio?.pause()
      }
      // // 模拟光标位置
      this.cursorPosition = SelectionUtils.rect
    }

    if ($('#editor:focus').length > 0 && this.cursorVisible) {
      this.cursorVisible = false
    }
    if (
      selection.type == 'Caret' &&
      SelectionUtils.isRangeAtEditor(selection.getRangeAt(0))
    ) {
      this.changeGlobalMuteClick()
    }
  }
  changeRange(range) {
    let htmlNode = range.cloneContents()
    let list = Dom.getChildNodesAst(htmlNode, 0)
    if (list[list.length - 1].isTag == true) {
      let newRange = new Range()
      newRange.setStart(this.editor, 0)
      newRange.setEnd(range.endContainer, range.endOffset)
      let index = $(newRange.cloneContents()).find('.isTag').length - 1
      let endNode = $('.isTag')[index]
      let range2 = new Range()
      range2.setStart(range.startContainer, range.startOffset)
      range2.setEnd(
        endNode.parentNode,
        [...endNode.parentNode.childNodes].indexOf(endNode)
      )
      return range2
    } else {
      return range
    }
  }
  iscanSwitchCompose = true
  menuClick(e) {
    let target=e.target
    if(typeof target.className !=="string"||!target.className){
      return
    }
    if (
      target.className.indexOf('mutilTone') == -1 &&target.parentNode&&
      target.parentNode.className.indexOf('mutilTone') == -1
    ) {
      $('.toneActive').removeClass('toneActive')
    }
    if (target.className.indexOf('icon-audio') != -1) {
      this.audition(true)
    }
     //判断点击区域是否在class bottom-nav-goups 内部或者点击的是class bottom-nav-goups 则不去切换合成模式
     let $navgoups = $('.bottom-nav-goups')
    if($navgoups.length>0&&$navgoups.has(target).length>0){
      this.iscanSwitchCompose = false
      setTimeout(() => {
        this.iscanSwitchCompose = true
      }, 300);
    }
   /*  if (
      e.target.className.indexOf('bottom-nav-item') != -1 ||
      e.target.className.indexOf('bottom-nav-img') != -1 ||
      e.target.className.indexOf('bottom-img-wrapper') != -1 ||
      e.target.className.indexOf('icon-pack-more') != -1
    ) {
      // $(".stressActive").removeClass("stressActive")
      // this.removeStressActive()
      if (this.playStatus&&this.activeSheetType !== 'symbolMute') {
        toast('请点击内容区域，指定效果位置进行设置', 'top')
        this.__resetArticleStatus()
        return
      }
      // if (e.target.getAttribute('data-disabled')) {
      //   toast('当前发音人不支持该功能', 'top')
      //   return
      // }
      // this.changeItem(e)
    } */
    let className=e.target.className
    if (className.indexOf('icon-pack-done') != -1||className.indexOf('icon-done') != -1||className.indexOf('icon-pack-keyboard') != -1) {
      
        if(this.showBottomNavs){
          this.onEditorBlur(e,true)
        }
    }
    if (
      [
        'icon-pack-keyboard',
        'pack-wrapper',
        'icon-pack-keyboard icon-pack-keyboard-coll'
      ].includes(e.target.className)
    ) {
      // 当前菜单详细内容显示时显示键盘编辑，当为键盘时关闭菜单
      if (this.showMenuContent) {
        this.focus()
        this.scrollEvt(e)
        this.bottomNavItems = this.bottomNavItems.map(item => {
          item.active = false
          return item
        })
        e.preventDefault()
      } else {
        // this.onHandleDoneClick(e)
      }
    }
  }
  // 试听文本高亮
  highlightWord(
    startIndexs: [number, number, number],
    endIndexs: [number, number, number],
    type = 0
  ) {
    // remove class highlight
    $('#editor')
      .find('span')
      .removeClass('w-highlight')
      // filter target element
      .filter(filterHighLight)
      .addClass('w-highlight')
    // 滚动

    this.$nextTick(() => {
      let stayTop = Math.floor($('#editor').height() / 3)
      let firstHighlightDom = $('.w-highlight').eq(0)[0]
      if (!firstHighlightDom) return
      let domTop = firstHighlightDom.offsetTop
      if ($('.w-highlight').eq(0) && domTop - stayTop <= 0) {
        $('#editor').scrollTop(0)
        return
      }
      if ($('.w-highlight').eq(0) && Math.abs(domTop - stayTop) > 0) {
        $('#editor').scrollTop(Math.abs(domTop - stayTop))
      }
    })

    // 通过pIndex，sIndex匹配高亮字符
    function filterHighLight() {
      let el = $(this)
      if (!el.data('idx')) return false
      let [spIndex, ssIndex, swIndex] = startIndexs
      let [epIndex, esIndex, ewIndex] = endIndexs
      let [pIndex, sIndex, wIndex] = el.data('idx').split('-')
      if (pIndex >= spIndex && pIndex <= epIndex) {
        if (sIndex >= ssIndex && sIndex <= esIndex) {
          if(type==1){
            return true
          }
          if (wIndex >= swIndex && wIndex <= ewIndex) {
            return true
          }
        }
      }
    }
  }
  // 清除高亮
  clearHighlightWord(){
    $('.w-highlight').removeClass('w-highlight')
  }
  // 点击高亮特效节点
  highlightEffectNode(effectNode, pauseValue = null) {
    this.clearHighlightEffectNode()
    if (pauseValue) {
      // 兼容旧实现pause
      $(effectNode).addClass('pauseHover')
      $(effectNode).find('.icon-pause').attr('src', this.hoverPauseObjs[pauseValue])
    } else {
      $(effectNode).addClass('backColor')
    }
  }
  // 清除高亮的特效节点
  clearHighlightEffectNode() {
    $('.backColor').removeClass('backColor')
    if($('.sensitive').length>0){
      $('.sensitive').replaceWith(function() {
        return $(this).contents();
      });
      this.wordAndReplaceList=[]
    }
    // 兼容旧实现pause
    let $dom = $('.pauseHover').find('.icon-pause')
    if ($dom.length > 0) {
      let key = $('.pauseHover').attr('data-value')
      $('.pauseHover').find('.icon-pause').attr('src', ImageMap[key])
      $('.pauseHover').removeClass('pauseHover')
    }
  }

  // 页面初始化
  initPage(loged: boolean = false) {
    let vm = this
    vm._checkToken()
      .then(() => {
        this.getPersonal()
        this.getUserHistorySet()
        vm.state.isLogined = true
        
        let list = [
          vm._getUserVipInfo(),
          vm.getMyAlbumList(),
          vm.getAllSpeakersData(), //新版
        ]
        if (vm.state.articleId) {
          this.placeholderText = "正在加载中......"
          if (!loged) {
            list.push(vm._getArticleDetail())
          }
        } else if (vm.editorHtml) {
          let html = JSON.parse(localStorage.getItem('editorHtml'))
          vm.editer.innerHTML = html
          vm.showPlaceholder = false
          this.debounce(this.onlySaveArticleToServer)
          // localStorage.removeItem('editorHtml');
        } else if (vm.articleContent) {
          let obj = localStorage.getItem('articleContent')
          if(obj){
            obj = obj.replace(/\n/g, 'breakword')
            vm.editer.innerHTML =
              '<div>' + obj.replace(/breakword/g, '</div><div>') + '</div>'
            vm.showPlaceholder = false
            this.$nextTick(()=>{
              this.addGlobalMute()
            })
            this.debounce(this.onlySaveArticleToServer)
          }
        
        } else if (vm.copyText) {
          let obj = LZString.decompressFromBase64(vm.copyText)
          if(obj){
            obj = obj.replace(/\n/g, 'breakword')
            vm.editer.innerHTML =
              '<div>' + obj.replace(/breakword/g, '</div><div>') + '</div>'
            vm.showPlaceholder = false
            this.debounce(this.onlySaveArticleToServer)
          }
        } else {
          vm.showPlaceholder = true
        }
        Promise.all(list)
          .then((resp: any) => {
            let articleDataRes = resp[3];
            if (articleDataRes && !loged) {
              let articleData = articleDataRes.data
              if (JSON.parse(articleData.otherJson).compress_type == 1) {
                articleData.ttsJson = pako.inflate(
                  base64ToUint8Array(articleData.ttsJson),
                  {
                    to: 'string'
                  }
                )
                resp[3].data.ttsJson = articleData.ttsJson
              }
              vm.__renderArticleDetail(articleDataRes)
              vm.getLastSaveTimeStatusChange(articleData.updatedAt)
            }
	          // 检查更新智能分句是否支持状态
            this.checkUpdateAutoMute()
            
          })
          .finally(() => {
            this.placeholderText = this.isPicIn?`请输入配音内容...(不少于${TXT_MIN_LENFTH}字,最多${TXT_MAX_LENGTH}字)`:`请输入文本内容...(最多${TXT_MAX_LENGTH}字)`;
          })
      })
      .catch((e) => {
        console.log(e);
        // vm.state.isLogined = false
        vm.loginCallback()
      })
  }
  pointEvent(item: any, type: string, e: any) {
    if (!this.computedNavItemAuth(item)) {
      toast('当前发音人不支持该功能', 'top')
      return
    }
    if(type){
      let isValidMessge = checkRangeValid(item.type,this.lastSelection)||this.checkSpeakerInvalid(item.type,this.lastSelection)
      if(isValidMessge){
        return toast(isValidMessge, 'top')
      }
    }
    // debugger
    this.isEffectUpdate = false
    this.activeSheetType = type || item.type
    this.changeItem(this.activeSheetType)
    customCollectEvent('editor_tools_click', {
      type: item.name
    })
  }
  __resetArticleStatus() {
    MAudio.stopAll()
    this.state.isComposed = false
  }

  _getSpeakerEmotionList() {
    return new Promise((resolve,reject)=>{
        let vm = this
        return this.$http('getSpeakerEmotionList', {}).then((res) => {
          if (res.code == 200) {
            vm.state.emotionListMap = (res.data || []).reduce(
              (target: any, item: any) => {
                target[item.emotion] = item.imageUrl
                return target
              },
              {}
            )
            resolve(res);
          } else {
            // this
            reject(res);
          }
        }).catch(err=>{
            console.log(err);
            reject(err)
        })
    })
  }

  //
  async audioEndEvt() {
    this.playStatus = false
    this.state.auditionIndex++

    // 播放结束
    if (this.state.auditionIndex > this.state.auditionArr.length - 1) {
      if (this.state.auditionLimit) {
        // 试听限制弹框提示
        overListenMessage(this)
      }
      return
    }
    this.playAudio()

    // 是否还有下一段试听
    setTimeout(() => {
      if (
        this.state.hasNextAudition &&
        this.state.auditionIndex >= this.state.auditionArr.length - 2
      ) {
        this.__getNextAuditionUrl()
      }
    })
  }

  // 登录
  loginCallback() {
    // 登录
  }

  _checkToken() {
    return new Promise((resolve, reject) => {
      if (!this.state.ww_token) {
        reject()
        return
      }
      resolve(true)
    })
  }
  _fitAddr(baseHeight: number = 0) {
    if (
      !this.selectionAddr.anchorNode ||
      !this.selectionAddr.anchorNode.parentNode
    ) {
      return
    }
    if ((Object.keys(this.selectionAddr).length = 0)) {
      this.setFitFocus(this.editer, 0, 0)
    } else if (this.selectionAddr?.anchorNode.className == 'editor') {
      var eleHeight
      if (this.editer.childNodes.length > 0) {
        eleHeight =
          this.editer.childNodes[this.editer.childNodes.length - 1].offsetTop
      } else {
        eleHeight = 0
      }
      this.setFitFocus(this.editer, this.selectionAddr.anchorOffset, eleHeight)
    } else if (
      (this.selectionAddr?.anchorNode.nodeName == '#text' ||
        this.selectionAddr?.anchorNode.nodeName == 'SPAN') &&
      this.selectionAddr?.anchorNode.parentNode.className == 'editor'
    ) {
      let textHeight =
        Math.floor(this.selectionAddr.anchorOffset / 22) * 32 + 70 + baseHeight
      var eleHeight: any =
        textHeight - (this.$refs.KeyswrapperRef as HTMLElement).clientHeight
      eleHeight = eleHeight > 0 ? eleHeight : 0
      this.setFitFocus(
        this.selectionAddr.anchorNode,
        this.selectionAddr.anchorOffset,
        eleHeight
      )
    } else if (
      this.selectionAddr.anchorNode.nodeName == '#text' &&
      this.selectionAddr?.anchorNode.parentNode.className != 'editor'
    ) {
      let node = this.selectionAddr.anchorNode
      let idx = [].indexOf.call(node.parentNode.childNodes, node)
      let textLen = 0
      node.parentNode.childNodes.forEach((ele, index) => {
        if (index < idx) {
          let text = ele.innerText || ele.textContent
          textLen += text.length
        }
      })
      let textHeight =
        Math.floor((textLen + this.selectionAddr.anchorOffset) / 22) * 32 +
        70 +
        baseHeight
      var eleHeight: any =
        textHeight +
        this.selectionAddr.anchorNode.parentNode.offsetTop -
        (this.$refs.KeyswrapperRef as HTMLElement).clientHeight
      eleHeight = eleHeight > 0 ? eleHeight + 150 : 0
      this.setFitFocus(
        this.selectionAddr.anchorNode,
        this.selectionAddr.anchorOffset,
        eleHeight
      )
    } else if (
      this.selectionAddr.anchorNode.nodeName == 'SPAN' &&
      this.selectionAddr.anchorNode.parentNode.className != 'editor'
    ) {
      var eleHeight: any =
        this.selectionAddr.anchorNode.offsetTop -
        (this.$refs.KeyswrapperRef as HTMLElement).clientHeight +
        30 +
        baseHeight
      eleHeight = eleHeight > 0 ? eleHeight + 150 : 0
      this.setFitFocus(
        this.selectionAddr.anchorNode,
        this.selectionAddr.anchorOffset,
        eleHeight
      )
    } else if (
      this.selectionAddr.anchorNode.nodeName == 'DIV' &&
      this.selectionAddr.anchorNode.parentNode.className == 'editor'
    ) {
      var childHeight = 0
      if (this.selectionAddr.anchorNode.childNodes.length > 0) {
        childHeight =
          this.selectionAddr.anchorNode.childNodes[
            this.selectionAddr.anchorNode.childNodes.length - 1
          ].offsetTop || 0
      }

      var eleHeight: any =
        this.selectionAddr.anchorNode.offsetTop +
        childHeight -
        (this.$refs.KeyswrapperRef as HTMLElement).clientHeight +
        30 +
        baseHeight
      eleHeight = eleHeight > 0 ? eleHeight : 0
      this.setFitFocus(
        this.selectionAddr.anchorNode,
        this.selectionAddr.anchorOffset,
        eleHeight
      )
    }
  }

  setFitFocus(el, len, height = 0) {
    var sel
    sel = window.getSelection()
    this.sectionType = 'Caret'
    sel.collapse(el, len)
    this.selectionchange()
    if (height) {
      this.editer.scrollTop = height
    }
  }
  onKeyDown(event: KeyboardEvent) {
    let selection = window.getSelection()
    const e: any = normalizeInputEvent(event)
    if (e.inputType == 'deleteContentBackward') {
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0)
        // 删除特效时，不是整体删除，只删除一个字同时效果也取消掉
        this.removeEffectOnDeleteKey(range, event)

        // 解决光标定位问题，删除时，段落尾部插入空span，防止出现段落尾部失去焦点
        // this.removeLastCharacterOnDeleteKey(range)
      }
     
    } else {
      if (this.articleLength >= TXT_MAX_LENGTH) {
        toast(`请输入${TXT_MAX_LENGTH}字以内的文本`, 'top')
      }
    }
    if (selection.rangeCount > 0) {
      this.deleteLabel()
    }
    // let node =
    // this.editor.innerText = this.editor.innerText.replaceAll('<', '《')
  }
  
  //输入时触发的删除特效事件
  deleteLabel(){
    let selection2 = window.getSelection()
    this.selectionAddr.anchorNode = selection2.anchorNode
    this.selectionAddr.anchorOffset = selection2.anchorOffset
    this.selectionAddr.type = selection2.type
    this.cursorVisible = false
    this.state.isComposed = false

    let node = selection2.getRangeAt(0).startContainer
    if (node) {
      let dom = this.getprevnextNode(node, '#text', 'prev')
      if (
        dom &&
        dom.nextSibling &&
        dom.nextSibling.nodeName === 'SPAN' &&
        dom.nextSibling.getAttribute('data-stresshover')
      ) {
        this.stresshover = dom.nextSibling.getAttribute('data-stresshover')
        this.removeStress()
      }
    }
    let range = new Range()
    let backRange = selection2.getRangeAt(0)
    range.setStart(this.editor, 0)
    range.setEnd(node, backRange.startOffset)
    this.removeRangesingleEffect('liandu', range, 'continuousid')
    this.removeRangesingleEffect('aliasChange', range, 'aliasgroupkey')
    this.removeRangesingleEffect('phonetics', range, 'phoneticsid')
  }
  

  // 获取登录用户的vip状态
  _getUserVipInfo() {
    let vm = this
    return new Promise((resolve, reject) => {
      this.$http('getVipInfo')
        .then(res => {
          if (res.code == 200) {
            vm.state.vipInfo = res.data
            // res.data.wordNum = 0;//测试字数不足
            // console.log('vipInfo获取到的用户状态',res.data);
            this.$store.state.vipInfo = res.data
            if(!localStorage.getItem('wwid')){
                localStorage.setItem('wwid',res.data.wwid)
            }
            resolve(res.data)
          } else if (res.code == 150004) {
            const { message } = res //TODO
            Toast(message)
            setTimeout(() => vm.gotoLogin(), 500)
            reject()
          } else {
            reject()
          }
        })
        .catch(err => {
          let errTxt
          const response = err.response
          if (response && response.data) {
            const { message } = response.data
            if (message == "Required String parameter 'wwid' is not present") {
              if (!vm.state.hasBeenRemind) {
                errTxt = this.loginInvalIText
                !this.isAPP && Toast(errTxt)
                vm.state.hasBeenRemind = true
                vm.state.isLogined = false
                setTimeout(() => vm.gotoLogin(), 500)
              }
            } else if (
              errTxt &&
              errTxt != "Required String parameter 'wwid' is not present"
            ) {
              Toast(errTxt || '服务出错，code1200')
            }
          }
        })
    })
  }
  personalSetting: any = []
  // 获取用户个性化设置
  getPersonal() {
    let vm = this
    return new Promise((resolve, reject) => {
      let articleId = this.state.articleId
      this.$http('getPersonalSetting',{modelId:1})
        .then(res => {
          if (res.code == 200) {
            vm.personalSetting = res.data
            if (!articleId) {
              let articlePunctuations = vm.personalSetting.filter(item => {
                return item.featureId == 15
              })
              let mergeSymbolSetting = vm.personalSetting.filter(item => {
                return item.featureId == 24
              })
              let MuteSetting = vm.personalSetting.filter(item => {
                return item.featureId == '12'
              })

              if (articlePunctuations[0]?.setting) {
                vm.articlePunctuations = JSON.parse(
                  articlePunctuations[0].setting
                )
              }
              if (mergeSymbolSetting[0]?.setting=='1') {
                vm.symbolMuteChecked = true
              }else{
                vm.symbolMuteChecked = false
              }
              if(MuteSetting[0]?.setting){
                let setting = JSON.parse(MuteSetting[0]?.setting)
                this.globalMuteTime = setting.globalMuteTime||200
                this.showGlobalMute = setting.showGlobalMute||false

              }
            }
            resolve(res.data)
          } else {
            reject()
          }
        })
        .catch(() => {
          reject()
        })
    })
  }
  // 获取历史设置信息-背景音/多发音人/历史发音人/音量等
  getUserHistorySet(){
    let vm = this;
    return new Promise((resolve,reject)=>{
        this.$http('getUserHistory').then(res=>{
          let volume = res?.data?.volume??70;
        //   localStorage.setItem('volume',volume);
          vm.lastVolumeValue = volume;
          resolve(volume)
        }).catch(err=>{
          console.log('获取用户历史设置失败',err)
          reject()
        })
    })
  }

  // 获取文章价格详情
  _getArticlePrice() {
    let vm = this
    return new Promise((resolve,reject)=>{
      this.$http('getArticlePrice', { articleId: this.state.articleId })
        .then(res => {
          // vm.state.priceModal = true
          // vm.state.priceData = res.data
          vm.cursorVisible = false
          vm.showComposing = false
          console.log('文章价格详情完成')
          resolve(res)
        })
        .catch((err) => {
          toast('获取订单失败')
          this.showComposing = false
          reject();
      })
    })

  }

  // 获取发音人分类
  _getSpeakerTypeList() {
    this.$http('getSpeakerTypeList', {}).then(res => {
      if (res.code == 200) {
        this.state.speakerTypeList = res.data
      } else {
        // this
      }
    })
  }

  // editor input
  // onEditorInput(e: InputEvent) {
  //   let target: HTMLElement = e.target as any;
  //   this.content = target.innerHTML;
  //   console.log(target.innerHTML);
  // }
  // selfSelection
  scrollToView() {
    this.setFitFocus(
      this.selectionAddr.anchorNode,
      this.selectionAddr.anchorOffset,
      0
    )
    let selection: any = window.getSelection()
    let cloneRange = null
    try {
    selection?.getRangeAt(0)?.cloneRange() as Range
    } catch (error) {
      console.log(error);
    }
    if (cloneRange) {
      const span = document.createElement('span')
      span.appendChild(document.createTextNode('\u200b'))
      cloneRange.insertNode(span)
      span.scrollIntoView({ behavior: 'smooth', block: 'center' })
      const spanParent = span.parentNode
      spanParent.removeChild(span)
    }
  }
  touchmoveEvt(e: any) {
    let target: HTMLElement = e.target as any
    if (
      target.className.indexOf('editor-wrapper') != -1 ||
      document.querySelector('.editor-wrapper').contains(target)
    ) {
      return
    } else {
      e.preventDefault()
    }
  }
  touchmoveindex = 0;
  
  onEditorFocus(e) {
    this.isOpen = false
    this.isEditorFocus = true
    this.showMenuContent = false
    this.removeStressActive()
    // 合成之后end高亮没有去掉，focus的时候去掉高亮
    this.clearHighlightWord()
    this.removeLastRange() // 注意，此处pc和手机端有差异 pc端滑选后才聚焦，手机端要么聚焦后(出来键盘)才会滑选，要么直接滑选不触发聚焦
    // 获取焦点的时候
    let u = navigator.userAgent
    if (u.indexOf('iPhone') > -1) {
      inobounce.enable()
    }
    if (this.auditionAction) {
      return
    }

    this.cursorVisible = false
    //滚动到光标位置
    if (judgeDeviceType.isIOS) {
      
      // this.resetRenderEditor(false)
      // this.showbottomfield = false
      this.showBottomNavs = true
      
    /*   setTimeout(() => {
        this.showbottomfield = true
      }, 450) */
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 100)
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 200)
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 300)
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 400)
      setTimeout(() => {
        this._fitAddr()
      }, 700)
    
      // this.caretBlur(null,true)
    } else {
      // setTimeout(() => this.scrollToView(), 600)
      setTimeout(() => {
        let anchorNode = this.selectionAddr.anchorNode
        if (!isOverlapped(anchorNode) && $(':focus').length > 0) {
          this._fitAddr()
        }
      }, 600)
    }
    //等键盘出来再显示
    setTimeout(() => {
    this.showBottomNavs = true
    //设置工具栏的高度
    // $('.bottom-nav-goups').css('bottom',`${this.editorKeyboardHeight}px`)
    }, 100)
  }
  //主要修复Ios光标飘的问题
  onEditorMousedown(e) {
    this.editor.contentEditable = 'true'
    let dom = Dom.getTagNode(e.target)
    this.cursorVisible = false
    let { type } = dom.dataset
      if (!type) {
        // let selectType=window.getSelection().type
          let eleObj: any = isSetCaret(e)
          if (eleObj.node) {
            if($(":focus").length == 0) {
              this.editor.focus()
            }
            this.setFitFocus(eleObj.node, eleObj.offset, 0)
          } else if (eleObj == -1 && e.target.nodeName == 'DIV') {
            let effectMute = $(e.target).find('.effect-global-mute')[0]
            if (effectMute) {
              this.setFakeCaretBefore(effectMute, false)
            }
          }
      }
    // },100)
   
  }
  //编辑器失去焦点
  onEditorBlur(e?: FocusEvent,flag=false) {
    let self=this
    if(flag){
      setTimeout(()=>{
        self.onHandleDoneClick(null)
      },200)
    }else if(this.iscanSwitchCompose){
      setTimeout(()=>{
        if(!self.activeSheetType&&!self.showAudio){
          self.onHandleDoneClick(null)
        }
      },200)
    }
    this.$store.state.keyboardTrigger = '' // 在编辑器失焦后，清空键盘触发源
    this.isEditorFocus = false
    this.resetRenderEditor()
    inobounce.disable()

    // let wrapper: any = this.$refs.editorWrapperRef
    // wrapper.style.height = `calc(100% - ${3.2}rem)`
    this.editor.contentEditable = 'false'
    setTimeout(() => {
      let content: HTMLElement = document.querySelector('.real-container')
      content.style.height = '100vh'
      // this._fitAddr()
    }, 100)
    //  document.removeEventListener("touchmove", this.touchmoveEvt)
    // this.caretBlur()
  }

  // 插入模拟光标
  __mockCustomCaret() {
    if (
      this.selectionAddr.anchorNode.nodeName == '#text' &&
      this.selectionAddr.anchorNode.textContent.length > 1
    ) {
      let caret = Dom.make('span', ['mycaret'])
      this._insertHtmlStringAtCaret(caret.outerHTML)
      this.selectionAddr.anchorNode = $('.mycaret')[0]
      this.selectionAddr.anchorOffset = 0
    }
  }

  
  getprevnextNode(node: any, tag: string, type: string) {
    if (node.nodeName == tag) {
      return node
    }
    if (node.nodeName == 'DIV' || node.nodeName == 'BR') {
      return false
    }
    if (node.contenteditable == 'false') {
      return false
    }
    if (type == 'prev') {
      if (
        (node.className && node.className.indexOf('isPlaceHolder') != -1) ||
        $(node).parents('.isPlaceHolder')[0]
      ) {
        let prevNode = node.previousSibling
        if (!node.previousSibling) {
          prevNode = this.getpreparentSibling(node)
        }
        return this.getprevnextNode(prevNode, tag, type)
      } else if (!node.textContent.trim()) {
        let prevNode = node.previousSibling
        if (!node.previousSibling) {
          prevNode = this.getpreparentSibling(node)
        }
        return this.getprevnextNode(prevNode, tag, type)
      } else if (node.textContent.trim()) {
        return this.getprevnextNode(
          node.childNodes[node.childNodes.length - 1],
          tag,
          type
        )
      } else if (!node.textContent.trim() && !node.previousSibling) {
        return this.getprevnextNode(node.parentNode.previousSibling, tag, type)
      } else {
        return false
      }
    }
    if (type === 'next') {
      if (
        (node.className && node.className.indexOf('isPlaceHolder') != -1) ||
        $(node).parents('.isPlaceHolder')[0]
      ) {
        let nextNode = node.nextSibling
        if (!node.nextSibling) {
          nextNode = this.getpreparentSibling(node)
        }
        return this.getprevnextNode(nextNode, tag, type)
      } else if (!node.textContent.trim()) {
        let nextNode = node.nextSibling
        if (!node.nextSibling) {
          nextNode = this.getpreparentSibling(node)
        }
        return this.getprevnextNode(nextNode, tag, type)
      } else if (node.textContent.trim()) {
        return this.getprevnextNode(
          node.childNodes[node.childNodes.length - 1],
          tag,
          type
        )
      } else if (!node.textContent.trim() && !node.nextSibling) {
        return this.getprevnextNode(node.parentNode.nextSibling, tag, type)
      } else {
        return false
      }
    }
  }

  getpreparentSibling(node: any, type = 'prev') {
    if (type == 'prev') {
      if (node.previousSibling && node.previousSibling.textContent) {
        return node.previousSibling
      } else {
        return this.getpreparentSibling(node.parentNode)
      }
    } else {
      if (node.nextSibling && node.nextSibling.textContent) {
        return node.nextSibling
      } else {
        return this.getpreparentSibling(node.parentNode)
      }
    }
  }
  
  onEditorClick(e: any) {
    if( this.showBottomAixiaomo){
      this.$bus.$emit('editorClick',e)
      return
    }
    this.showPlaceholder = false
    if (!this.showBottomNavs && !judgeDeviceType.isIOS) {
      setTimeout(() => this.scrollToView(), 400)
    }
    setTimeout(() => {
      this.mycaretRemove('oldcaret')
      this.mycaretRemove('toneActive')
    }, 50)

    let dom = Dom.getTagNode(e.target)
    //获取当前选取 -- TODO
    // console.log('---dom',dom)
    let { type, value, stresshover, continuousid } = dom.dataset
    this.showMenuContent = false
    this.showbottomfield = true
    this.activeSheetType=""
    //隐藏所有面板
    /*    Object.values(typeShowObj).forEach((value) => {
      this[value] = false
    }) */

    this.clearHighlightEffectNode()
    clearHighlightSelection()
    this.showAudio = false
    this.tagElement = null
    setTimeout(() => {
      this.showBottomNavs = true
    }, 420)
    this.bottomNavItems = this.bottomNavItems.map(item => {
      item.active = false
      return item
    })
    if (type == 'globalMute' && $(dom).hasClass('opacityHide')) {
      let prev = $(dom).prev()
      if (prev.hasClass('ignore') && !prev.text().trim()) {
        this.setFakeCaretBefore(prev)
        this.focus()
      } else {
        this.setFakeCaretBefore(dom)
        this.focus()
      }
      return
    }
    const typeList = [
      'stress',
      'mute',
      'multi-tone',
      'liandu',
      'localSpeed',
      'globalMute',
      'multiSpeaker',
      'aliasChange',
      'phonetics'
    ]
    // this.showMenuContent = true
    if (typeList.indexOf(type) != -1) {
      this.caretBlur(dom)
      this.isEffectUpdate = true
      this.onEffectNodeClick(dom)
      setTimeout(() => {
        this.cursorVisible = false
      }, 610)
    } else if (type == 'pause') {
      this.isEffectUpdate = true
      this.updateLastEl(null)
      // 当前操作tag dom
      this.caretBlur(dom)
      // 高亮当前特效节点
      this.highlightEffectNode(dom, value)
      this.tagElement = dom
      this.pauseObjs = this.pauseObjs.map((item: any) => {
        item.change = true
        item.checked = value == item.value ? true : false
        return item
      })
      this.activeSheetType = 'pause'
      this.showMenuContent = true
      if (dom.nextSibling) {
        this.selectionAddr.anchorNode = dom.nextSibling
        this.selectionAddr.anchorOffset = 0
      }
      this.blur()
      setTimeout(() => {
        this.cursorVisible = false
      }, 610)
    } else if (type == 'mute') {
      // 当前操作tag dom
      this.tagElement = dom
      let flag
      this.muteObjs = this.muteObjs.map((item: any) => {
        item.change = true
        item.checked = value == item.value ? true : false
        if (item.checked) {
          flag = true
        }
        return item
      })
      if (!flag) {
        this.selfMute = value
      }
      this.activeSheetType = 'mute'
      this.showMenuContent = true
      if (dom.nextSibling) {
        this.selectionAddr.anchorNode = dom.nextSibling
        this.selectionAddr.anchorOffset = 0
      }
      this.editor.blur()
      setTimeout(() => {
        this.cursorVisible = false
      }, 610)
    } else if (type == 'stress-read') {
      // 当前操作tag dom
      this.stresshover = stresshover
      // if (e.target.className == 'stress-title-close') {
      //   this.removeStress();
      // } else {
      //
      // }
      this.stressObj = this.stressObj.map((item: any) => {
        item.checked = item.name == '强' ? true : false
        return item
      })
      this.stress = '强'
      this.activeSheetType = 'stress'
      this.showMenuContent = true
      if (dom.nextSibling) {
        this.selectionAddr.anchorNode = dom.nextSibling
        this.selectionAddr.anchorOffset = 0
      }
      this.editor.blur()
      setTimeout(() => {
        this.cursorVisible = false
      }, 610)
    } else if (type == 'stress-close') {
      this.stresshover = stresshover
      this.removeStress()
    } else if (type == 'tone' || type == 'stress-tone') {
      // 当前操作tag dom
      this.tagElement = dom
      this.activeSheetType = 'stress'
      this.showMenuContent = true
      this.wordText = this.tagElement.textContent.trim()
      this.__getWordsByText(value)
      if (dom.nextSibling) {
        this.selectionAddr.anchorNode = dom.nextSibling
        this.selectionAddr.anchorOffset = 0
      }
      this.editor.blur()
      setTimeout(() => {
        this.cursorVisible = false
      }, 610)
    } else {
     this.focus()
      this.selectedEffectValue = ''
      this.updateLastEl(null)
      this.rangeSelection = {}
      // this.onEditorMousedown(e)
      // this.focus()
    }
    if (type == 'liandu') {
      this.showLiandu = true

      // 当前操作tag dom
      this.selectedEffectValue = '1'
      this.continuousid = continuousid

      this.editor.blur()
      setTimeout(() => {
        this.cursorVisible = false
      }, 610)
    }
    if (type == 'globalMute') {
      this.selectedEffectValue = $(dom).find('.effect-mute').attr('data-value')
    }else if (type == 'phonetics') {
      this.selectedEffectValue = $(dom).attr('data-phoneticstext')
    }else if (type == 'localSpeed') {
      // 当前操作tag dom
      this.tagElement = dom

      this.selectedEffectValue = dom.getAttribute('data-speed')
      this.continuousid = continuousid

      this.editor.blur()
      setTimeout(() => {
        this.cursorVisible = false
      }, 610)
    }
    if (type == "multiSpeaker") {
      // 当前操作tag dom
      this.tagElement = dom
      this.selectedEffectValue = {
        speed: dom.getAttribute("data-speed"),
        pitch: dom.getAttribute("data-pitch"),
        speakerId: dom.getAttribute("data-speakerId"),
        emotionWeight: dom.getAttribute("data-emotionWeight"),
      }
      this.editor.blur()
      setTimeout(() => {
        this.cursorVisible = false
      }, 610)
    }
    if(type == 'multi-tone'){
      this.wordText = dom.textContent.trim()
      const handler = getEffectHandler(type)
      if (
        handler &&
        handler.beforeSheetOpen &&
        !handler.beforeSheetOpen(this, this.lastSelection,this.wordText)
      ) {
        // beforeSheetOpen返回false，阻止面板打开
        return
      }
    }
    if (type == "aliasChange") {
      // 当前操作tag dom
      this.tagElement = dom
      this.selectedEffectValue = {
        aliasContent: dom.getAttribute("data-aliasContent"),
      }
      this.editor.blur()
      setTimeout(() => {
        this.cursorVisible = false
      }, 610)
    }

    /*  if (type) {
      this.bottomNavItems = this.bottomNavItems.map((item: any) => {
        item.active = false
        if (item.type == type) {
          item.active = true
        }
        return item
      })
    } */

     e.stopPropagation()
  }
  //光标点到文章末尾自动定位到全局静音前面
  changeGlobalMuteClick() {
    let selection = window.getSelection()
    if (selection.type == 'Caret') {
      let node = selection.anchorNode
      let offset = selection.anchorOffset
      let parentDIV = node.nodeName == 'DIV' ? node : $(node).parents('DIV')[0]
      if ($(parentDIV).find('.effect-global-mute').length > 0) {
        let range = new Range()
        range.setStart(parentDIV, 0)
        range.setEnd(node, offset)
        let $html = $(range.cloneContents())
        if ($html.find('.effect-global-mute').length > 0) {
          let node3 = $(parentDIV).find('.effect-global-mute')[0]
          if (node3) {
            let prev = $(node3).prev()
            if (prev.hasClass('ignore') && !prev.hasClass('isTag')) {
              if (!prev.text().trim()) {
                this.setFakeCaretBefore(prev[0], false)
              } else {
                prev.removeClass('ignore')
              }
            } else {
              this.setFakeCaretBefore(node3, false)
            }
          }
        }
      } else if (
        $(node).hasClass('ignore') &&
        $(node).text().trim().length == 0
      ) {
        this.setFakeCaretBefore(node, false)
      } else if (
        $(node.parentNode).hasClass('ignore') &&
        $(node.parentNode.parentNode).text().trim().length == 0
      ) {
        this.setFitFocus(node.parentNode.parentNode, 0)
      }
    }
  }

  // 点击编辑区域空白、点击底部键盘 聚焦编辑器
  focus() {
    this.$store.state.keyboardTrigger = 'editor' // 键盘激活前，设置键盘触发源
    this.editor.contentEditable = 'true'
    this.editor.focus()
  }

  // 点击特效节点、工具 失焦编辑器
  blur(showCursor = true) {
    this.editor.blur()
    setTimeout(() => {
      if(this.editor.textContent.length>0&&!this.showBottomAixiaomo){
        this.cursorVisible = showCursor
      }else{
        this.cursorVisible = false
      }
    }, 510)
  }

  // 文章内点击特效节点
  onEffectNodeClick(effectNode) {
    // 会闪现一下 体验不太好 to opt
    // 键盘在的时候，点击特效节点
    if (this.isEditorFocus) {
      this.blur()
    }
    // 高亮当前特效节点
    this.highlightEffectNode(effectNode)
    // 更新当前选中的特效节点
    this.updateLastEl(effectNode)

    const type = effectNode.getAttribute('data-type')
    // this[typeShowObj[type]] = true
    this.activeSheetType = type
    // to refact
    // 显示菜单
    this.showMenuContent = true
    // 光标定位
    this.setFakeCaretAfter(effectNode)
  }

  // 更新特效
  onEffectChange(type, value) {
    // 根据value 操作dom
    const effectHandler = getEffectHandler(type)
    if (!value) {
      // 删除特效
      if (type == 'liandu') {
        this.removeContainHtml(this.lastSelection.el, 'continuousid', 'liandu')
      } else if (type == 'localSpeed') {
        this.removeContainHtml(
          this.lastSelection.el,
          'speedhover',
          'localSpeed'
        )
      }  else if (type == "multiSpeaker") {
        this.removeContainHtml(
          this.lastSelection.el,
          "hover",
          "multiSpeaker"
        )
      } else if (this.isEffectChangeType(type)) {
        this.removeEffectHtml(this.lastSelection.el)
      }
      this.editStatusShow = 1
      this.debounce(this.onlySaveArticleToServer)
    } else {
      if (this.isEffectChangeType(type)) {
        // 修改特效
        this.lastSelection.el.setAttribute('data-value', value)
        effectHandler.modifyEffect(this, this.lastSelection, value)
        // 重新定位假光标
        this.setFakeCaretAfter(this.lastSelection.el)
      } else {
        let message = checkRangeValid(type, this.lastSelection)||this.checkSpeakerInvalid(type,this.lastSelection)
        if (message) {
          toast(message)
          return
        }
        // 添加特效
        effectHandler.addEffect(this, this.lastSelection, value)
        this.editStatusShow = 1
        this.debounce(this.onlySaveArticleToServer)
      }
    }

    // this.rangeSelection = {}
    this.__resetArticleStatus()
    // this.__mockCustomCaret()
    // customCollectEvent('editor_tools_use', {
    //   'type' : '重读'
    // })
  }
  //
  updateGlobeMute(value, muteType, isDefault = false) {
    if (muteType == 'isAll') {
      $('.effect-global-mute.backColor.isSelf').removeClass('isSelf')
      $('.effect-global-mute')
        .not('.isSelf')
        .find('.effect-mute')
        .attr('data-value', value)
      this.globalMuteTime = value
      this.selectedEffectValue = value
      let setting={
        globalMuteTime:this.globalMuteTime,
        showGlobalMute:this.showGlobalMute
      }
      this.updatePSetting({
        modelId:'1',
        featureId: '12',
        setting:JSON.stringify(setting)
      })
      //  $(".backColor").removeClass("backColor")
    } else if (muteType == 'isSelf') {
      $('.backColor.effect-global-mute .effect-mute').attr('data-value', value)
      $('.backColor.effect-global-mute').addClass('isSelf')
      if (isDefault) {
        $('.effect-global-mute.backColor.isSelf').removeClass('isSelf')
      }
      this.selectedEffectValue = value
    }
    this.debounce(this.onlySaveArticleToServer)
  }
  // 更新包含特效
  updateNode(effectParam, param, flag = '') {
    let effectName = effectParam.effectName
    let nodeList = [`#${effectName}Start_${effectParam.id}`]
    if (flag == 'delete') {
      nodeList.forEach((nodeBy: string) => {
        this.removeContainHtml($(nodeBy)[0], effectParam.idName, effectName)
      })
    } else {
      nodeList.forEach((nodeBy: string) => {
        let nodeout = $(nodeBy)[0]
        let nodeIn =
          $(nodeBy).find(`.${effectParam.innerEffectName}Start`)[0] ||
          $(nodeBy).find(`.${effectParam.innerEffectName}End`)[0]
        Object.keys(param).forEach(key => {
          nodeout.setAttribute(`data-${key}`, param[key])
          nodeout.setAttribute(`data-${key}`, param[key])
          nodeIn && nodeIn.setAttribute(`data-${key}`, param[key])
        })
      })
    }
    this.editStatusShow = 1
    this.state.isComposed = false
    this.debounce(this.onlySaveArticleToServer)
  }
  // 当前选中特效节点是否是要修改的类型
  isEffectChangeType(type) {
    const lastEl = this.lastSelection.el
    return lastEl && $(lastEl).attr('data-type') === type
  }

  // 关闭特效面板，重置状态
  @Watch('showMenuContent')
  onSheetClose() {
    // 隐藏菜单面板时重置选中特效状态
    if (!this.showMenuContent) {
      this.activeSheetType = ''
      this.updateLastEl(null)
    }else{
      this.showbottomfield=true
    }
  }

  /**
   * 这个方法主要是为了解决ios设备键盘弹出时闪动大量灰色背景问题
   * 3.04rem 是header头部的高度加上底部bar的最大高度
   * 解决方式：在键盘弹起来之前改变编辑器的高度，从而使编辑器的位置高于键盘
   * @param isHeight 是否重新设置高度
   */
  resetRenderEditor(isHeight: boolean = false) {
    if (judgeDeviceType.isIOS) {
      console.log('resetRenderEditor',this.currentKeyboardHeight);
      
      if (isHeight) {
        this.editor.style.height = this.isAPP
          ? `calc(100vh - 3.04rem)`
          : `calc(100vh - ${this.currentKeyboardHeight}px - 3.04rem)`
      } else {
        this.editor.style.height = '100%'
      }
    }
  }
  setKeyboardHeight(value) {
    this.$store.state.cachedKeyboardHeight = value
    this.resetRenderEditor(true)
  }
  onFocusin(e) {
    // 如果聚焦的不是编辑器，则将容器高度设置为固定px高度，而不是100vh和100%相对单位
    if (this.isAPP) {
      let content: HTMLElement = document.querySelector('.real-container')
      if ($(e.target).is(this.editor)) {
        content.style.height = '100vh'
      } else {
        content.style.height = WINDOW_HEIGHT + 'px'
      }
    }
  }

  mycaretRemove(className = 'mycaret') {
    if (document.querySelectorAll(`.${className}`).length > 0) {
      document.querySelectorAll(`.${className}`).forEach(node => {
        if (node.innerHTML) {
          node.outerHTML = node.innerHTML
        } else {
          node.remove()
        }
      })
    }
  }

  // 编辑器输入监听
  onEditorInput(e: any) {
    if (this.isInputingChinese) {
      return
    }
    // this.__getValueToState(this.editor)
    this.getArticleLength()
    this.editStatusShow = 1
    this.debounce(this.onlySaveArticleToServer)
    let brNode = $(this.editor).find('BR')
    if (
      brNode.parent().text().length != 0 ||
      brNode.parent().find('.isTag').length > 0
    ) {
      brNode[0].remove()
    }
    // $(this.editor).find("BR").remove()
    if (!this.isInputingChinese) {
      if (e.inputType == 'insertParagraph') {
        this.addGlobalMute('insertParagraph')
      } else {
        this.debounce(this.addGlobalMute, 2000, 'timer2')
      }
    }
    if(this.lastSelection.range){
      this.removeLastRange()
    }
   
  }
  // 正在输入中文
  isInputingChinese: Boolean = false
  onCompositionStart(e: any) {
    this.isInputingChinese = true
  }
  //输入时尾部添加段落静音
  /**
   * 这个方法是输入时尾部添加段落静音
   */
  addGlobalMute(type='') {
    let selection = window.getSelection()
    let range, $Caret
    if (selection) {
      try {
        range = window.getSelection().getRangeAt(0)
        $Caret = $("<span class='oldcaret'><span>")
        range.insertNode($Caret[0])
      } catch (error) {}
    }
    let divList = $(this.editor).find('div')
    //  divList = $(this.editor).find("div")
    for (let i = 0; i < divList.length; i++) {
      let childrenList = $(divList[i]).find('div')
      if (childrenList.length > 0) {
        this.addRangeDiv(divList[i])
      }
    }
    this.addRangeDiv(this.editor)
    let formatDivList = $(this.editor).find('div')
    let paraList = []
    for (let i = 0; i < formatDivList.length; i++) {
      paraList.push(formatDivList[i])
    }
    let curParaAnchorNode
    if (type == 'insertParagraph') {
      let selection = window.getSelection()
      curParaAnchorNode = selection.anchorNode
    }
    paraList.forEach((ele, index) => {
      let nextNode = paraList[index + 1]
      if (
        type == 'insertParagraph' &&
        nextNode &&
        curParaAnchorNode == nextNode &&
        nextNode.textContent.trim() == 0
      ) {
        if (
          $(ele).text().trim().length > 0 &&
          $(ele).find('.effect-global-mute').length == 0 &&
          $(nextNode).find('.effect-global-mute').length == 1
        ) {
          ele.appendChild($(nextNode).find('.effect-global-mute')[0])
        }
        nextNode.appendChild(
          $(`<span class='ignore globalmutespace'>&nbsp;</span>`)[0]
        )
      }
      if (
        $(ele).find('.effect-global-mute').length == 0 &&
        $(ele).text().trim().length > 0
      ) {
        let muteStr = $(
          `<span contenteditable="false" class="effect-global-mute isTag ${
            this.showGlobalMute ? '' : 'opacityHide'
          }" data-type="globalMute"><span>&nbsp;</span><span class="effect-mute  isPlaceHolder" data-type="globalMute" data-value="${
            this.globalMuteTime
          }"><span style="font-size:0;">&nbsp;</span></span>`
        )
        ele.appendChild(muteStr[0])
        let prev = $(ele).find('.effect-global-mute').prev()
        if (
          prev.length > 0 &&
          prev.hasClass('globalmutespace') &&
          prev.text().trim().length == 0
        ) {
          prev.remove()
        }
      } else if (
        $(ele).find('.effect-global-mute').length > 0 &&
        $(ele).text().trim().length == 0
      ) {
        if ($(ele).find('.ignore').length > 0) {
          $(ele).find('.effect-global-mute').remove()
        } else {
          $(ele)
            .find('.effect-global-mute')
            .replaceWith(
              $(`<span class='ignore globalmutespace'>&nbsp;</span>`)
            )
        }
      } else if (
        $(ele).find('div').length > 0 &&
        $(ele).children('.effect-global-mute').length > 0
      ) {
        $(ele).children('.effect-global-mute').remove()
      } else if ($(ele).children('.effect-global-mute').length > 1) {
        $(ele).children('.effect-global-mute').remove()
      } else if ($(ele).find('.effect-global-mute').length >= 1) {
        let list = Dom.getChildNodesAst(ele, 0)
        if (!list[list.length - 1].isGlobalMute) {
          $(ele).find('.effect-global-mute').remove()
        }
      }
    })
    if ($Caret) {
      this.setFitFocus($Caret[0], 0)
      $('.oldcaret').removeClass('oldcaret')
    }

    // $(this.editor).find("BR").remove()
  }
  addRangeDiv(parantDiv) {
    let range1 = new Range()
    let divList = $(parantDiv).find('div')
    range1.setStart(parantDiv, 0)
    if (divList.length > 0) {
      let index = [...parantDiv.childNodes].indexOf(divList[0])
      range1.setEnd(parantDiv, index)
    } else {
      range1.setEnd(parantDiv, parantDiv.childNodes.length)
    }
    let rangeContext = range1.cloneContents()
    let text = $(rangeContext).text()
    if (text.length > 0) {
      let $div = $(`<div></div>`)
      $div[0].appendChild(range1.extractContents())
      if (divList.length > 0) {
        $div.insertBefore($(divList[0]))
      } else {
        $(parantDiv).append($div)
      }
    }
  }
  onCompositionEnd(e: any) {
    this.isInputingChinese = false
    this.onEditorInput(e)
  }
  // 调整编辑器内段落静音显隐
  async onGlobeMuteChange() {
    // 更新后再翻转按钮状态，防止快速连续点击
    this.showGlobalMute = !this.showGlobalMute
    let setting={
      globalMuteTime:this.globalMuteTime,
      showGlobalMute:this.showGlobalMute
    }
    this.updatePSetting({
      modelId:'1',
      featureId: '12',
      setting:JSON.stringify(setting)
    })
    
    if (this.editor.textContent.trim().length > 0) {
      this.__getValueToState()
      await this.getWords()
      this.checkGlobalMute()
      // 重新渲染
      this.renderJsonToDom()
      this.debounce(this.onlySaveArticleToServer)
    }
  }
  // ttsJson 渲染到dom
  renderJsonToDom() {
    let dom = this.jsontoDom(this.state.articleTxt)
    let ele = document.querySelector('#editor')
    ele && (ele.innerHTML = dom)
    this.selectionAddr = {}
  }
  // // ttsJson 渲染到dom
  // renderTryAuditionJsonToDom(sensitive) {
  //   let dom = this.jsontoDom(this.state.articleTxt,sensitive)
  //   let ele = document.querySelector('#editor')
  //   ele && (ele.innerHTML = dom)
  //   this.selectionAddr = {}
  //   this.cursorVisible = false
  // }

  // ttsJson遍历
  jsontoDom(ttsJson: any[] = []) {
    let HtmeData: string = ''
    let sensitiveIndex = 0
    let sensitiveWord=this.wordAndReplaceList[sensitiveIndex]
    let startIndex=null
    let endIndex=null
    if(sensitiveWord){
      startIndex = sensitiveWord.startIndex
      endIndex = sensitiveWord.endIndex
    }else{
      startIndex = null
      endIndex = null
    }
    ttsJson.forEach((pItem: any, pIndex: number) => {
      let pHtml = '<div>'
      pItem.forEach((sItem: any, sIndex: number) => {
        pHtml += `<span data-idx='${pIndex}-${sIndex}-0'>`
        sItem.originWord.forEach((word: any, wIndex: number) => {
          if (!word) {
            return
          }
          if(startIndex&&pIndex==startIndex[0]&&sIndex==startIndex[1]&&wIndex==startIndex[2]){
            let curSensitive=sensitiveIndex==0?'curSensitive':''
            pHtml += `<span class="sensitive ${curSensitive} sensitive${sensitiveWord.words}" data-sensitiveWord="${sensitiveWord.words}">`
          }
          if (
            !word.isPlaceHolder ||
            word.startStressRead ||
            word.endStressRead ||
            word.isGlobalMute
          ) {
            if (word.pinyin && word.isChange) {
              // 自定义拼音
              pHtml += `<span  class="ignore">&nbsp;</span><span class="effect-multi-tone isTag" contenteditable="false" data-type="multi-tone" data-value="${word.pinyin}"><span class="wc" data-idx='${pIndex}-${sIndex}-${wIndex}'>${word.word}</span></span><span  class="ignore">&nbsp;</span>`
            } else if (this.originPinyinVisible && word.originPinyin) {
              // 原始的多音字拼音
              pHtml += `<span  class="ignore">&nbsp;</span><span class="effect-multi-tone isTag" contenteditable="false" data-type="multi-tone" data-origin-pinyin="${word.originPinyin}" ><span class="wc" data-idx='${pIndex}-${sIndex}-${wIndex}'>${word.word}</span></span><span  class="ignore">&nbsp;</span>`
            } else if (word.startStressRead) {
              // 重音开始
              const value =
                word.isStress === 2
                  ? '1' // 重读
                  : word.dragSound === 2
                  ? '2' // 拖音
                  : '3' // 重+拖
              let wordHtml=''
              if(word.word.trim()){
                wordHtml =`<span data-idx='${pIndex}-${sIndex}-${wIndex}' class="wc">${word.word}</span>` 
              }
              pHtml += `<span  class="ignore">&nbsp;</span><span class="effect-stress isTag" contenteditable="false" data-type="stress" data-value="${value}">${wordHtml}`
            } else if (
              (word.isStress || word.dragSound || word.stressAndDragSound) &&
              !word.startStressRead &&
              !word.endStressRead
            ) {
              // 重音文字部分
              const wordText = word.word === ' ' ? NBSP_HTML : word.word
              pHtml += `<span data-idx='${pIndex}-${sIndex}-${wIndex}' class="wc">${wordText}</span>`
            } else if (word.endStressRead) {
              // 重音结束
              let wordHtml=''
              if(word.word.trim()){
                wordHtml =`<span data-idx='${pIndex}-${sIndex}-${wIndex}' class="wc">${word.word}</span>` 
              }
              pHtml += `${wordHtml}</span><span  class="ignore">&nbsp;</span>`
            } else if (word.isGlobalMute) {
              // 段尾静音
              pHtml += `<span  contenteditable="false" class="effect-global-mute isTag ${
                this.showGlobalMute ? '' : 'opacityHide'
              } ${
                word.muteChange ? 'isSelf' : ''
              }" data-type="globalMute"><span>&nbsp;</span><span class="effect-mute isPlaceHolder" data-type="globalMute" data-value="${
                word.digital
              }"><span style="font-size:0;">&nbsp;</span></span>`
            } else if (word.rhythmData) {
              if (word.rhythm > -1) {
                let img = ImageMap[word.rhythm]
                pHtml += `<span class="pause-item isTag isPlaceHolder" data-type="pause" data-value="${word.rhythm}" contentEditable="false"><img class="icon-pause" src="${img}"></span>`
              }
            }  else if (word.aliasChangeStart || word.aliasChangeEnd) {
              if (word.aliasChangeStart) {
                pHtml += `<span class="ignore aliasChange aliasChangeStart isTag" id="aliasChangeStart_${word.aliasGroupKey}" data-aliascontent="${word.aliasContent}" data-aliascontent2="//${word.aliasContent}" data-originalias="${word.originAlias}" data-type="aliasChange" contenteditable="false" data-aliasgroupkey="${word.aliasGroupKey}">&nbsp;<span class="aliasChangeInnerStart" data-aliascontent="${word.aliasContent}" data-aliascontent2="//${word.aliasContent}" data-originalias="${word.originAlias}">&nbsp;</span>&nbsp;</span>`
                pHtml += `<span data-idx='${pIndex}-${sIndex}-${wIndex}'>${word.word}</span>`
              }
              if (word.aliasChangeEnd) {
                if (!word.aliasChangeStart) {
                  pHtml += `<span data-idx='${pIndex}-${sIndex}-${wIndex}'>${word.word}</span>`
                }
                pHtml += `<span class="ignore aliasChange aliasChangeEnd isTag" id="aliasChangeEnd_${word.aliasGroupKey}" contenteditable="false" data-aliascontent="${word.aliasContent}" data-aliascontent2="//${word.aliasContent}" data-originalias="${word.originAlias}" data-type="aliasChange" data-aliasgroupkey="${word.aliasGroupKey}">&nbsp;<span class="aliasChangeInnerEnd" data-aliascontent="${word.aliasContent}" data-aliascontent2="//${word.aliasContent}" data-originalias="${word.originAlias}">&nbsp;</span>&nbsp;</span>`
              }
            }  else if (word.pronChangeStart || word.pronChangeEnd) {
              if (word.pronChangeStart) {
                let phoneticsId=word.phoneticsId||word.time
                pHtml += `<span class="ignore phonetics phoneticsStart isTag" id="phoneticsStart_${phoneticsId}" data-phoneticstext="${word.pronContent}" data-originpron="${word.originPron}" data-type="phonetics" contenteditable="false" data-phoneticsid="${phoneticsId}">&nbsp;<span class="phoneticsInnerStart" data-phoneticstext="${word.pronContent}" data-originpron="${word.originPron}">&nbsp;</span>&nbsp;</span>`
                pHtml += `<span data-idx='${pIndex}-${sIndex}-${wIndex}'>${word.word}</span>`
              }
              if (word.pronChangeEnd) {
                if (!word.pronChangeStart) {
                  pHtml += `<span data-idx='${pIndex}-${sIndex}-${wIndex}'>${word.word}</span>`
                }
                let phoneticsId=word.phoneticsId||word.time
                pHtml += `<span class="ignore phonetics phoneticsEnd isTag" id="phoneticsEnd_${phoneticsId}" contenteditable="false" data-phoneticstext="${word.pronContent}" data-originpron="${word.originPron}" data-type="phonetics" data-phoneticsid="${phoneticsId}">&nbsp;<span class="phoneticsInnerEnd" data-phoneticstext="${word.pronContent}" data-originpron="${word.originPron}">&nbsp;</span>&nbsp;</span>`
              }
            } else {
              pHtml += word.word
            }
          } else if (word.isPlaceHolder) {
            if (word.isMute) {
              // 静音
              pHtml += `<span  class="ignore">&nbsp;</span><span class="effect-mute isTag isPlaceHolder" contenteditable="false" data-type="mute" data-value="${word.digital}"><span style="font-size:0;">&nbsp;</span></span><span class="ignore">&nbsp;</span>`
            } else if (word.rhythmData) {
              if (word.rhythm > -1) {
                let img = ImageMap[word.rhythm]
                pHtml += `<span class="ignore">&nbsp;</span><span class="pause-item isTag isPlaceHolder" data-type="pause" data-value="${word.rhythm}" contentEditable="false"><img class="icon-pause" src="${img}"></span><span class="ignore">&nbsp;</span>`
              }
            } else if (word.continuousStart) {
              let continuousId = word.continuousId || word.time
              pHtml += `<span  class="ignore">&nbsp;</span><span class="ignore lianduStart liandu isTag" id="lianduStart_${continuousId}" contenteditable="false" data-type="liandu" data-continuousid="${continuousId}">&nbsp;<span class="continuousStart">&nbsp;</span>&nbsp;</span>`
            } else if (word.continuousEnd) {
              let continuousId = word.continuousId || word.time
              pHtml += `<span class="ignore lianduEnd liandu isTag" id="lianduEnd_${continuousId}" contenteditable="false" data-type="liandu" data-continuousid="${continuousId}">&nbsp;<span class="continuousEnd">&nbsp;</span>&nbsp;</span><span class="ignore">&nbsp;</span>`
            } else if (word.startSpeed) {
              pHtml += `<span class="ignore localSpeedStart isTag" id="localSpeedStart_${word.speedHover}" contenteditable="false" data-speedhover="${word.speedHover}" data-type="localSpeed" data-speedVal="${word.speed}x" data-speed="${word.speed}">&nbsp;<span class="speedStart"  data-speedVal="${word.speed}x">&nbsp;</span>&nbsp;</span>`
            } else if (word.endSpeed) {
              pHtml += `<span class="ignore localSpeedEnd isTag" id="localSpeedEnd_${word.speedHover}" contenteditable="false"  data-speedhover="${word.speedHover}" data-type="localSpeed" data-speedVal="${word.speed}x" data-speed="${word.speed}">&nbsp;<span class="speedEnd"  data-speedVal="${word.speed}x">&nbsp;</span>&nbsp;</span>`
            } else if (word.startSpeaker) {
              const speakerId = this.speakerUtils.getSpeakerBySpeaker(word.speaker)?.id ?? ''
              const speakerName2 = word.speakerName.split("|")[0]
              pHtml += `<span class="ignore multiSpeaker multiSpeakerStart isTag" id="multiSpeakerStart_${word.hover}" data-speed="${word.speed}" data-pitch="${word.pitch}" data-speakername="${word.speakerName}" data-speakername2="${speakerName2}" data-speakerid="${speakerId}" data-gender="${word.gender}" data-speaker="${word.speaker}" data-speakersource="${word.speakerSource}" data-emotionWeight="${word.emotionWeight || 1}" data-type="multiSpeaker" contenteditable="false" data-hover="${word.hover}">&nbsp;<span class="multiSpeakerInnerStart" data-speed="${word.speed}" data-pitch="${word.pitch}" data-speakername="${word.speakerName}" data-speakername2="${speakerName2}" data-speakerid="${speakerId}" data-gender="${word.gender}" data-speaker="${word.speaker}" data-speakersource="${word.speakerSource}" data-emotionWeight="${word.emotionWeight || 1}">&nbsp;</span>&nbsp;</span>`
            } else if (word.endSpeaker) {
              const speakerId = this.speakerUtils.getSpeakerBySpeaker(word.speaker)?.id ?? ''
              const speakerName2 = word.speakerName.split("|")[0]
              pHtml += `<span class="ignore multiSpeaker multiSpeakerEnd isTag" id="multiSpeakerEnd_${word.hover}" contenteditable="false" data-speed="${word.speed}" data-pitch="${word.pitch}" data-speakername="${word.speakerName}" data-speakername2="${speakerName2}" data-speakerid="${speakerId}" data-gender="${word.gender}" data-speaker="${word.speaker}" data-speakersource="${word.speakerSource}" data-emotionWeight="${word.emotionWeight || 1}" data-type="multiSpeaker" data-hover="${word.hover}">&nbsp;<span class="multiSpeakerInnerEnd" data-speed="${word.speed}" data-pitch="${word.pitch}" data-speakername="${word.speakerName}" data-speakername2="${speakerName2}" data-speakerid="${speakerId}" data-gender="${word.gender}" data-speaker="${word.speaker}" data-speakersource="${word.speakerSource}" data-emotionWeight="${word.emotionWeight || 1}" >&nbsp;</span>&nbsp;</span>`
            } else if (word.pronChangeStart) {
              let phoneticsid =word.phoneticsid||word.time
              const phoneticstext = word.pronContent
              pHtml += `<span class="ignore phonetics phoneticsStart isTag" id="phoneticsStart_${phoneticsid}" contenteditable="false" data-phoneticstext="${phoneticstext}" data-type="phonetics" data-phoneticsid="${phoneticsid}">&nbsp;</span>&nbsp;</span>`
            } else if (word.pronChangeEnd) {
              let phoneticsid =word.phoneticsid||word.time
              const phoneticstext = word.pronContent
              pHtml += `<span class="ignore phonetics phoneticsEnd isTag" id="phoneticsEnd_${phoneticsid}" contenteditable="false" data-phoneticstext="${phoneticstext}" data-type="phonetics" data-phoneticsid="${phoneticsid}">&nbsp;</span>&nbsp;</span>`
            }
          }
          if(endIndex&&pIndex==endIndex[0]&&sIndex==endIndex[1]&&wIndex==endIndex[2]){
            pHtml += `</span>`
            sensitiveIndex=sensitiveIndex+1
            sensitiveWord=this.wordAndReplaceList[sensitiveIndex]
            if(sensitiveWord){
              startIndex = sensitiveWord.startIndex
              endIndex = sensitiveWord.endIndex
            }else{
              startIndex=null
              endIndex=null
            }
          }
        })
        pHtml += `</span>`
      })
      pHtml += '</div>'
      HtmeData += pHtml
    })
    this.cursorVisible = false
    return HtmeData
  }

  // onKeyDown(e: any) { }

  // dom to Json
  _domToDomJSON(editor) {
    let tts: Array<any> = []
    if (editor) {
      let list = Dom.getChildNodesAst(editor, 0)
      if (list.indexOf('caret') != -1) {
        let idx = list.indexOf('caret')
        list.splice(idx, 1)
        list[idx] && (list[idx].isCaret = true)
      }
      let map = []
      list.forEach(item => {
        if (!map[item.$deep]) {
          map[item.$deep] = {
            children: []
          }
        }
        map[item.$deep].children.push(item)
      })
      list = map
      let caretFlag = false
      let lianduObj = null
      let speedObj = null
      let speakerObj = null
      let aliasObj = null
      let aliasLeftLength = 0;
      let pronLeftLength = 0;
      let stressObj = null
      let pronObj=null
      list.forEach((ele) => {
        let pList: Array<any> = []
        ele.children = ele.children || []
        ele.children.forEach((item: any) => {
          if (item.isTag) {
            if (item && caretFlag == true) {
              item.isCaret = true
              caretFlag = false
            }
            if (item.wordType == 'lianduStart') {
              let range = new Range()
              range.setStartAfter($(`#lianduStart_${item.continuousId}`)[0])
              range.setEndBefore($(`#lianduEnd_${item.continuousId}`)[0])
              let rangec = range.cloneContents()
              let text = $(rangec).text()
              lianduObj = {
                continuousChange: true,
                continuousId: item.continuousId,
                time: item.continuousId,
                continuousContent: text,
                continuousLength: text.length,
              }
              let effctItem: any = {
                word: ' ',
                isPlaceHolder: 1,
                continuousChange: true,
                continuousStart: true,
                continuousId: item.continuousId,
                time: item.continuousId,
                isTag: true
              }
              if (item.isCaret) {
                effctItem.isCaret = item.isCaret
              }
              pList.push(effctItem)
            } else if (item.wordType == 'lianduEnd') {
              lianduObj = null
              let effctItem: any = {
                word: ' ',
                isPlaceHolder: 1,
                continuousChange: true,
                continuousEnd: true,
                continuousId: item.continuousId,
                time: item.continuousId,
                isTag: true
              }
              if (item.isCaret) {
                effctItem.isCaret = item.isCaret
              }
              pList.push(effctItem)
            } else if (item.wordType == 'localSpeedStart') {
              speedObj = {
                speedHover: item.speedHover,
                speed: item.speed
              }
              let effctItem: any = {
                word: ' ',
                isPlaceHolder: 1,
                startSpeed: true,
                speedHover: item.speedHover,
                speed: item.speed,
                isTag: true
              }
              if (item.isCaret) {
                effctItem.isCaret = item.isCaret
              }
              pList.push(effctItem)
            } else if (item.wordType == 'localSpeedEnd') {
              speedObj = null
              let effctItem: any = {
                word: ' ',
                isPlaceHolder: 1,
                endSpeed: true,
                speedHover: item.speedHover,
                speed: item.speed,
                isTag: true
              }
              if (item.isCaret) {
                effctItem.isCaret = item.isCaret
              }
              pList.push(effctItem)
            } else if (item.wordType == "multiSpeakerStart") {
              speakerObj = {
                speed: item.speed,
                pitch: item.pitch,
                hover: item.hover,
                gender: item.gender,
                speaker: item.speaker,
                speakerName: item.speakerName,
                speakerSource: item.speakerSource,
                emotionWeight: item.emotionWeight || 1
              }
              let effctItem: any = {
                word: " ",
                isPlaceHolder: 1,
                startSpeaker: true,
                isTag: true,
                ...speakerObj
              }
              if (item.isCaret) {
                effctItem.isCaret = item.isCaret
              }
              pList.push(effctItem)
            } else if (item.wordType == "multiSpeakerEnd") {
              let effctItem: any = {
                word: " ",
                isPlaceHolder: 1,
                endSpeaker: true,
                isTag: true,
                ...speakerObj
              }
              speakerObj = null
              if (item.isCaret) {
                effctItem.isCaret = item.isCaret
              }
              pList.push(effctItem)
            } else if (item.wordType == "stressStart") {
              stressObj = {
                ...(item.isStress === 2 ? {
                  isStress: 2
                }:item.dragSound === 2 ? {
                  dragSound: 2
                }:item.stressAndDragSound === 2 ? {
                  stressAndDragSound: 2
                }:null),
                stresshover: item.stresshover,
              }
              let effctItem: any = {
                word: item.word,
                startStressRead: true,
                ...stressObj
              }
              if (item.isCaret) {
                effctItem.isCaret = item.isCaret
              }
              pList.push(effctItem)
            } else if (item.wordType == "stressEnd") {
              let effctItem: any = {
                word: item.word,
                endStressRead: true,
                ...stressObj
              }
              stressObj = null
              if (item.isCaret) {
                effctItem.isCaret = item.isCaret
              }
              pList.push(effctItem)
            } else if (item.wordType == "aliasChangeStart") {
              aliasObj = {
                aliasChange: true,
                aliasContent: item.aliasContent,
                aliasGroupKey: item.aliasGroupKey,
                aliasLength: item.aliasLength,
                originAlias: item.originAlias,
              }
              aliasLeftLength = item.originAlias.length // 剩余字符长度
              // if (item.isCaret) {
              //   effctItem.isCaret = item.isCaret
              // }
            } else if (item.wordType == "aliasChangeEnd") {
              aliasObj = null
              // if (item.isCaret) {
              //   effctItem.isCaret = item.isCaret
              // }
            } else if (item.wordType == "phoneticsStart") {
              pronObj = {
                pronChange: true,
                pronContent: item.pronContent,
                phoneticsId: item.phoneticsId,
                pronLength: item.pronLength,
                originPron: item.originPron,
              }
              pronLeftLength = item.pronLength // 剩余字符长度
              // if (item.isCaret) {
              //   effctItem.isCaret = item.isCaret
              // }
            } else if (item.wordType == "phoneticsEnd") {
              pronObj = null
              // if (item.isCaret) {
              //   effctItem.isCaret = item.isCaret
              // }
            } else {
              pList.push(item)
            }
          } else {
            let textObj: any;
            let langArr = item.text && this._splitTextByLanguage(item.text);
            textObj = langArr && langArr.map(str => {
                str = str.replace(
                  /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
                  ''
                )
                let regExp =
                  /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im
                let aliasObj2 = null
                let lianduObj2 = null
		let multiToneObj = null
                let pronObj2 = null
                if (lianduObj) {
                  if (regExp.test(str)) {
                    str = ' '
                  }
                  lianduObj2 = {
                    ...lianduObj
                  }
                  delete lianduObj.continuousContent
                  delete lianduObj.continuousLength
                }
                if (aliasObj) {
                  let boundObj: any = {}
                  if (aliasObj.originAlias.length === 1) {
                    boundObj.aliasChangeStart = true
                    boundObj.aliasChangeEnd = true
                  } else if (aliasObj.originAlias.length === aliasLeftLength) {
                    boundObj.aliasChangeStart = true
                  } else if (aliasLeftLength === 1) {
                    boundObj.aliasChangeEnd = true
                  }
                  aliasLeftLength--
                  aliasObj2 = {
                    ...aliasObj,
                    ...boundObj
                  }
                }
                if (item.wordType === 'multi-tone') {
                  multiToneObj = {
                    isChange: item.isChange,
                    pinyin: item.pinyin,
                    originPinyin: item.originPinyin
                  }
                }
                if (pronObj) {
                  let boundObj: any = {}
                  if (pronObj.pronLength === 1) {
                    boundObj.pronChangeStart = true
                    boundObj.pronChangeEnd = true
                  } else if (pronObj.pronLength === pronLeftLength) {
                    boundObj.pronChangeStart = true
                  } else if (pronLeftLength === 1) {
                    boundObj.pronChangeEnd = true
                  }
		  pronLeftLength--
                  pronObj2 = {
                    ...pronObj,
                    ...boundObj
                  }
                }
              
                
                return { word: str, ...speedObj, ...speakerObj, ...lianduObj2, ...aliasObj2, ...pronObj2,...stressObj, ...multiToneObj }
              })
///////////////
            if (item.isCaret) {
              caretFlag = true
              if (textObj[0]) {
                textObj[0].isCaret = true
                caretFlag = false
              }
            }
            if (textObj[0] && caretFlag == true) {
              textObj[0].isCaret = true
              caretFlag = false
            }
            if (textObj) {
              pList.push(...textObj)
            }
          }
        })
        pList.length > 0 && tts.push(pList)
      })
    }
    return tts
  }
  _splitTextByLanguage(text){
     // Unicode 范围匹配：东南亚语言（泰文、老挝文、缅文、柬文等）
     const southeastAsianRegex = /[\u0E00-\u0E7F\u0E80-\u0EFF\u1000-\u109F\u1780-\u17FF]/;

    const isSoutheastAsian = southeastAsianRegex.test(text);

    if (isSoutheastAsian && typeof Intl !== 'undefined' && typeof (Intl as any).Segmenter !== 'undefined') {
      const segmenter = new (Intl as any).Segmenter('th', { granularity: 'grapheme' });
      const segments = segmenter.segment(text);
      return Array.from(segments, (s: any) => s.segment);
    } else {
      return Array.from(text);
    }
  }
  mergetts(data: any[], baseArticleTxt: any[]) {
    return new Promise(resolve => {
      try {
        data.forEach((ele, pIndex) => {
          baseArticleTxt[pIndex] = this.replaceSourceWords(
            ele,
            baseArticleTxt[pIndex]
          )
        })

        resolve(baseArticleTxt)
      } catch (err) {
        /**
         * error start
         */
        // eslint-disable-next-line no-ex-assign
        err = err || new Error()
        err.methods = 'checkSentenceSplit'
        // savePromiseError(err)
        console.log(err)
        /**
         * error end
         */
        resolve(baseArticleTxt)
      }
      resolve(baseArticleTxt)
    })
  }
  /**
   * 段落分词merge
   *
   * @param      {Array}  data    tts返回段落数据源
   * @param      {String}  sourceData  段落数据源
   */
  replaceSourceWords(data, sourceData) {
    // let self = this
    let dataCount = 0
    // let dataArr = []

    let dataLen = 0
    data.forEach(ele => {
      dataLen += ele.originWord.length
    })
    const resetSourceData = sourceData.map(item => {
      if (item.originPinyin === item.pinyin && !item.isChange) {
        delete item.originPinyin
        delete item.pinyin
      }
      if (item.originRhythm === item.rhythm && !item.rhythmData) {
        delete item.originRhythm
        delete item.rhythm
      }
      return item
    })

    function addword(
      sentence,
      resetSourceData,
      oItem,
      index,
      dataCount,
      itemOIndex
    ) {
      if (resetSourceData[dataCount].word != oItem.word) {
        sentence.splice(index, 0, resetSourceData[dataCount])
        spliceCount++
        dataCount++
        itemOIndex++
        index++
      }
      if (resetSourceData[dataCount] && resetSourceData[dataCount].word != oItem.word) {
        ;[dataCount, itemOIndex] = addword(
          sentence,
          resetSourceData,
          oItem,
          index,
          dataCount,
          itemOIndex
        )
      }
      return [dataCount, itemOIndex]
    }

    // 将返回的分句添加韵律和多音字属性
    let spliceCount = 0
    // let additionalWord = []
    data.forEach((sentence, sIndex) => {
      let originWordSen = JSON.parse(JSON.stringify(sentence.originWord))
      let itemOIndex = 0
      originWordSen.forEach((oItem, index) => {
        if (
          resetSourceData.length - dataLen - spliceCount > 0 &&
          resetSourceData[dataCount].word != oItem.word
        ) {
          ;[dataCount, itemOIndex] = addword(
            sentence.originWord,
            resetSourceData,
            oItem,
            itemOIndex,
            dataCount,
            itemOIndex
          )
        }
        let itemO = sentence.originWord
        if (
          resetSourceData[dataCount] &&
          resetSourceData[dataCount].word == oItem.word
        ) {
          itemO[itemOIndex] = this._mergeDomObjectToTts(
            itemO[itemOIndex],
            resetSourceData[dataCount]
          )
        }
        // 换行空字符单独存为一句
        if (data.length >= 1 && isSpaceWord(oItem)) {
          data.push({
            originWord: [oItem]
          })
          if (sentence.originWord.length === 1) {
            data.splice(sIndex, 1)
          } else {
            data[sIndex].originWord.splice(index, 1)
          }
        }
        dataCount++
        itemOIndex++
      })
    })

    return data
  }

  mergeDomJsonToTtsJson(ttsJson: any[]) {
    let self = this
    if (this.cachedDomJson) {
      this.cachedDomJson.forEach((paragraph: any[], pIndex: number) => {
        if (Array.isArray(paragraph)) {
          if (paragraph.length == 0) {
            ttsJson.splice(pIndex, 0, [
              {
                originWord: [this._genMuteWord()]
              }
            ])
          }
          paragraph.forEach((item: any, idx: number) => {
            // if (item.isTag||item.isCaret) {
            // tts段
            let ttsParagraph = ttsJson[pIndex]
            let count = 0 // 每句累加
            for (let i = 0; i <= ttsParagraph.length; i++) {
              if (idx > count) {
                count += ttsParagraph[i].originWord.length
              } else if (idx == count) {
                let sentence = ttsParagraph[i]
                sentence.originWord[0] = self._mergeDomObjectToTts(
                  sentence.originWord[0],
                  item
                )
                break
              } else {
                let sentence = ttsParagraph[i - 1]
                let wordIndex = sentence.originWord.length - (count - idx)
                sentence.originWord[wordIndex] = self._mergeDomObjectToTts(
                  sentence.originWord[wordIndex],
                  item
                )
                break
              }
            }
            // }
          })
        }
      })
    }
    ttsJson.forEach(paragraph => {
      let lastScentence = paragraph[paragraph.length - 1].originWord || []
      let lastWord = lastScentence[lastScentence.length - 1]
      if (!lastWord.isMute) {
        paragraph.push({
          originWord: [this._genMuteWord()]
        })
      }
    })
  }
  // 构造一个和分词一样的数据结构 用于自动保存代替分词
  generateOneTransientData() {
    let articleTxt: any = []
    let { cachedDomJson } = this
    let prePindex = -1 // 记录上一次WIndex
    cachedDomJson.forEach((paragraph: any[], pIndex: number) => {
      if (Array.isArray(paragraph)) {
        if (paragraph.length == 0) {
          articleTxt.push([
            {
              originWord: [this._genMuteWord()]
            }
          ])
        } else {
          if (prePindex !== pIndex) {
            articleTxt.push([{ originWord: [] }])
            prePindex = pIndex
          }
          paragraph.forEach(val => {
            let obj = { word: val.word }
            articleTxt[pIndex][0].originWord.push(
              this._mergeDomObjectToTts(obj, val)
            )
          })

          articleTxt.forEach(sen => {
            let lastScentence = sen[sen.length - 1].originWord || []
            let lastWord = lastScentence[lastScentence.length - 1]
            if (!lastWord.isMute) {
              sen.push({
                originWord: [this._genMuteWord()]
              })
            }
          })
        }
      }
    })
    this.state.articleTxt = articleTxt
  }
  _mergeDomObjectToTts(target: any, source: any) {
    let base: any = {
      pinyin: '',
      originPinyin: '',
      word: ' ',
      rhythm: -1,
      originRhythm: -1,
      ...target
    }
    base = Object.assign(base, source)

    if (source.wordType == 'pause') {
      base = {
        ...base,
        rhythm: source.rhythm,
        rhythmData: source.rhythmData,
        isPlaceHolder: 1
      }
    }

    if (source.wordType == 'mute') {
      base = {
        ...base,
        digital: source.digital,
        isMute: source.isMute,
        isPlaceHolder: 1,
        visible: false,
        muteChange: true
      }
      if (source.text_attr) {
        base.muteChange = source.muteChange
      }
    }

    if (source.wordType == 'multi-tone') {
      let obj: any = {}
      if (source.source && source.source !== 'undefined') {
        obj = JSON.parse(source.source || '{}')
      }
      base = {
        pinyin: source.pinyin,
        originPinyin: target.originPinyin,
        word: source.word,
        rhythm: target.rhythm,
        originRhythm: target.originRhythm,
        pinyinPron: obj.pron,
        pinyinTone: obj.tone,
        toneStatus: !!obj.tone,
        pinyinNum: obj.data,
        isChange: true
      }
    }
    if (source.wordType == 'stress') {
      const valueObj =
        source.isStress === 2
          ? {
              // 重读
              isStress: 2
            }
          : source.dragSound === 2
          ? {
              // 拖音
              dragSound: 2
            }
          : source.stressAndDragSound === 2
          ? {
              // 重+拖
              stressAndDragSound: 2
            }
          : {}
      const boundObj = source.startStressRead
        ? {
            startStressRead: true,
            isPlaceHolder: 1
          }
        : source.endStressRead
        ? {
            endStressRead: true,
            isPlaceHolder: 1
          }
        : {}
      base = {
        word: source.word,
        stress: source.stress,
        ...valueObj,
        source: source.source,
        parentId: source.parentId,
        stresshover: source.stresshover,
        ...boundObj
      }
    }
    if (source.wordType == 'stress-tone') {
      let obj: any = {}
      if (source.source && source.source !== 'undefined') {
        obj = JSON.parse(source.source || '{}')
      }
      base = {
        word: source.word,
        stress: source.stress,
        isStress: source.isStress,
        source: source.source,
        parentId: source.parentId,
        stresshover: source.stresshover,
        pinyin: source.pinyin,
        originPinyin: target.originPinyin,
        rhythm: target.rhythm,
        originRhythm: target.originRhythm,
        pinyinPron: obj.pron,
        pinyinTone: obj.tone,
        toneStatus: !!obj.tone,
        pinyinNum: obj.data,
        isChange: true
      }
    }
    if (source.wordType == 'startStressRead') {
      base = {
        word: source.word,
        isStress: source.isStress,
        startStressRead: true,
        stresshover: source.stresshover,
        isPlaceHolder: 1
      }
    }
    if (source.wordType == 'endStressRead') {
      base = {
        word: source.word,
        isStress: source.isStress,
        endStressRead: true,
        stresshover: source.stresshover,
        isPlaceHolder: 1
      }
    }
    //光标合并
    if (source.isCaret) {
      base.isCaret = true
    }

    return base
  }
  //选择操作
  changeItem(type: any) {
    this.activeSheetType = type
    if (this.playStatus&&this.activeSheetType !== 'symbolMute') {
      toast('请点击内容区域，指定效果位置进行设置', 'top')
      this.__resetArticleStatus()
      return
    } else if(this.playStatus&&this.activeSheetType=='symbolMute'){
      this.__resetArticleStatus()
    }
    this.showAudio = false
    this.tagElement = null
    if (type != 'multi-tone' && type != 'stress') {
      this.removeStressActive()
    }
    this.$nextTick(() => {
      let node = $('.bottom-nav-item.active')[0]
      if (node && !isOverlapped(node)) {
        node.scrollIntoView(true)
      }
    })
    //嵌套逻辑判断
    if (type == 'stress') {
      setTimeout(() => {
        this.pauseObjs = this.pauseObjs.map((item: any) => {
          item.checked = false
          item.change = false
          return item
        })
        this.openSheet(type)
      }, 100)
    } else if (type == 'multi-tone') {
      if (this.sectionType != 'Range') {
        this.checkMutilTone()
      }
      setTimeout(() => {
        this.openSheet(type)
      }, 100)
    } else {
      setTimeout(() => {
        this.openSheet(type)
      }, 100)
    }
  }
  /**
   * 用元素替换被选中的文本
   */
  replaceSelectedStrByEle(ele, className) {
    let range = this.rangeSelection.firstRange
    // 抽取选区片段到fragment
    let _fragment = range.extractContents()
    let span = document.createElement(ele)
    span.className = className
    span.appendChild(_fragment)
    range.insertNode(span)
    // range.select();
  }
  checkSpeakerInvalid(type,selection) {
    let range = selection.range || selection.caret
    const speakerNotSupport = this.isRangeSpeakerNotSupportEffect(selection.range, type)
    if (speakerNotSupport) {
      return `${speakerNotSupport.name.split("|")[0]}暂不支持此功能`
    }else{
      return ''
    }
  }
  
  /**
   * 替换选区
   */
  checkStress() {
    this.showStress = true
    this.showMenuContent = true
  }

  //显示多音字
  checkMutilTone() {
    this.wordText = ''
    this.mutilToneObjs = []
    this.selection.savedSelectionRange = SelectionUtils.createRange(
      this.selection.savedSelectionRange
    )
    this.selRange = this.selection.savedSelectionRange
    this.showMenuContent = true
    this.showMutilTone = true
    let reg = /[\u4e00-\u9fa5]/
    if (this.rangeSelection.data) {
      if (this.rangeSelection.data.length > 1) {
        toast('多音字需要对单个文字进行设置', 'top')
        // Toast({
        //   message: '多音字需要对单个文字进行设置',
        //   position: 'top'
        // })
        this.rangeSelection = {}
        return
      }
      let text = this.rangeSelection.data
      let range = this.rangeSelection.firstRange
      if (!reg.test(text)) {
        toast('多音字需要对单个文字进行设置', 'top')
        this.rangeSelection = {}
        return
      }
      let _fragment = range.extractContents()
      let span = document.createElement('span')
      span.className = 'toneActive'
      span.appendChild(_fragment)
      range.insertNode(span)
    } else {
      if (
        this.selRange.startContainer.textContent ==
          this.selRange.endContainer.textContent &&
        this.selRange.startContainer.textContent.length == 1 &&
        this.selRange.startContainer.parentNode.nodeName == 'SPAN' &&
        this.selRange.startContainer.parentNode.innerText ==
          this.selRange.startContainer.textContent
      ) {
        let node = this.selRange.startContainer
        var reg2 = /[\u4e00-\u9fa5]/
        let text = this.selRange.startContainer.textContent
        // debugger
        if (!text || !reg2.test(text)) {
          toast('多音字需要对单个文字进行设置', 'top')
          return
        }
        if (node.parentNode.nodeName == 'SPAN') {
          let className = node.parentNode.className
          if (className.indexOf('toneActive') == -1) {
            node.parentNode.className = className + ' toneActive'
          }
        }
        // 兼容手输一个字
        if (
          node.parentNode.nodeName == 'DIV' &&
          node.parentNode.className.indexOf('editor') > -1
        ) {
          node.parentNode.innerHTML =
            '<span class="toneActive">' +
            this.selRange.startContainer.textContent +
            '</span>'
        }
        // this.wordText = this.selRange.startContainer.textContent
        if (/[^\u4e00-\u9fa5]/.test(this.wordText)) {
          toast('多音字需要对单个文字进行设置', 'top')
          this.showMenuContent = true
          return
        }
        this.__getWordsByText()
      } else {
        //  console.log(Dom.getTagNode(this.selRange.startContainer))
        let node = this.selRange.startContainer
        let startOffset = this.selRange.startOffset
        let text = this.selRange.startContainer.textContent || ''
        text = text.replace(/[\n]/g, '')
        var reg2 = /[\u4e00-\u9fa5]/

        let Html = ''
        if (!text) {
          node = this.getprevnextNode(node, '#text', 'prev')
          if (!node || !reg2.test(node.textContent.slice(-1))) {
            toast('多音字需要对单个文字进行设置', 'top')
            return
          }
          if (node.nodeName == '#text') {
            let nodeText = node.textContent
            Html =
              nodeText.slice(0, -1) +
              `<span class='toneActive'>${nodeText.slice(-1)}</span>`
          } else {
            let childNodes = node.childNodes || []
            this.handleToneNode(childNodes, startOffset)
          }
        } else {
          if (node.nodeName === '#text') {
            if (!text || !reg2.test(text.substr(startOffset, 1))) {
              toast('多音字需要对单个文字进行设置', 'top')
              return
            }
            Html =
              text.substr(0, startOffset) +
              `<span class='toneActive'>${text.substr(startOffset, 1)}</span>` +
              text.substr(startOffset + 1, text.length - startOffset - 1)
          } else {
            // debugger
            if (!text || !reg2.test(text.substr(startOffset - 1, 1))) {
              toast('多音字需要对单个文字进行设置', 'top')
              return
            }
            let childNodes = node.childNodes || []

            this.handleToneNode(childNodes, startOffset)
          }
        }
        if (
          node.parentNode.nodeName == 'SPAN' ||
          node.parentNode.nodeName == 'DIV'
        ) {
          if (Html) {
            let htmlNode
            if (node.tagName) {
              htmlNode = document.createElement(node.tagName)
            } else {
              htmlNode = document.createElement('SPAN')
            }
            htmlNode.innerHTML = Html
            node.parentNode.insertBefore(htmlNode, node)
            node.remove()
          }

          //
          // let index=[].indexOf.call(node.parentNode.childNodes,node)
        }
      }
    }
    this.selectionAddr.anchorNode = $('.toneActive')[0]
    this.selectionAddr.anchorOffset = 1
    this.setFitFocus(
      this.selectionAddr.anchorNode,
      this.selectionAddr.anchorOffset,
      0
    )
    this.wordText = $('.toneActive').text()
    if (!this.wordText || /[^\u4e00-\u9fa5]/.test(this.wordText)) {
      toast('多音字需要对单个文字进行设置', 'top')
      return
    }
    this.__getWordsByText()
    this.rangeSelection = {}
  }

  /**
   * 处理多音字，这里主要兼容了重读的情况
   * @param childNodes
   * @param startOffset
   */
  handleToneNode(childNodes, startOffset) {
    let stressNode = childNodes[startOffset]
    if (stressNode) {
      let _nodeList = stressNode.childNodes
      if (_nodeList && _nodeList.length) {
        if (_nodeList.length > 1) {
          this.handleToneNode(_nodeList, startOffset)
        } else {
          let _stressNode = _nodeList[0].cloneNode(true)
          let parentNode = _nodeList[0].parentNode
          let span = document.createElement('span')
          span.className = 'toneActive'
          span.appendChild(_stressNode)
          parentNode.replaceChild(span, _nodeList[0])
        }
      } else {
        if (stressNode.nodeName == '#text') {
          let text = stressNode.textContent
          let Html =
            text.substr(0, startOffset) +
            `<span class='toneActive'>${text.substr(startOffset, 1)}</span>` +
            text.substr(startOffset + 1, text.length - startOffset - 1)
          let htmlNode
          if (stressNode.tagName) {
            htmlNode = document.createElement(stressNode.tagName)
          } else {
            htmlNode = document.createElement('SPAN')
          }
          htmlNode.innerHTML = Html
          stressNode.parentNode.insertBefore(htmlNode, stressNode)
          stressNode.remove()
        } else {
          let _stressNode = stressNode.cloneNode(true)
          let parentNode = stressNode.parentNode
          let span = document.createElement('span')
          span.className = 'toneActive'
          span.appendChild(_stressNode)
          parentNode.replaceChild(span, stressNode)
        }
      }
    }
  }
  createHtmlStr(text: string, startOffset: number) {
    let reg2 = /[\u4e00-\u9fa5]/
    if (!text || !reg2.test(text.substr(startOffset, 1))) {
      toast('请选择中文字符', 'top')
      return
    }
    return (
      text.substr(0, startOffset) +
      `<span class='toneActive'>${text.substr(startOffset, 1)}</span>` +
      text.substr(startOffset + 1, text.length - startOffset - 1)
    )
  }

  // 插入静音
  insertMute(item: any) {
    if (item.value > -1) {
      let mute = Dom.make('span', ['mute-item', 'isTag'])
      mute = Dom.dataset(mute, {
        type: 'mute',
        value: item.value
      })
      // debugger
      // muteNumber.textContent = item.value
      // mute.appendChild(muteNumber)
      mute.innerHTML = `</span><span class="mute-number">${
        item.value
      }</span>${Dom.renderMuteLine(item.value)}`
      mute.contentEditable = 'false'
      // mute.textContent = " ";
      this._insertHtmlAtCaret(mute)
    }
  }

  // 插入停顿
  insertPause(item: any) {
    const _getImage = (value: typeof ImageMap) => ImageMap[value] || null
    let value: typeof ImageMap = item.value

    // 插入
    if (item.value > -1) {
      if (_getImage(value)) {
        let img = Dom.make('img', 'icon-pause', {
          src: _getImage(value)
        })
        let pause = Dom.make('span', ['pause-item', 'isTag'])
        pause = Dom.dataset(pause, {
          type: 'pause',
          value: value
        })
        pause.contentEditable = 'false'
        pause.appendChild(img)
        // 高亮当前特效节点
        this.highlightEffectNode(pause, value)
        this._insertHtmlAtCaret(pause)
      }
    } else {
      // 删除之前的dom
    }
  }
  // 请空文本
  clearTxt(isNeedFocus = true) {
    this.state.content = ''
    document.querySelector('#editor').innerHTML = ''
    this.state.articleTxt = []
    // this.editor.click()
    if (isNeedFocus) {
      this.setFitFocus(this.editer, 0, 10)
      setTimeout(() => {
        // this.editor.click()
        this.cursorVisible = false
      }, 610)
    }
    this.showMute = false
    this.showMutilTone = false
    this.showPause = false
    this.showStress = false
    this.showMenuContent = false
    this.bottomNavItems.forEach(val => {
      val.active = false
    })
    this.getArticleLength()
  }
  // 光标处插入html
  _insertHtmlAtCaret(dom: HTMLElement, range?: any) {
    let sel: Selection = window.getSelection() as Selection
    range = range || this.lastSelection.caret
    console.log('_insertHtmlAtCaret', range, this.selection)
    this.tagElement = dom
    if (sel && range) {
      range.deleteContents()
      var el = document.createElement('div')
      // el.innerHTML = html;
      el.innerHTML = `<span class="ignore">&nbsp;</span>${dom.outerHTML}<span class="ignore">&nbsp;</span>`
      this.tagElement = el.childNodes[1] as HTMLElement
      let node3 = el.childNodes[2]
      var frag = document.createDocumentFragment(),
        node,
        lastNode
      while ((node = el.firstChild)) {
        lastNode = frag.appendChild(node)
      }
      range.insertNode(frag)
      // Preserve the selection
      this.selectionAddr.anchorNode = node3
      this.selectionAddr.anchorOffset = 1
      this.setFitFocus(
        this.selectionAddr.anchorNode,
        this.selectionAddr.anchorOffset,
        0
      )
      setTimeout(() => {
        this.setFitFocus(
          this.selectionAddr.anchorNode,
          this.selectionAddr.anchorOffset,
          0
        )
        this.cursorPosition = SelectionUtils.rect
      }, 100)
    } else {
      toast('选区不存在，请重新定位光标', 'top')
      this.tagElement.remove()
      this.tagElement = null
      // this.selection.clearSaved();;
    }
  }

  /**
   * 替换特殊符号
   * @param text
   */
  replaceSymbol(text) {
    if (!text) return ''
    text = text
      .split('<')
      .join('《')
      .split('>')
      .join('》')
      .split('&')
      .join('﹠')
    return text
  }
  // 光标处插入html

  _insertHtmlStringAtCaret(html: string) {
    this.selection.savedSelectionRange = SelectionUtils.createRange(
      this.selection.savedSelectionRange
    )
    this.selRange = this.selection.savedSelectionRange
    //  console.log(Dom.getTagNode(this.selRange.startContainer))
    let node = this.selectionAddr.anchorNode
    let startOffset = this.selectionAddr.anchorOffset
    let text = this.selectionAddr.anchorNode.textContent || ''
    let Html
    // text = this.replaceSymbol(text)
    if (node.nodeName == '#text') {
      if (startOffset == 0) {
        Html = html + text
      } else {
        Html = text.slice(0, startOffset) + html + text.slice(startOffset)
      }
      if (
        node.parentNode.nodeName == 'SPAN' ||
        node.parentNode.nodeName == 'DIV'
      ) {
        let htmlNode
        if (node.tagName) {
          htmlNode = document.createElement(node.tagName)
        } else {
          htmlNode = document.createElement('SPAN')
        }
        htmlNode.innerHTML = Html
        // let index=[].indexOf.call(node.parentNode.childNodes,node)
        node.parentNode.insertBefore(htmlNode, node)

        node.remove()
      }
    } else if (node.childNodes) {
      let htmlNode = document.createElement('SPAN')
      htmlNode.innerHTML = html
      if (startOffset < node.childNodes.length) {
        node.insertBefore(htmlNode, node.childNodes[startOffset])
      } else {
        node.innerHTML = node.innerHTML + html
      }
    } else {
      node.outerHTML = html
    }
  }

  // 专辑列表
  getMyAlbumList() {
    let self = this
    this.$http('getMyCompanyList', {}).then(res => {
      if (res.code == 200) {
        let first = (res.data || [])[0] || {}
        self.state.companyList = res.data || []
        self.state.companyId = first.id
        this.projectId=first.projectId
      }
    })
  }
  //获取多音字拼音list
  __getWordsByText(value?: string) {
    let self = this
    if (isSpecialString(self.wordText)) {
      toast('存在特殊字符，请重新选择', 'top')
      return
    }
    self.showMutilTone = true
    this.$http('getWordPinyinByText', {
      language: 'zh-cn',
      word: self.wordText
    }).then((res: any) => {
      if (res.err_code == 0) {
        let str = JSON.stringify(res)
        let mutilTone = (res.data || [])
          .concat(res.pron || [])
          .concat(res.tone || [])
        if (mutilTone.length > 0) {
          self.mutilToneObjs = mutilTone.map((item: any) => {
            return { checked: false, name: item, dataSource: str }
          })
          if (value) {
            self.mutilToneObjs = self.mutilToneObjs.map((item: any) => {
              item.change = true
              item.checked = value == item.name ? true : false
              return item
            })
          }
        }
      }
    })
  }
  // 获取可用发音人list
  __getUsableSpeakerList(): Promise<any> {
    let self = this
    return new Promise((resolve, reject) => {
      this.$http('getUsableSpeakerList', {})
        .then((res: any) => {
          if (res.code == 200) {
            resolve(res)
          } else {
            reject()
          }
        })
        .catch(() => reject())
    })
  }

  // 发音人分类 -新同pc
  getAllSpeakersData(cover?) {
    let vm = this;
    return new Promise(resolve => {
      Promise.all([
        this.$http('getUsableSpeaker', {}),
        this.$http('getUserSpeakerByType', {}),
        this.$http('getSpeakerByType', {}),
        this.$http('getHistorySpeakerList', {}),
        this.$http('getStoreSearchCriteria'),
        this._getSpeakerEmotionList()
      ])
        .then(res => {
            console.log('--getAoo',res);
          let [usableList, userSpeakerTypeMapList, searchTagList, historyList, classificationList] =
            res.map(obj => {
              if (obj && obj.code == 200) {
                return obj.data || [];
              } else {
                return [];
              }
            });
          //处理historyList
          historyList = this.dealWithHistoryList(historyList);
          // 问问实验室如果没有数据不展示 删除"最近"
          if (userSpeakerTypeMapList['最近']) {
            delete userSpeakerTypeMapList['最近'];
          }
          let wwList = userSpeakerTypeMapList['问问实验室'] || [];
          if (wwList.length < 1) {
            delete userSpeakerTypeMapList['问问实验室'];
          }
          let vipType = this.state.vipInfo.type;
          // 已购(已购、讲真直购)、收藏、我的
          const BOUGHT = '已购';
          const MERGE_BOUGHT_TYPE_LIST = ['体验会员'];
          const OWNED_TYPE_LIST = ['已购', '体验会员'];
          let allPurchasedKeys = [];
          OWNED_TYPE_LIST.forEach(key => {
            const keys = userSpeakerTypeMapList[key];
            if (keys) {
              keys.forEach(key => {
                allPurchasedKeys.push(key);
                if (key.indexOf('_meet_') !== -1) {
                  allPurchasedKeys.push(key.replace('_meet', '_lpcnet'));
                } else if (key.indexOf('_lpcnet') !== -1) {
                  allPurchasedKeys.push(key.replace('_lpcnet', '_meet'));
                }
              });
            }
          });
          let mineKeys = userSpeakerTypeMapList['我的'] || [];//将所有“我的”获取到，也要设置为usable=true
          allPurchasedKeys = allPurchasedKeys.concat(wwList);
          let data = speakerNormalize([...usableList], vipType, allPurchasedKeys,mineKeys);
          allPurchasedKeys.map(v => {
            if (data.allSpeakersMap[v] && data.allSpeakersMap[v].default) {
              data.allSpeakersMap[v].default.purchased = true;
            }
          });
          this._allSpeakerData = usableList;
          // 构造boughtSpeakerList和purchasedSpeakerList
          let boughtSpeakerList = [];
          let purchasedSpeakerList = [];
          const getBoughtList = (keys, isPurchased) => {
            keys.forEach(v => {
              //遍历传入的keys
              const allSpeakersMap = data.allSpeakersMap;
              let speaker =
                allSpeakersMap[v] ||
                allSpeakersMap[v.replace('_lpcnet_', '_meet_')] ||
                allSpeakersMap[v.replace('_meet_', '_lpcnet_')];
              if (speaker && speaker.default) {
                // 所有购买的声音
                boughtSpeakerList.push(speaker.default);
                // 直接购买的声音
                if (isPurchased()) {
                  purchasedSpeakerList.push(speaker.default);
                }
              }
            });
          };
          Object.keys(userSpeakerTypeMapList).forEach(key => {
            if (OWNED_TYPE_LIST.includes(key)) {
              const keys = userSpeakerTypeMapList[key];
              if (keys) {
                getBoughtList(keys, () => MERGE_BOUGHT_TYPE_LIST.includes(key));

                // 直接购买的合并到付费已购tab
                if (MERGE_BOUGHT_TYPE_LIST.includes(key)) {
                  userSpeakerTypeMapList[BOUGHT] = (userSpeakerTypeMapList[BOUGHT] || []).concat(
                    keys
                  );
                }
              }
            }
          });
          MERGE_BOUGHT_TYPE_LIST.forEach(key => {
            delete userSpeakerTypeMapList[key];
          });
          // 问问实验室声音
          getBoughtList(wwList, () => true);

          // 合并后的分类"已购"去重，讲真可以和正常购买重复购买
          if (userSpeakerTypeMapList[BOUGHT]) {
            boughtSpeakerList = this.removeDuplicateVoice(boughtSpeakerList);
            userSpeakerTypeMapList[BOUGHT] = [...new Set(userSpeakerTypeMapList[BOUGHT])];
          }
          vm.$store.state.boughtSpeakerList = boughtSpeakerList;
          vm.$store.state.purchasedSpeakerList = purchasedSpeakerList;
          //对"收藏"分类发音人
          userSpeakerTypeMapList['收藏'].map(v => {
            v = v.split('@')[0]; //只需要本体发音人
            if (!data.allSpeakersMap[v]) {
              //_lpcnet_ 和_meet_ 替换  ->替换之后再从所有可用发音人之后找 因为找不到很可能是这两个字段的问题
              if (v.indexOf('_lpcnet_') != -1) {
                v = v.replace('_lpcnet_', '_meet_');
              } else {
                v = v.replace('_meet_', '_lpcnet_');
              }
            }
            data.allSpeakersMap[v]?.default && (data.allSpeakersMap[v].default.isFavourite = true);
          });
          // 将48k 转 24k 并且去重
          let newArr = [];
          let obj = {};
          userSpeakerTypeMapList['常用'] = (userSpeakerTypeMapList['常用'] || []).map(v => {
            let originSpeaker24k = '';
            if (v.originSpeaker) {
              if (v.originSpeaker.includes('_48k')) {
                originSpeaker24k = v.originSpeaker = v.originSpeaker.replace('_48k', '_24k');
                v.speaker = v.speaker.replace('_48k', '_24k');
                v.is48k = true; //给"常用"中对象添加is48K属性
              } else {
                originSpeaker24k = v.originSpeaker;
                v.is48k = false;
              }
            }

            // 去重
            if (!obj[originSpeaker24k]) {
              obj[originSpeaker24k] = 1;
              newArr.push(v);
            }
            return v;
          });
          //将去重后的数组赋值回去
          userSpeakerTypeMapList['常用'] = newArr;
          searchTagList = searchTagList.map(val => {
            val.mediaSpeakerListVOList = val.mediaSpeakerListVOList.map(v1 => {
              v1.speakerList = v1.speakerList.filter(v2 => !v2.includes('_48k'));
              return v1;
            });
            val.mediaSpeakerListVOList = val.mediaSpeakerListVOList.filter(
              v1 => v1.name !== '外语'
            );
            return val;
          });
          //ps
          vm.state.searchTagList = searchTagList;
          vm.state.userSpeakerTypeMapList = userSpeakerTypeMapList;
          vm.state.allSpeakerIds = data.allSpeakerIds;
          vm.state.allSpeakersMap = data.allSpeakersMap;
          //查找第一个发音人 -多发音人中 若无发音人需要使用默认发音人
          vm.firstTabFirstSpeaker = vm.getFirstSpeaker();
          vm.state.allStoreSpeakers = data.allStoreSpeakers;
          vm.state.allSpeakerIdMap = data.allSpeakerIdMap;
          vm.state.userHasSpeakersMap = data.userHasSpeakersMap;
          vm.state.nameToEngNameMap = data.nameToEngNameMap;
          vm.state.defaultSpeakerIds = data.defaultSpeakerIds;
          vm.state.alLineSpeakerMap = data.alLineSpeakerMap;

          vm.state.vcSpeakerList = data.vcSpeakerList;
          vm.state.typeSpeakerMap = data.typeSpeakerMap;
          vm.state.historySpeakers = historyList || [];
          vm.state.userSpeakerList = data.userSpeakerList;
          let languageList = classificationList['全部语言:specificLanguage'];
          languageList.unshift({
            value: '全部',
            name: '全部',
          });
          vm.state.languageList = languageList;
          this.speakerUtils = new SpeakerUtils({
            allSpeakersMap: data.allSpeakersMap,
            emotionListMap: vm.state.emotionListMap,
          });
          if (!cover){
            this.initAriticleSpeaker(data);
          }
          resolve(null);
        })
        .catch(err => {
          console.log(err, '有错啦err');
          toast('获取发音人失败','top');
        });
    });
  }
  //文章发音人相关处理
  async initAriticleSpeaker(allSpeakerData) {
    
    let vm = this;
    let currentSpeaker = null;
    if (vm.speaker) {
      let speaker = allSpeakerData.userHasSpeakersMap[vm.speaker];
      if (speaker) {
        let defaultSpeaker = speaker;
        currentSpeaker = defaultSpeaker;
      }
    }
    if (vm.articleSepakerId) { 
      if(vm.is3sclone){//3秒克隆的声音-单独查询接口todo
      const [err, resp] = await to(get3sCloneSpeakerById(this.articleSepakerId))
      resp.data.data.speakerFeature = resp.data.data.usableFutures;//该接口字段需要重新处理
      currentSpeaker = resp.data.data;
      }else{
        //若传入了发音人id
        let speaker = allSpeakerData.allSpeakerIdMap[vm.articleSepakerId];
        if (speaker) {
          speaker = speaker.split('@');
          let speakerKey = speaker[0];
          let speakerStyle = speaker[1];
          speakerKey = vm.getDefaultSpeakerKey(speakerKey, allSpeakerData); //兼容meet 和 lpcents
          let defaultSpeaker = allSpeakerData.allSpeakersMap[speakerKey][speakerStyle || 'default'];
          currentSpeaker = defaultSpeaker;
        }
      }

    }
    if (!currentSpeaker) {
      let lastArticleSpeaker = null;
     
      //   优先取上一篇文章的发音人
      if (vm.state.historySpeakers && vm.state.historySpeakers.length > 0) {
        let lastHistorySpeaker = vm.state.historySpeakers[0];
        lastArticleSpeaker = this.getDefault24kSpeaker(lastHistorySpeaker);
        if (lastArticleSpeaker && this.getVoiceStatus(lastArticleSpeaker).owned) {
          currentSpeaker = lastArticleSpeaker;
        }
      }
      // 没有选择发音人,且没有历史发音人，获取可用发音人
      if (!currentSpeaker) {
        // 在全部发音人中查找第一个可用发音人
        const allSpeakerList = vm.state.allSpeakersMap;
        let found = false;
        let keys = Object.keys(allSpeakerList) || []; //所有发音人key
        for (let i = 0; !found && i < keys.length; i++) {
                let speaker = allSpeakerList[keys[i]].default;
                if(speaker){
                    if (this.getVoiceStatus(speaker).owned) {
                        found = true;
                        currentSpeaker = speaker;
                    }
                }
        }
      }
      // 所有发音人都不可用，则还是取近一篇的发音人或者取第一个tab的发音人
      if (!currentSpeaker) {
        if (lastArticleSpeaker) {
          currentSpeaker = lastArticleSpeaker;
        } else {
          currentSpeaker = vm.getFirstSpeaker();
        }
      }
    }
    
    if (currentSpeaker) {
      vm.state.currentSelectSpeaker = currentSpeaker;
    }
    

    console.log('currentSpeaker---',currentSpeaker)
  }
  //获取第一个可用发音人，无则返回第一个发音人
  getFirstSpeaker(){
    let vm = this;
    let currentSpeaker = null;
    const allSpeakerList = vm.state.allSpeakersMap;
    let keys = Object.keys(allSpeakerList) || []; //所有发音人key
    for (let z = 0; z < keys.length; z++) {
      let speaker = allSpeakerList[keys[z]].default;
      if (speaker && speaker['usable']) {
        currentSpeaker = speaker;
        break;
      }
    }
    if(!currentSpeaker){
      let speaker = allSpeakerList[keys[0]].default;
      currentSpeaker = speaker;
    }
    return currentSpeaker;
  }
  //处理historyList-取本体去重
  dealWithHistoryList(res) {
    let list=[];
    res.forEach((item)=>{
      if ((item && item.speaker)){
        let speakerD = item.speaker.split('@')[0];
        list.indexOf(speakerD)<0 && list.push(speakerD) 
      }
    });
    return list;
  }
  // 声音去重
  removeDuplicateVoice(voiceList) {
    const set = new Set(), res = []
    for (let voice of voiceList) {
      if (set.has(voice.speaker)) continue;
      set.add(voice.speaker);
      res.push(voice)
    }
    return res
  }
  // 声音排序
  sortVoice(voiceList) {
    voiceList.sort((a, b) => a.displayOrder - b.displayOrder)
  }

  /**
   * 发音人兼容
   */
  getDefaultSpeakerKey(defaultSpeakerKey: string,allSpeakerData:any) {
    allSpeakerData = allSpeakerData ||this.state;
    if (!allSpeakerData.allSpeakersMap[defaultSpeakerKey]) {
      if (defaultSpeakerKey.indexOf('_meet') != -1) {
        defaultSpeakerKey = defaultSpeakerKey.replace('_meet', '_lpcnet')
      } else {
        defaultSpeakerKey = defaultSpeakerKey.replace('_lpcnet', '_meet')
      }
    }
    return defaultSpeakerKey
  }

  // 获取配音师(默认声音模型)
  getDefault24kSpeaker(key) {
    if (key && typeof key === 'object') key = key.speaker;
    if (!key) return null
    key = key.replace('_48k', '_24k')
    key = this.getDefaultSpeakerKey(key,null)
    return this.state.alLineSpeakerMap[key] || null
  }

  /**
   * 播放音频
   */
  playAudio() {
    this.playStatus = true
    const self = this
    if (!self.state.auditionArr || self.state.auditionArr.length === 0) {
      Toast({
        message: '服务繁忙，请重试',
        icon: 'none',
        duration: 2000,
        position: 'top'
      })
      this.playStatus = false
      this.auditionAudio && this.auditionAudio.pause()
      return
    }
    const index = self.state.auditionIndex
    const data = self.state.auditionArr[index]
    if (data) {
      self.auditionAudio.setSrc(data.src)
      // 根据当前播放事件返回当前索引
      const getCurrentAudioIndex = function () {
        let currentIndex = -1
        return (currentTime: number) => {
          let sentenceList = this.sentenceVos || []
          currentTime = Number(currentTime.toFixed(2))
          let item = null
          sentenceList.forEach((sItem: any, idx: number) => {
            if (
              currentTime >= sItem.startTime &&
              currentTime < sItem.endTime &&
              currentIndex !== idx
            ) {
              currentIndex = idx
              item = sItem
            }
          })
          return item
        }
      }
      try{
        self.auditionAudio.getCurrentAudioIndex = getCurrentAudioIndex.call(data)
      }catch (err){
        toast(err,'top');
        
      }
      
      // self.auditionAudio.src = data.src;
      self.$nextTick(() => {
        self.auditionAudio.play()
      })
    }
  }

  // 获取第一句试听音频
  async __getFirstAuditionUrl(params: any) {
    //设置音量
    params.volume = getArithmeticVolume(this.lastVolumeValue);
    return new Promise(async (resolve, reject) => {
      if (this.state.playId) {
        params.prePlayId = this.state.playId
      }
      try {
        await this.__auditionUrlReq('first', params)
        resolve(true)
      } catch (err) {
        this.auditionAudio.pause()
        this.auditionAudio.setSrc('')
        // this.auditionCountRollback()
        reject()
      }
    })
  }

  // 获取下一句试听音频
  async __getNextAuditionUrl() {
    let params:any = {
      playId: this.state.playId,
      product: this.state.AUDITION_PRODUCT
    }
    try {
      await this.__auditionUrlReq('next', params)
    } catch (err) {
    }
  }

  // 试听
  __auditionUrlReq(type: string, params: any = {}) {
    let reqType = type == 'first' ? 'playFirst' : 'playNext'
    let self = this
    if (type === 'first') {
      this.state.auditionLimit = false
      const index = [params.paragraphIndex, params.sentenceIndex, params.wordIndex]
      this.lastAuditionData = {
        startSentenceVos: [
          {
            startIndex: index,
            endIndex: index
          }
        ]
      }
    }
    return new Promise((resolve, reject) => {
      self
        .$http(reqType, { params: params })
        .then(async (auditionData: any) => {
          if (auditionData.code === 101108 || auditionData.code === 101111) {
            // 试听次数已用完
            self.state.auditionLimit = true
            if (type == 'first') {
              overListenMessage(self)
            }
            reject()
            return
          } else if (auditionData.code === 150003) {
            // 文章格式不符，请重新导入
            toast(auditionData.message, 'top')
            reject()
            return
          }
          this.lastAuditionData = auditionData.data
          // 试听内容已结束
          if (type === 'next' && !auditionData.data) {
            self.state.hasNextAudition = false
          }
          const dataArr: any[] = await self.__getAuditionData(
            auditionData.data || []
          )
          if (dataArr.length > 0) {
            self.state.auditionArr = self.state.auditionArr.concat(dataArr)
          }
          resolve(true)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
  // 试听数据
  __getAuditionData(data: any): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      let auditionArr = []
      if (isObject(data)) {
        this.state.playId = data.playId
        data.src = await this.__resetAudioUrl(data.audioUrl)
        auditionArr.push(data)
      } else if (isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          data[i].src = await this.__resetAudioUrl(data[i].audioUrl)
        }
        auditionArr = data
      }
      resolve(auditionArr)
    })
  }

  // 重新拼写试听接口
  async __resetAudioUrl(url: string) {
    let iosV = this.getIosVersion()
    let iosV2: number = 0
    if (iosV) {
      iosV2 =
        iosV.split('_').length > 2
          ? parseInt(iosV.split('_').join(''))
          : parseInt(iosV.split('_').join('')) * 10
    }
    if (iosV && iosV2 >= 1540 && iosV2 < 1550) {
      if (url.indexOf('/') === 0) {
        return proxyUrl(`/nodetts-apis/tts/audition${url}`)
      } else {
        return proxyUrl(`/nodetts-apis/tts/audition/${url}`)
      }
    }

    return new Promise((resolve, reject) => {
      this.$http('getAudition', {
        body: { url }
      }).then(res => {
        if (res) {
          let url = URL.createObjectURL(res)
          resolve(url)
        } else {
          reject()
        }
      })
    })
  }
  getIosVersion() {
    var str = navigator.userAgent.toLowerCase()
    var ver = str.match(/cpu iphone os (.*?) like mac os/)
    return ver ? ver[1] : false
  }
  // 根据发音人id获取发音人相关map
  __getSpeakerById(speakerId: string) {
    let currentSpeaker: any = {}
    let speakerString = this.state.allSpeakerIdMap[speakerId]
    if (speakerString) {
      currentSpeaker = this.state.alLineSpeakerMap[speakerString]
    }
    return currentSpeaker || {}
  }
  // 根据发音人name获取发音人相关map
  __getSpeakerByName(speakerName: string) {
    let currentSpeaker
    currentSpeaker = this._allSpeakerData.find(
      item => item.name == speakerName && item.speaker.indexOf('48k') === -1
    )
    return currentSpeaker || {}
  }

  __getAudioOssFile(audios: any[]) {
    if (audios.length === 1) {
      return audios[0].ossFile
    }
    const type = 'wav'
    const currentIndex = audios.findIndex(audio => audio.format === type)
    return audios[currentIndex].ossFile
  }

  // tts音频根据ossfile获取链接
  __getAudioUrlByOssfile(ossFileUrl: string) {
    let vm = this
    return new Promise(resolve => {
      vm.$http('getAudioUrl', { ossFile: ossFileUrl }).then(res => {
        if (res.data) {
          vm.state.audioUrl = res.data

          this.__composeAudioCallback()
        }
      })
    })
  }
  getWavDuration(ossFileUrl: string) {
    let self = this
    let url = ossFileUrl
      .replace('synthesis_audio', 'duration')
      .replace('wav', 'json')
    $.getJSON({
      url,
      dataType: 'json',
      //data:{action:'js_type',tid:{$tid},cid:{$cid},ccid:{$ccid}},
      success: function (data) {
        if (data && Array.isArray(data)) {
          self.state.audioDurationInfoPerSentence = data
          let lastP = data[data.length - 1]
          self.duration = lastP[lastP.length - 1].endTime
        }
      },
      error: function (err) {
        console.log(err, 'get---json---err')
      }
    })
  }
  // 试听失败次数回滚
  // auditionCountRollback () {
  //   this.$http("rollbackDemoCount", {})
  // }

  // 获取合成ssml
  compoundAudio() {
    // this.state.isComposed = 'loading';
    // 获取ssml链接
    const params = {
      articleId: this.state.articleId,
      product: this.state.AUDITION_PRODUCT,
      transactionId: this.state.transactionId,
      //是否带水印
      // withWatermark:this.checkboxChecked
    }

    let ssmlUrl = ''
    this.$http('getComposeSsml', params)
      .then(ssmlData => {
        if(ssmlData.code!=200){
          toast(ssmlData.message, 'top')
          this.isClickCompose = true
          return
        }
        ssmlUrl = ssmlData.data
        this.audioComponse(ssmlUrl)
      })
      .catch(err => {
        toast("获取合成信息失败", 'top')
        this.state.isComposed = false
        this.isClickCompose = true
        // this._compoundRollBack()
      })
  }
  // 合成
  audioComponse(ssmlUrl: string) {
    const loading = Toast.loading({
      message: '正在配音中',
      forbidClick: true,
      duration: 0
    })
    let self = this
    // 生成音频和字幕
    let title = this.editor.textContent.slice(0, 10)
    title = title.replace(/\s/g, '_').replace(/[^0-9a-zA-Z\u4e00-\u9fa5]/g, '')
    let params:any = {
        compose_url: encodeURIComponent(ssmlUrl),
        transactionId: this.state.transactionId,
        articleId: this.state.articleId,
        speakerId: this.state.currentSelectSpeaker.id,
        title: title
    }
    //添加音量
    params.volume = getArithmeticVolume(this.lastVolumeValue);
    this.$http('postArticleCompose', {
      body: params
    })
      .then(res => {
        console.log('---res生成音频 h5服务compoundAudiof返回的内容',res)
        if (res.code !== 200) {
          loading.clear()
          this.isClickCompose = true
          let message = res?.message||'配音失败，请稍后再试,code8';
          if(res?.err_code == 40084){
            Dialog.alert({
              confirmButtonText: '确认',
              message: `当前文章检测到有敏感词信息，检测到 "${res.err_sensitive_word}" 等暴力、政治敏感词，请修改后重试。`,
              className: 'pop-confirm pop-alert',
              getContainer: '#page-audition',
              closeOnClickOverlay: true
            })
            .then(() => {

            })
            .catch(() => {
            })
          }else{
            toast(message, 'top')
          }
          // 配音合成失败埋点
          customCollectEvent('editor_compose_result', {
            code: res.code,
            message: res.message || res.msg || '请求失败'
          })
          return
        }
        // 配音合成成功埋点
        customCollectEvent('editor_compose_result', {
          code: '200',
          message: 'success'
        })
        const audioFile = res.data
        // 保存字幕地址
        self.state.subtitleUrl = audioFile.srt_address
        self.state.audioOssFile = audioFile
        self.saveAudio()
      })
      .catch(error => {
        this.isClickCompose = true
        loading.clear()
        // 配音合成失败埋点
        customCollectEvent('editor_compose_result', {
          code: '-1',
          message: ( typeof error === 'string' ? error : error?.message ) || '服务器错误',
        })
      })
  }

  // 分词
  getWords() {
    let vm = this
    return new Promise((resolve, reject) => {
      if (!this.state.content.trim()) {
        if (this.state.articleId) {
          this.onlySaveArticleToServer()
        }
        this.showComposing = false
        toast('请输入文章内容', 'top')
        reject()
        return
      }
      let baseArticleTxt = $deepClone(this.cachedDomJson)
      let diffIndexes = baseArticleTxt.map((ele, index) => {
        // console.log(ele);
        return index
      })
      let requestText = ''
      for (let i = 0; i < diffIndexes.length; i++) {
        const pIndex = diffIndexes[i]
        const sentences = baseArticleTxt[pIndex]
        let aliastxt = '',
          aliasContent = ''
        let text = sentences
          .map(w => {
            // 存在连读标签时添加<cw>标签
            // 存在时添加<cw>标签
            if (w.continuousStart || w.vcStart) {
              return '<cw> '
            } else if (w.continuousEnd || w.vcEnd) {
              return ' </cw>'
            } else {
              if (w.aliasChange) {
                if (w.aliasContent) aliasContent = w.aliasContent
                aliastxt += w.word
              }
              return w.word
            }
          })
          .join('')

        // 存在别名标签时添加<sub>标签
        if (aliastxt) {
          let aliasLabel =
            '<sub alias="' + aliasContent + '">' + aliastxt + '</sub>'
          text = text.replace(aliastxt, aliasLabel)
        }
        if (requestText) {
          requestText = requestText + `\n` + text
        } else {
          requestText = text
        }
      }
      const requestData = {
        result: requestText,
        merge_symbol:((this.symbolMuteChecked&&this.supportAutoMute) || this.state.currentSelectSpeaker.isGpt)?true:false
      }

      this.$http('ttsSplitWord', { body: requestData })
        .then((res: any) => {
          let ttsJson = res.result || []
          vm.mergetts(ttsJson, baseArticleTxt).then((res2: any) => {
            vm.state.articleTxt = res2
          })
          resolve(vm.state.articleTxt)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
  // 保存音频
  saveAudio() {
    let self = this
    if (!(this.state.articleId && this.state.audioOssFile)) {
      // 条件不满足时链路终止，必须恢复合成锁，否则按钮永久失灵
      this.isClickCompose = true
      return
    }
    let data: {
      [key: string]: any
    } = {
      articleId: this.state.articleId,
      format: 'wav',
      ossFile: this.state.audioOssFile.ossFile,
      size: this.state.audioOssFile.size,
      speakerId: this.state.currentSelectSpeaker.id,
      lengthOfTime: this.state.audioOssFile.lengthOfTime
    }

      let formData = new FormData()
      for (let i in data) {
        let value: any = data[i]
        formData.append(i, value)
      }

      this.$http('postArticleOssPath', {
        body: formData
      })
        .then(async (res: any) => {
          this.isClickCompose = true
          if (res.code === 200) {
            self.state.isComposed = true
            Toast({
              message: '合成成功',
              icon: 'none',
              duration: 2000,
              position: 'middle'
            })
            //奇妙元合成完成返回上一级
            if(window.platformSource=='weta365'){
              window.taroRawSdk.miniProgram.postMessage({
                data: { articleId: self.state.articleId,ossUrl: self.state.audioOssFile.ossFile}
              })
              self.$navigateBack();
            }
            await self.saveArticle(false)
            self.state.priceModal = false
            if (this.isDownload) {
              this.download()
              this.isDownload = false
            }
          } else {
            Toast.fail({
              message: '合成失败',
              icon: 'none',
              duration: 2000,
              position: 'middle'
            })
          }
        })
        .finally(() => {
          Toast.clear()
          self.isClickCompose = true
        })
  }

  _genMuteWord() {
    return {
      digital: this.globalMuteTime,
      isMute: true,
      originPinyin: '',
      originRhythm: 0,
      pinyin: '',
      rhythm: 0,
      text_attr: 'space',
      isGlobalMute: true,
      visible: false,
      word: ' '
    }
  }

  // 全局停顿
  checkGlobalMute() {
    this.state.articleTxt.forEach((paragraph, index) => {
      const lastIndex = paragraph.length - 1
      const words = paragraph[lastIndex].originWord
      // 补全段落结尾静音标签
      if (words.length === 1 && !words[0].word && !words[0].isMute) {
        paragraph[lastIndex] = { originWord: [this._genMuteWord()] }
      } else if (words.length > 1 && words[words.length - 1].isMute) {
        let muteData = words.slice(-1)
        paragraph[lastIndex].originWord = JSON.parse(
          JSON.stringify(words.slice(0, -1))
        )
        paragraph.push({ originWord: muteData })
      } else if (!words[0].isMute) {
        paragraph.push({ originWord: [this._genMuteWord()] })
      }
    })
  }
  // 单纯保存文章 dom To server
  async onlySaveArticleToServer() {
    const vm = this
    vm.__getValueToState(this.editor)
    // await vm.getWords()
    this.generateOneTransientData()
    this.checkGlobalMute()
    const isUpdate = vm.state.articleId ? true : false
    vm._baseSaveArticle(isUpdate)
      .then((res: any) => {
        if (!isUpdate) {
          let articleData = res.data
          vm.state.articleId = articleData.articleId
          sessionStorage.setItem('articleId', articleData.articleId)
          if(window.platformSource=='weta365'){
            window.taroRawSdk.miniProgram.postMessage({
              data: { articleId: articleData.articleId}
            })
          }
        }
      })
      .catch(err => {})
  }
  /**
   * @param fn 传入执行函数
   * @param delay 延时时间 默认3s
   */
  timer2 = null
  timer3 = null
  debounce(fn, delay: number = 3000, timer = 'timer') {
    if (this[timer]) {
      clearTimeout(this[timer])
      this[timer] = null
    }
    this[timer] = setTimeout(() => {
      let selectType=window.getSelection().type
      if(selectType=="Range"||$('.range-highlight').length>0){
        this.debounce(fn,delay,timer)
        return
      }
      fn.call(this)
      clearTimeout(this[timer])
      this[timer] = null
    }, delay)
  }

  /**
   * 保存文章并更新页面
   * @param isUpdate
   */
  saveArticle(isUpdate = false) {
    let vm = this
    return new Promise((resolve, reject) => {
      vm._baseSaveArticle(isUpdate)
        .then((res: any) => {
          if (res.code!=200) {
            vm.$toast({
              message: '音频合成错误, 请稍后再试',
              icon: 'none',
              duration: 2000
            })
            reject()
          }
          let articleData = res.data
          if (JSON.parse(articleData.otherJson).compress_type == 1) {
            articleData.ttsJson = pako.inflate(
              base64ToUint8Array(articleData.ttsJson),
              {
                to: 'string'
              }
            )
            res.data.ttsJson = articleData.ttsJson
          }
          if (!isUpdate) {
            vm.state.articleId = articleData.articleId
            sessionStorage.setItem('articleId', articleData.articleId)
            // setQueryString('articleId', data.articleId);
            vm.__renderArticleDetail(res)
            resolve(true)
            /*  vm._getArticleDetail().then((resp) => {
             vm.__renderArticleDetail(resp)
             resolve(true)
           }) */
          } else {
            vm.__renderArticleDetail(res)
            resolve(true)
          }
          vm.getLastSaveTimeStatusChange(articleData.updatedAt)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  /**
   * 获取文章的长度 从content中计算
   * @return {number} 文章长度
   */
  getArticleLength() {
    let content = $('.editor').text()
    if (!content) {
      this.articleLength = 0
      return
    }
    /*   let article = ''
    content.split('').forEach(item => {
      if (reg.test(item)) article += item
    })
    this.articleLength = article.length */
    this.articleLength = this.getFilterWordLen(content)
    // console.log(content,content.length);
    return this.articleLength
  }
  copyEditorText(){
    let content = $('.editor').text().trim()
    if (this.isAPP) {
			let setAppClipBoardContent: any = (<any>window).setAppClipBoardContent
			setAppClipBoardContent.postMessage(content)

		} else {
			copy(content).then(() => {
				toast("内容已复制");
			});
		}
	}
  getFilterWordLen(resultText: string) {
    const foreignPunctuation = /[^\p{L}\p{N}\s]/gu;
    const whitespace = /\s/g;
    const filterWord = resultText.replace(foreignPunctuation, '').replace(whitespace, '');
    return filterWord.length;
  }
  _baseSaveArticle(isUpdate = false) {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    if (!this.state.articleId && !this.state.content) {
      return Promise.reject()
    }
    if (this.articleLength > TXT_MAX_LENGTH) {
      this.editStatusShow = 8
      return Promise.reject()
    }
    let vm = this
    this.checkGlobalMute()
    let compressed = pako.deflate(JSON.stringify(vm.state.articleTxt))
    let base64articleTxt = uint8arrayToBase64(compressed)
    let isFnju = this.supportAutoMute
    return new Promise((resolve, reject) => {
      let data: any = {
        ww_token: vm.state.ww_token,
        subtitleUrl: vm.state.subtitleUrl || '',
        companyId: vm.state.companyId||'',
        author: '',
        title: vm.state.content.slice(0, 10),
        editor: '',
        publishAt: '',
        outLink: '',
        coverImage: '',
        punctuations:JSON.stringify(this.articlePunctuations),
        mergeSymbol:this.symbolMuteChecked&&this.supportAutoMute?'1':'0',
        otherJson: JSON.stringify({
          speed: vm.state.speedSlideVal,
          pitch: vm.state.pitchSlideVal.replace('+', ''),
          emotionWeight: +this.state.emotionWeight || 1,
          speakerId: vm.state.currentSelectSpeaker.id,
          bgmId: this.bgmId?this.bgmId:'',
          volume: 80,
          editedArticle: vm.state.isComposed,
          compress_type: 1,
          globalMuteTime: this.globalMuteTime,
          showGlobalMute: this.showGlobalMute,
          mergeSymbol:this.symbolMuteChecked?'1':'0',
        }),
        bgm: '',
        ttsJson: base64articleTxt,
        contentLength: this.getArticleLength() || 0,
        originContent: vm.state.content,
        pauseMap: 'break_prosody,phrase_prosody'
      }

      let formdata = new FormData()
      for (let key in data) {
        formdata.append(key, data[key])
      }

      let requestMethod = 
      vm.state.articleId?isUpdate
        ? vm.$http('updateSomeArticleDetail', {
            id: vm.state.articleId,
            body: formdata
          })
        : vm.$http('updateArticleDetail', {
            id: vm.state.articleId||"",
            body: formdata
          })
        : vm.$http('saveArticleDetail', {
            id: vm.state.articleId,
            body: formdata
          })

      requestMethod
        .then(res => {
          if (res.code == 150004) {
            if (!vm.state.hasBeenRemind) {
              let message = this.loginInvalIText
              !this.isAPP && Toast(message)
              vm.state.hasBeenRemind = true
              vm.state.isLogined = false
              // setTimeout(() => vm.gotoLogin(), 500)
            }
            reject()
          }
          if (res.code == 200) {
            this.editStatusShow = 2
            resolve(res)
          } else {
            this.editStatusShow = 3
          }
        })
        .catch(err => {
          
          //将ttsJson重新放入页面-toDo
          // vm.renderTryAuditionJsonToDom(base64articleTxt);
          if (err.message.indexOf('timeout') !== -1) {​
            // 请求超时，认为是网络连接失败​
            this.editStatusShow = 3
          } else if (err.message.indexOf('Network Error') !== -1) {​
            // 网络连接失败​
            this.editStatusShow = 3
          } else {​
            // 其他错误​
            this.editStatusShow = 7
          }
          let errTxt:string
          const response = err.response
          if (response && response.data) {
            const { status, message } = response.data
            if (message == "Required String parameter 'wwid' is not present") {
              if (!vm.state.hasBeenRemind) {
                errTxt = this.loginInvalIText
                !this.isAPP && Toast(errTxt)
                vm.state.hasBeenRemind = true
                vm.state.isLogined = false
                // setTimeout(() => vm.gotoLogin(), 500)
              }
            } else if (
              errTxt &&
              errTxt != "Required String parameter 'wwid' is not present"
            ) {
              Toast(errTxt || '服务出错，code1200')
            }
          }
          reject()
        })
    })
  }

  // 合成次数回滚
  _compoundRollBack() {
    this.$toast({
      message: '合成音频失败，请稍后重试！',
      icon: 'none',
      duration: 2000
    })
    this.isClickCompose = true
    this.state.priceModal = false
    this.$http('composeRollback', {
      params: {
        transactionId: this.state.transactionId
      }
    }).then(() => {
      this._getUserVipInfo()
    })
  }

  _getArticleDetail() {
    return new Promise((resolve, reject) => {
      this.$http('getArticleDetail', {
        id: this.state.articleId
      }).then(res => {
        if (res.code == 200) {
          resolve(res)
        } else {
          Toast.fail({
            message: res.message || '获取文章失败',
            position: 'top'
          })
        }
      })
    })
  }

  async __renderArticleDetail(res: any) {
    let self = this
    const articleData = res.data
    const editorData = {
      ttsJson: JSON.parse(articleData.ttsJson),
      otherJson: JSON.parse(articleData.otherJson),
      originContent: articleData.originContent
    }
    let currentSpeaker = self.__getSpeakerById(editorData.otherJson.speakerId)
    if (!currentSpeaker || !currentSpeaker.speaker) {
      currentSpeaker = self.__getSpeakerByName(articleData.speakerName)
    }
    const contentStr = self.__getArticleOriginTxt(editorData.ttsJson)

    const { speed, pitch, globalMuteTime, showGlobalMute, bgmId, emotionWeight } =
      editorData.otherJson
    self.bgmId = bgmId || ""
    self.globalMuteTime = globalMuteTime || '200'
    self.showGlobalMute = showGlobalMute
    self.state.articleTxt = JSON.parse(JSON.stringify(editorData.ttsJson))
    self.state.content = contentStr
    self.state.originContent = contentStr
    self.state.subtitleUrl = articleData.subtitleUrl
    self.state.currentSelectSpeaker = currentSpeaker
    self.state.subtitleUrl = articleData.subtitleUrl
    self.state.originSpeaker = currentSpeaker.speaker
    self.state.originSpeed = editorData.otherJson.speed
    self.state.originPitch = editorData.otherJson.pitch
    self.state.originEmotionWeight = +editorData.otherJson.emotionWeight || 1;
    self.state.isComposed = editorData.otherJson.editedArticle
    self.state.speedSlideVal = speed
    self.symbolMuteChecked = editorData.otherJson.mergeSymbol&&editorData.otherJson.mergeSymbol=='1'?true:false
    if(articleData.mergeSymbol=='1'){
    self.symbolMuteChecked =true
    }
    self.state.pitchSlideVal = pitch + ''
    self.state.emotionWeight = +emotionWeight || 1

    if (this.isTryAudion != 1) {
      self.renderJsonToDom()
    }
    const audios = articleData.audios
    if (audios.length > 0 && editorData.otherJson.editedArticle) {
      self.state.audioOssFile = this.__getAudioOssFile(audios)
      self.__getAudioUrlByOssfile(self.state.audioOssFile)
      self.getWavDuration(self.state.audioOssFile)
    } else {
      self.state.audioUrl = ''
      self.composedAudio = null
    }
    setTimeout(() => {
      self.originRenderContent = self.__getEditorContent()
      self.getArticleLength()
    })
    self.articlePunctuations = JSON.parse(articleData.punctuations)
  }

  // 计时器 自动保存5分钟后改状态
  autoSaveEditStatusChange() {
    if (this.editStatusTimer) {
      clearTimeout(this.editStatusTimer)
    }
    this.editStatusTimer = setTimeout(() => {
      this.editStatusShow = 5
    }, 1000 * 60 * 5)
  }

  // 保存或者获取文章内容状态修改
  getLastSaveTimeStatusChange(time) {
    let timestamp = new Date(time).getTime()
    let nowTimeStamp = new Date().getTime()
    if (nowTimeStamp - timestamp > 1000 * 60 * 60 * 12) {
      this.editStatusShow = 4
      this.lastModifyTime = time
      return
    }
    if (nowTimeStamp - timestamp > 1000 * 60 * 5) {
      this.editStatusShow = 5
      return
    }
    this.autoSaveEditStatusChange()
    this.editStatusShow = 2
  }

  __getEditorContent() {
    let childNodes = Array.prototype.slice.call(this.editor.childNodes || [])
    return childNodes
      .map((node: HTMLElement) => {
        return node.innerHTML
      })
      .join('')
  }

  __getArticleOriginTxt(articleTxt: any[]) {
    let paragraphStr = ''
    articleTxt.forEach(paragraph => {
      paragraph.forEach((sentence: any) => {
        ;(sentence.originWord || []).forEach((word: any) => {
          // debugger
          if (word.word && word.word != ' ') {
            paragraphStr += word.word
          } else if (word.isPlaceHolder) {
            paragraphStr += ' '
          }
        })
      })
      paragraphStr += `\n`
    })
    return paragraphStr
  }
//获取ios是否可以购买 -因为ios现在都是不可以购买，是否可以删除？
//   getArticlePaymentStatus() {
//     this.$http('getPaymentStatus', {}).then(res => {
//       if (res.code === 200) {
//         if (res.data.iOS === 'true') {
//           this.state.canIosBuyVoice = true
//         }
//       }
//     })
//   }

  // 充值vip--TODO
  goRechargeVip() {
    if (this.editer.innerHTML) {
      localStorage.setItem('articleDom', this.editer.innerHTML)
    }
    if (this.isAPP) {
      toBeVip()
    } else {
      this.$navigateTo({
        url: `/pages/recharge-vip/recharge-vip?fromBtn=usePayVoice&ww_token=${this.state.ww_token}`
      })
    }
    
    customCollectEvent('editor_compose_buyvip')
  }

  /**
   * 前往声音商店购买声音
   */
  buyVoice() {
    if (this.isAPP) {
      let param: any = {
        speaker: this.state.currentSelectSpeaker.speaker,
        speakerName: this.state.currentSelectSpeaker.name
      }
      if(this.state.priceData.isTrcVoice){
        let callMoyinAppPay: any = (<any>window).callMoyinAppPay
        callMoyinAppPay.postMessage("3sec")
      }else{
        toVoiceShop(param)
      } 
    } else {
      let currentSpeaker = this.state.currentSelectSpeaker.speaker
      let speakerName = this.state.currentSelectSpeaker.name

      let url = this.state.priceData.isTrcVoice?`/mine-package/pages/buy-word/buy-word?currentTabIdx=1`:`/pages/voice-shop/voice-shop?speaker=${currentSpeaker}&speakerName=${speakerName}&pageType=back&ww_token=${this.state.ww_token}`
      this.$navigateTo({
        url: url
      })
    }
    customCollectEvent('editor_compose_buyvip')
  }

  // 一键升级SVIP
  updateVip() {
    this.$toast.fail({
      message: '部分功能超级VIP可用，请前往“我的”升级超级会员',
      icon: 'none',
      duration: 2000,
      position: 'top'
    })
    // this.$navigateTo({
    //   url: '/pages/recharge-vip/recharge-vip'
    // })
  }
  // updateVip() {
  //   this.$toast({
  //     message: '部分功能超级VIP可用，请前往电脑端将权益一键升级为超级VIP',
  //     icon: 'fail',
  //   });
  // }
  //校验敏感词
  checkSensitiveContent() {
    // 合成全链路在途（含检测通过后的付费/合成/保存过程）时拦截点击，
    // 实现检测通过后到合成结果返回前按钮不可点击
    if (!this.isClickCompose) return
    if (this.sensitiveChecking) return
    this.sensitiveChecking = true
    this.$http('checkSensitive', {
      articleId: this.state.articleId,
      userId: this.state.vipInfo.userId,
      lexiconIdList: "",
      auto: true
    }).then((res: any) => {
      if (res.code == 200 && res.data?.wordAndReplaceList?.length>0) {
        let wordAndReplaceList = res.data.wordAndReplaceList
          this.state.priceModal = false
          this.checkSensitiveDialog(wordAndReplaceList)
          return
      } else {
        this.free()
      }
    }).catch((err: any) => {
      this.free()
    }).finally(() => {
      // 请求结束即复位：检测不通过走弹窗流程到此终止；
      // 检测通过则 free() 已同步置 isClickCompose=false 接管拦截
      this.sensitiveChecking = false
    })
  }

  // 免费合成
  free() {
    let vm = this
    if (!this.isClickCompose) return
    if (!this.state.priceData.freeCount) return
    this.isClickCompose = false
    let loading = Toast.loading({
      message: '加载中',
      mask: true
    })
    this.$http('payForFree', { params: { articleId: this.state.articleId } })
      .then((response: any) => {
        if (response.code == 150004) {
          if (!vm.state.hasBeenRemind) {
            let message = this.loginInvalIText
            !this.isAPP && Toast(message)
            vm.state.hasBeenRemind = true
            vm.state.isLogined = false
            setTimeout(() => vm.gotoLogin(), 500)
          }
          this.isClickCompose = true
          return
        } else if(response.code!=200){
            Toast(response.message)
            this.isClickCompose = true
            return 
        }
        this.state.transactionId = response.data
        this.compoundAudio()
        this._getUserVipInfo()
      })
      .catch(err => {
        this.isClickCompose = true
        loading.clear()
        let errTxt
        const response = err.response
        if (response && response.data) {
          const { code, message } = response.data
          if (
            code === 150004 ||
            message == "Required String parameter 'wwid' is not present"
          ) {
            if (!vm.state.hasBeenRemind) {
              errTxt = code === 150004 ? message : this.loginInvalIText
              !this.isAPP && Toast(errTxt)
              vm.state.hasBeenRemind = true
              vm.state.isLogined = false
              setTimeout(() => vm.gotoLogin(), 500)
            }
          } else if (
            errTxt &&
            errTxt != "Required String parameter 'wwid' is not present"
          ) {
            Toast(errTxt || '服务出错，code1200')
          }
        }
      }).finally(()=>{
        // 注意：此处不恢复 isClickCompose，由合成链路终点恢复锁
        // （compoundAudio/audioComponse/saveAudio 的 then/catch/finally），
        // 避免 payForFree 返回后到合成遮罩弹出前的窗口期可重复触发
        loading.clear()
      })
    
    const articleTxt = this.state.articleTxt
    // 进行一遍循环
    // 需要检查ttsjson的操作都写在这里
    const emotionWeights = [];
    articleTxt.forEach(paragraph => {
      paragraph.forEach(sentence => {
        sentence.originWord.map(word => {
          if (word.emotionWeight) {
            emotionWeights.push(+word.emotionWeight)
          }
        })
      })
    })

    const { name: speakerName, speaker } = this.state.currentSelectSpeaker
    customCollectEvent('editor_compose_confirm', {
      articleid: this.state.articleId,
      type: speaker.indexOf('_48k') !== -1 ? '48k' : '24k',
      speaker_name: speakerName,
      is_pro: speakerName.indexOf('Pro') > -1 ? 1 : 0,
      emotion_weight: +this.state.emotionWeight || 1,
      emotion_weight_speakers: [...new Set(emotionWeights)].sort().join(',')
    })
  }
  
  articleSpeedClick() {
    this.showSpeeds = true
    customCollectEvent("editor_voicepopup", {
      name: "语速选择",
    })
  }
  pitchClick() {
    this.showPitch = true
    customCollectEvent("editor_voicepopup", {
      name: "语调选择",
    })
  }
  // 语速确认
  onSpeedConfirm(value) {
    this.state.isComposed = false
    this.state.speedSlideVal = value
    this.debounce(this.onlySaveArticleToServer)
    customCollectEvent('editor_voicepopup_adjust', {
      type: '语速',
      number: value
    })
  }
  // 语调确认
  onPitchConfirm(value) {
    this.state.isComposed = false
    this.state.pitchSlideVal = value
    this.debounce(this.onlySaveArticleToServer)
    customCollectEvent('editor_voicepopup_adjust', {
      type: '语调',
      number: value
    })
  }

  __getValueToState(editor: any = this.editor) {
    // const childNodes = this.editor.childNodes;
    // console.log(childNodes);

    // childNodes.forEach((childNode: Node) => {
    //   if (childNode.nodeName == '#text') {
    //     let wrapper = document.createElement('div');
    //     wrapper.textContent = childNode.textContent;
    //     this.editor.replaceChild(wrapper, childNode);
    //   }
    // });

    this.cachedDomJson = this._domToDomJSON(editor)

    let content = ''
    this.cachedDomJson.forEach((paragraph: any[]) => {
      if (Array.isArray(paragraph)) {
        paragraph.forEach(item => {
          content +=
            item.isTag &&
            item.wordType !== 'multi-tone' &&
            item.wordType !== 'stress'
              ? ' '
              : item.word
        })
        content += '\n'
      }
    })
    // 如果最后两个字符串是换行符，删除掉多余的
    content = content.replace(/\n+$/, '')
    this.state.content = content
    this.getArticleLength()
    return content
  }

  /**
   * 试听监听
   */
  auditionListen() {
    if (!this.auditionAudio) {
      this.auditionAudio = MAudio.listen({
        ended: () => {
          this.audioEndEvt()
          this.clearHighlightWord()
        },
        pause: () => {
          this.playStatus = false
          this.clearHighlightWord()
        },
        timeupdate: () => {
          if (this.auditionAudio && this.auditionAudio.getCurrentAudioIndex) {
            let time = this.auditionAudio.audio.currentTime
            let item = this.auditionAudio.getCurrentAudioIndex(time)
            if (item) {
              this.highlightWord(item.startIndex, item.endIndex,1)
            }
          }
        },
        error: err => {
          console.log(err)
        }
      })
    }
  }
  //试听
  async audition(isMenu) {
    // if(this.state.currentSelectSpeaker.isGpt){
    //   toast('至臻发音人仅支持合成配音', 'middle')
    //   return 
    // }
    const {gtpSpeakers} = this.getSpeakersOfflineInArticle()
    // if(gtpSpeakers.length> 0){
    //   toast('至臻发音人仅支持合成配音', 'middle')
    //   return 
    // }
    this.showAudio = true
    if (!this.state.isLogined) {
      this.saveArticleToLocal()
      !this.isAPP && toast(this.loginInvalIText)
      setTimeout(() => this.gotoLogin(), 500)
      return
    }

    // 检查替换文中是否存在已下线发音人
    if (!await this.replaceOfflineSpeakers()) {
      return
    }
    this.activeSheetType=""
  // 检查更新智能分句是否支持状态
    this.checkUpdateAutoMute()

    // 校验内容是否为空
    this.__getValueToState()
    if (!this.state.content.trim()) {
      toast('请输入文章内容', 'top')
      return
    }
    if (this.playStatus === true && this.auditionAudio) {
      this.playStatus = false
      this.auditionAudio.pause()
      this.auditionAudio.setSrc('')
      return
    }
    this.auditionListen()
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    this.isTryAudion = 1
    if (this.playStatus == 'loading') {
      return
    }
    this.playStatus = 'loading'
    // debugger
    if (
      this.selectionAddr.anchorNode &&
      this.editor.contains(this.selectionAddr.anchorNode)
    ) {
      this.auditionAction = true
      this.editor.contentEditable = 'true'
      let caret = Dom.make('span', ['oldcaret'])
      this._insertHtmlStringAtCaret(caret.outerHTML)
      this.selectionAddr.anchorNode = $('.oldcaret')[0] //TODO
      this.selectionAddr.anchorOffset = 0
      if (this.isAPP) {
        // this.setFitFocus(//设置获取焦点- iosApp键盘弹出
        //   this.selectionAddr.anchorNode,
        //   this.selectionAddr.anchorOffset,
        //   0
        // )
        var sel
        sel = window.getSelection()
        this.editor.contentEditable = false
        sel.collapse(this.selectionAddr.anchorNode, 0) //--光标在第一个位置闪动
        //在指定位置插入模拟光标
        // this.cursorPosition = SelectionUtils.rect;
        // setTimeout(() => {
        //   this.cursorVisible = true
        // }, 600)
        this.selectionchange()
        this.editor.contentEditable = true
      } else {
       /*  this.setFitFocus(
          this.selectionAddr.anchorNode,
          this.selectionAddr.anchorOffset,
          0
        ) */
        this.blur(false) //--注释调可以看到试听弹框
      }
      this.cursorVisible = false
      setTimeout(() => {
        this.cursorVisible = false
      }, 610)
      // if(document.activeElement instanceof HTMLElement){
      //   document.activeElement.blur()
      // }

      if (!isMenu) {
        this.showBottomNavs = false
        this.showbottomfield = true
      } else {
        if (this.showBottomNavs) {
          this.showBottomNavs = true
          this.showMenuContent = true
          this.showAudio = true
          
        }
      }
      setTimeout(() => {
        this.auditionAction = false
      }, 600)
    }
    try {
      this.__getValueToState()
      await this.getWords()
    } catch (error) {
      this.playStatus = false
      this.$toast({
        message: '分词失败',
        icon: 'fail'
      })
    }
    // this.renderTryAuditionJsonToDom(this.state.articleTxt)
    this.renderJsonToDom()
    let position = this.getCursorPosition(this.state.articleTxt)
    if (!position) {
      position = { p_index: 0, s_index: 0, w_index: 0 }
    } else {
      let { p_index, s_index, w_index } = position
      let articleTxt = this.state.articleTxt
      let lastP = articleTxt.length - 1
      let lastS = articleTxt[lastP].length - 1
      let lastW = articleTxt[lastP][lastS].originWord.length - 1
      if (p_index == lastP && s_index == lastS && w_index == lastW) {
        position = { p_index: 0, s_index: 0, w_index: 0 }
      }
    }

    if (!this.state.content) {
      toast('请输入文章内容', 'top')
      this.playStatus = false
      return
    }

    const contentChanged = this.state.content !== this.state.originContent
    const speakerChanged =
      this.state.currentSelectSpeaker.speaker !== this.state.originSpeaker
    const speedChanged = this.state.speedSlideVal !== this.state.originSpeed
    const pitchChanged = this.state.pitchSlideVal !== this.state.originPitch
    const emotionWeightChanged = this.state.emotionWeight !== this.state.originEmotionWeight

    this.state.auditionIndex = 0
    this.state.auditionArr = []

    try {
      if (contentChanged) {
        await this.getWords()
      }
      if (speakerChanged || speedChanged || contentChanged || pitchChanged || emotionWeightChanged) {
        // const isUpdate = this.state.articleId ? true : false
        await this.saveArticle(false)
      }
      this.state.hasNextAudition = true
      this.getFirstData(position)

      // if (contentChanged) {
      //   this.__getValueToState()
      //   await this.getWords()
      // }
    } catch (error) {
      this.playStatus = false
    }

    const articleTxt = this.state.articleTxt
    // 进行一遍循环
    // 需要检查ttsjson的操作都写在这里
    const emotionWeights = [];
    articleTxt.forEach(paragraph => {
      paragraph.forEach(sentence => {
        sentence.originWord.map(word => {
          if (word.emotionWeight) {
            emotionWeights.push(+word.emotionWeight)
          }
        })
      })
    })

    const { name: speakerName, speaker } = this.state.currentSelectSpeaker
    customCollectEvent('editor_play', {
      articleid: this.state.articleId,
      type: speaker.indexOf('_48k') !== -1 ? '48k' : '24k',
      speaker_name: speakerName,
      is_pro: speakerName.indexOf('Pro') > -1 ? 1 : 0,
      emotion_weight: +this.state.emotionWeight || 1,
      emotion_weight_speakers: [...new Set(emotionWeights)].sort().join(',')
    })
  }
  async getFirstData(position) {
    // 获取第一个试听文件 && 获取playId

    let requestData = {
      articleId: this.state.articleId,
      paragraphIndex: position.p_index,
      sentenceIndex: position.s_index,
      wordIndex: position.w_index,
      product: this.state.AUDITION_PRODUCT
    }
    try {
      await this.__getFirstAuditionUrl(requestData)
      // toast.clear()
      // 播放音频
      this.playAudio()
      // 音频播放时获取下一个试听文件
      this.__getNextAuditionUrl()
    } catch (error) {
      console.log(error, 'trylisten-error')
      //播放器状态恢复
      this.playStatus = false
    }
  }
  //获取光标位置
  getCursorPosition(articleTxt: Array<any>) {
    let position = null
    try {
      articleTxt.forEach((paragraph, p_index) => {
        paragraph.forEach((sentence, s_index) => {
          sentence.originWord.forEach((word, w_index) => {
            if (word.isCaret) {
              position = { p_index, s_index, w_index }
              throw new Error('循环结束')
            }
          })
        })
      })
    } catch (error) {
      return position
    }

    return position
  }

  // 获取最后一个字的索引
  getLastWordPosition(articleTxt: Array<any>) {
    try {
      const p_index = articleTxt.length - 1
      const s_index = articleTxt[p_index].length - 2 // 跳过段尾静音
      const w_index = articleTxt[p_index][s_index].originWord.length - 1
      return { p_index, s_index, w_index }
    } catch {}
    return null
  }

  // 获取当前全部的发音人，包含全局发音人和文章中发音人
  getAllSpeakers() {
    const multiSpeakers = $('.multiSpeakerStart').toArray(), dealed = new Set()
    const allSpeakers = []
    allSpeakers.push(this.state.currentSelectSpeaker)
    dealed.add(this.state.currentSelectSpeaker.speaker)
    for (let node of multiSpeakers) {
      const speaker = node.dataset.speaker
      if (dealed.has(speaker)) continue
      dealed.add(speaker)
      const speakerInfo = this.speakerUtils.getSpeakerBySpeaker(speaker)
      if (speakerInfo) {
        allSpeakers.push(speakerInfo)
      }
    }
    return allSpeakers.map(speaker => {
      return {
        ...speaker,
        is48k: this.speakerUtils.is48k(speaker.speaker)
      }
    })
  }
  // 获取所有不支持智能分句的人
  getSpeakersNotSupportAutoMute(){
    return this.getAllSpeakers().filter(speaker => !this.isSpeakerSupportAutoMute(speaker))
  }

  // 发音人未拥有
  isSpeakerNotOwned(speaker) {
    return !this.getVoiceStatus(speaker).owned
  }
  
  // 获取文章中需要单独购买的多发音人
  getMultiSpeakerNotOwnedInArticle(startIndex: [number, number, number] = null) {
    let speakers = null;
    if (startIndex) {
      const [pIndex, sIndex, wIndex] = startIndex
      const startNode = $(`span[data-idx="${pIndex}-${sIndex}-${wIndex}"]`)
      speakers = $(selectNextNodeAll(startNode, '.multiSpeakerStart')).toArray()
    } else {
      speakers = $('.multiSpeakerStart').toArray()
    }
    for (let node of speakers) {
      const speakerId = node.dataset.speakerid
      const speaker = this.speakerUtils.getSpeakerById(speakerId)
      if (this.isSpeakerNotOwned(speaker)) {
        return speaker
      }
    }
    return null
  }

  // 获取文章中需要购买的发音人
  getSpeakerNotOwnedInArticle(startIndex: [number, number, number] = null) {
    // 全局发音人是否已经单独购买
    if (this.isSpeakerNotOwned(this.state.currentSelectSpeaker)) {
      return this.state.currentSelectSpeaker
    }
    return this.getMultiSpeakerNotOwnedInArticle(startIndex)
  }

  // 获取文章中已下线的发音人 gpt发音人
  getSpeakersOfflineInArticle() {
    const offlineSpeakers = [],gtpSpeakers=[]
    const speakers = $('.multiSpeakerStart').toArray(), dealed = new Set()
    for (let node of speakers) {
      const speaker = node.dataset.speaker
      if(dealed.has(speaker)) continue
      dealed.add(speaker)
      const name = node.dataset.speakername
      const speakerInfo:any = this.speakerUtils.getSpeakerBySpeaker(speaker)
      if (!speakerInfo) {
        offlineSpeakers.push({
          name,
          speaker
        })
      }
      if(speakerInfo?.isGpt){
        gtpSpeakers.push({
          name,
          speaker
        })
      }
    }
    return {speakersOffline: offlineSpeakers, gtpSpeakers}
  }

  /**
   * 替换文中已经下线的发音人
   * @returns true 替换成功 false 替换失败
   */
  async replaceOfflineSpeakers(): Promise<boolean> {
    const {speakersOffline} = this.getSpeakersOfflineInArticle()
    if (speakersOffline.length > 0) {
      try {
        await offlineSpeakerMessage(speakersOffline)
        const defaultSpeaker = this.state.baseDefaultSpeaker // 下线发音人替换为基础默认发音人
        speakersOffline.forEach(({ speaker }) => {
          let selector = []
          for (let clazz of ['multiSpeaker', 'multiSpeakerInner']) {
            for (let pos of ['Start', 'End']) {
              selector.push(`.${clazz}${pos}[data-speaker="${speaker}"]`)
            }
          }
          $(selector.join(',')).each((index, node) => {
            Object.entries({
              speakerName: defaultSpeaker.name,
              speakerName2: defaultSpeaker.name.split("|")[0],
              speakerId: defaultSpeaker.id,
              gender: defaultSpeaker.gender,
              speaker: defaultSpeaker.speaker,
              speakerSource: defaultSpeaker.source,
            }).forEach(([key, value]) => {
              node.setAttribute(`data-${key}`, value)
            })
          })
        })
        return true
      } catch (e) {
        // cancel 点击取消中断流程
        return false
      }
    }
    return true
  }

  // 获取当前试听过程中试用结束的发音人
  getSpeakerRunOutInTrial() {
    let sentenceVos = null
    let startIndex = null
    if (Array.isArray(this.lastAuditionData) && this.lastAuditionData.length > 0) {
      sentenceVos = this.lastAuditionData[this.lastAuditionData.length - 1].sentenceVos
    } else if (this.lastAuditionData?.sentenceVos) {
      sentenceVos = this.lastAuditionData.sentenceVos
    } else if (this.lastAuditionData?.startSentenceVos) {
      sentenceVos = this.lastAuditionData.startSentenceVos
    }
    if (sentenceVos) {
      startIndex = sentenceVos[sentenceVos.length - 1].endIndex
    }
    return this.getSpeakerNotOwnedInArticle(startIndex)
  }

  /**
   * 合成
   * @param type download 表示用户点击下载进入的方法
   */
  async compose() {
    let vm = this;
    //抖音内容安全检测
    if(localStorage.getItem('platform') == 'tt'){
      let res2 = await vm.$http('checkContent',{ 
          body:{
            "content":vm.state.content
          }
      });
      if(res2.err_code==-1){//抖音校验内容失败
        toast(`${res2.err_msg}`, 'top');
      }
      if(res2.data.predicts[0].hit){//违规
        toast('文章内容包含违规词', 'top')
        return ;
      }
    }
    
    if (!this.state.isLogined) {
      this.saveArticleToLocal()
      !this.isAPP && toast(this.loginInvalIText)
      setTimeout(() => this.gotoLogin(), 500)
      return
    }
    this.isTryAudion = 0

    // 检查替换文中是否存在已下线发音人
    if (!await this.replaceOfflineSpeakers()) {
      return
    }

    // 检查更新智能分句是否支持状态
    this.checkUpdateAutoMute()
    
    // 检查内容是否为空
    this.__getValueToState(this.editor)
    if (!this.state.content.trim()) {
      if (this.state.articleId) {
        this.onlySaveArticleToServer()
      }
      toast('请输入文章内容', 'top')
      return
    }
    //判断那内容 发音人 语速语调是否发生改变 
    const contentChanged = this.state.content !== this.state.originContent
    const speakerChanged =
      this.state.currentSelectSpeaker.speaker !== this.state.originSpeaker
    const speedChanged =  this.state.speedSlideVal !== this.state.originSpeed
    const pitchChanged =  this.state.pitchSlideVal !== this.state.originPitch
    const emotionWeightChanged = this.state.emotionWeight !== this.state.originEmotionWeight
    // this.state.isComposed ='loading';
    let source =this.$getUrlKeyWord('source');
    if (!this.isDownload) {
      this.showComposing = true
    }
    try {
      //内容改变 分词
      if (contentChanged) {
        await this.getWords()
      }
      //发音人内容改变 重新保存文章
      if (speakerChanged || speedChanged || contentChanged || pitchChanged || emotionWeightChanged) {
        // const isUpdate = this.state.articleId ? true : false
        await this.saveArticle(false)
      }
      if(window.platformSource != 'weta365'){
        let res:any =  await this._getArticlePrice();
        if(res.data){
          vm.state.priceData = res.data;
        }
        if(vm.state.priceData){
          let notVip = this.state.vipInfo && (this.state.vipInfo.type == VIP_TYPE.FREE || this.state.vipInfo.type == VIP_TYPE.COMPANY);
          //非3秒克隆发音人，非会员 提示充值会员
          if(!vm.state.priceData.isTrcVoice && notVip){
            this.buyVoiceTipVisible = true
            return;
          }
        }
      }
        // 检查文章中多发音人是否拥有
        const speakerNotOwned = this.getSpeakerNotOwnedInArticle()
        if (speakerNotOwned) {
          this.state.selectPaySpeaker = speakerNotOwned
          if (this.state.vipInfo.type === VIP_TYPE.TRIAL) {
              // 体验会员 使用未拥有声音
              this.trialVipTipVisible = true
          } else {
              this.state.buyVoicePopupVisible = true
          }
          return
        }
        if(window.platformSource=='weta365'){
            this.cursorVisible = false
            this.showComposing = false  
        }else{
            //配音清单
            this.state.priceModal = true
        }
    } catch(e) {
      console.log(e);
      
      this.showComposing = false
    }

    if(window.platformSource=='weta365'){
      this.free();
    }
  }
 localStorageSet (name, data)  {
    const obj = {
        data,
        expire: new Date().getTime() + 1000 * 60 * 60 * 2
    };
    localStorage.setItem(name, JSON.stringify(obj));
}
//读取缓存
localStorageGet(name) {
  const storage = localStorage.getItem(name);
  const time = new Date().getTime();
  let result = null;
  if (storage) {
      const obj = JSON.parse(storage);
      if (time < obj.expire) {
          result = obj.data;
      } else {
          localStorage.removeItem(name);
      }
  }
  return result;
}
  // 下载
  download() {
    let vm = this
    let wwid = localStorage.getItem("wwid");
    //添加埋点
    customCollectEvent?.('editor_download',{
      button:'下载',
      source:'wx',
      user_id:wwid||''
    })
    //token校验
    this.gotoDownloadPage()
  }
  gotoDownloadPage() {
    if (!this.state.isComposed) {
      // this.$toast({
      //   icon: "none",
      //   message: "请先合成",
      // })
      this.isDownload = true
      this.compose()
      return
    }
    if (this.isAPP) {
      let OpenDownloadAudioPage: any = (<any>window).OpenDownloadAudioPage
      let param: string = JSON.stringify({
        articleId: this.state.articleId,
        audioLink: this.state.audioOssFile,
        videoName: this.editor.textContent.slice(0, 11)
      })
      OpenDownloadAudioPage.postMessage(param)
    } else {
      let baseUrl= '/mine-package'
      let url = `${baseUrl}/pages/download/download?articleId=${this.state.articleId}&companyId=${this.state.companyId}&ossFile=${this.state.audioOssFile}&ww_token=${this.state.ww_token}`
      this.$navigateTo({
        url
      })
    }
  }

  // 播放合成音频
  composedAudioStatus = 0
  composedAudio = null
  progress: number = 0
  duration: number = 1 // 默认1s 防止滑块在最右边，初始化加载从音频对应的json中获取总时长
  beforeDragStatus: number = 0
  // 非合成状态清空audio
  @Watch('state.isComposed')
  watchComposed(val: boolean) {
    if (!val) {
      this.composedAudio.pause()
      this.composedAudio = null
    }
  }
  __composeAudioCallback() {
    if (!this.composedAudio) {
      this.progress = 0 // 清空进度条进度
      this.composedAudio = MAudio.listen({
        play: () => {
          this.composedAudioStatus = 1
          this.cursorVisible = false
        },
        pause: () => {
          this.composedAudioStatus = 0
          this.$nextTick(() => {
            this.clearHighlightWord()
          })
        },
        timeupdate: () => {
          this.progress = this.composedAudio.currentTime
          let paragraphIndex = 0
          paragraphIndex =
            this.progress === 0
              ? 0
              : this.state.audioDurationInfoPerSentence.findIndex(val => {
                  let lastSentence = val[val.length - 1]
                  return (
                    this.progress >= val[0].startTime &&
                    this.progress < lastSentence.endTime
                  )
                })
                if(this.state.audioDurationInfoPerSentence.length==0){
                  return
                }
                let sentenceIndex = this.state.audioDurationInfoPerSentence[
                  paragraphIndex
                ].findIndex(
                  val => this.progress >= val.startTime && this.progress <= val.endTime
                )
                this.highlightWord(
                  [paragraphIndex, sentenceIndex, 0],
                  [paragraphIndex, sentenceIndex, 0],
                  1
                )
        },
        setSrcCallback: () => {
          this.duration = this.composedAudio.duration
        },
        ended: () => {
          this.composedAudioStatus = 0
          this.progress = 0
          this.$nextTick(() => {
            this.clearHighlightWord()
          })
        }
      })
      this.composedAudio.setSrc(this.state.audioUrl)
    }
  }
  get currentTime() {
    return this.transformTimeFormat(this.progress)
  }
  get totalTime() {
    return this.transformTimeFormat(this.duration)
  }
  // 拖动进度条 停止播放 防止timeupdate会设置进度条的位置，会产生进度条跳动
  dragStart() {
    this.beforeDragStatus = this.composedAudioStatus
    if (!this.beforeDragStatus) return
    this.playComposedAudio()
  }
  // 拖动结束 设置进度条继续播放
  dragEnd() {
    this.setProgress()
    if (!this.beforeDragStatus) return
    this.playComposedAudio()
  }
  setProgress() {
    let { composedAudio } = this
    if (composedAudio) {
      composedAudio.setCurrentTime(this.progress)
    }
  }
  /**
   * @param {number} time 传入时间单位s
   * @return {string} 时间字符串
   */
  transformTimeFormat(time?: number) {
    if (time < 1) {
      return '00:00'
    }
    time = Math.floor(time)
    let min = Math.floor(time / 60)
    let second = time % 60
    return `${min < 10 ? '0' + min : min}:${
      second < 10 ? '0' + second : second
    }`
  }
  playComposedAudio() {
    if (!this.composedAudio) return
    if (this.composedAudioStatus == 0) {
      this.$nextTick(() => {
        this.composedAudio.play()
      })
    } else {
      this.composedAudio.pause()
    }
  }

  closePauseContent() {
    this.showPause = !this.showPause
  }
  //选择多音字拼音
  changeMutilTone(e: any) {
    if (this.playStatus) {
      toast('请点击内容区域，指定效果位置进行设置', 'top')
      this.__resetArticleStatus()
      return
    }
    let self = this
    let idx = e.currentTarget.dataset.index
    let mutilToneObjs = this.mutilToneObjs
    let obj = null

    mutilToneObjs.map((item: any, index: any) => {
      item.checked = false
      if (idx == index) {
        obj = item
        item.checked = true
        self.pinyin = item.name
      }
    })
    self.mutilToneObjs = mutilToneObjs
    if (this.tagElement) {
      this.tagElement.setAttribute('data-value', self.pinyin)
      this.tagElement.setAttribute('data-source', obj.dataSource)
    } else {
      //插入拼音
      let range = this.selection.savedSelectionRange.cloneRange()
      let tone = ''
      let toneActive = document.querySelector('.toneActive')
      let toneNode: HTMLElement = toneActive.firstChild as HTMLElement
      if (
        toneNode &&
        toneNode.nodeName !== '#text' &&
        (toneNode.getAttribute('data-type') === 'stress-tone' ||
          toneNode.getAttribute('data-type') === 'stress')
      ) {
        toneNode.className = 'tag tone-item'
        toneNode.setAttribute('data-value', self.pinyin)
        toneNode.setAttribute('data-source', JSON.stringify(obj))
        toneNode.setAttribute('data-type', 'stress-tone')
        this.tagElement = document.querySelector('.toneActive')
          .childNodes[0] as HTMLElement
      } else {
        tone = `&nbsp;<span class="tone-item tag" data-type="tone" data-value="${
          self.pinyin
        }" data-source=${JSON.stringify(obj)} contentEditable="false">${
          self.wordText
        }</span>&nbsp;`
        document.querySelector('.toneActive').innerHTML = tone
        this.tagElement = document.querySelector('.toneActive')
          .childNodes[1] as HTMLElement
      }
      let node2 = document.querySelector('.toneActive').childNodes[0]
      let node3 = document.querySelector('.toneActive').childNodes[2]
      document
        .querySelector('.toneActive')
        .parentNode.insertBefore(node2, document.querySelector('.toneActive'))

      this.selectionAddr.anchorNode = node2
      this.selectionAddr.anchorOffset = 1
      setTimeout(() => {
        this.setFitFocus(
          this.selectionAddr.anchorNode,
          this.selectionAddr.anchorOffset,
          0
        )
        this.cursorPosition = SelectionUtils.rect
      }, 100)
      document.querySelector('.toneActive').remove()
      node2.parentNode.insertBefore(this.tagElement, node2)
      if (node3) {
        node2.parentNode.insertBefore(node3, this.tagElement)
      }
    }
    /* this.selection.clearSaved();
    this.mutilToneObjs = []; */
    // this.showMutilTone = false
    this.__resetArticleStatus()
    this.debounce(this.onlySaveArticleToServer)
    customCollectEvent('editor_tools_use', {
      type: '多音字'
    })
  }

  // 打开操作面板
  openSheet(type) {
    const handler = getEffectHandler(type)
    console.log('打开操作面板',handler)
    if (
      handler &&
      handler.beforeSheetOpen &&
      !handler.beforeSheetOpen(this, this.lastSelection)
    ) {
      // beforeSheetOpen返回false，阻止面板打开
      return
    }
    this.activeSheetType = type
    this.addHighlightSelection()
    // 显示菜单
    this.showMenuContent = true
  }
  addHighlightSelection(selecion=this.lastSelection){
       // to refact
       if(!selecion.range){
          return this.blur()
        }
       if ($('.range-highlight').length == 0) {
        // ios添加高亮
        highlightSelection(selecion)
        let $highlight = $('.range-highlight')
        let prevNode = $highlight.prev()
        if (
          prevNode.text() == '' &&
          $highlight.find('span').first().attr('data-idx') ==
            prevNode.attr('data-idx')
        ) {
          prevNode.remove()
        }
        let nextNode = $highlight.next()
        if (
          nextNode.text() == '' &&
          $highlight.find('span').last().attr('data-idx') ==
            nextNode.attr('data-idx')
        ) {
          nextNode.remove()
        }
        if ($highlight.length > 0) {
          let range = new Range()
          range.setStart($highlight[0], 0)
          let endNode = $highlight[$highlight.length - 1]
          range.setEnd(endNode, endNode.childNodes.length)
          range = this.changeRange(range)
          this.updateLastRange(range)
          this.selection.savedSelectionRange = range
        }
        if(!this.showBottomAixiaomo){
          setTimeout(()=>{
            if(!isOverlapped($highlight[0])){
              this.caretBlur($highlight[0])
            }
          },100)
        }
     
        // 显示假光标到选区后面
        this.setFakeCaretAfter($highlight.get($highlight.length - 1))
      }
  }
  caretBlur(dom: any = null, flag = false) {
    if (dom) {
      setTimeout(() => {
        if (!isOverlapped(dom) || flag) {
          dom.scrollIntoView()
          this.editor.scrollTop = this.editor.scrollTop - 100
          this.cursorPosition = SelectionUtils.rect
        }
      }, 700)
      // return
    } else if (this.sectionType == 'Caret') {
      setTimeout(() => {
        if (!isOverlapped(this.selectionAddr.anchorNode) || flag) {
          this.selectionAddr.anchorNode.parentElement.scrollIntoView()
          this.editor.scrollTop = this.editor.scrollTop - 100
          this.cursorPosition = SelectionUtils.rect
        }
      }, 700)
      if(this.editor.textContent.length>0){
        setTimeout(() => {
          this.cursorVisible = true
        }, 500)
      }
     
    } else {
      let range = this.lastSelection.range || this.lastSelection.caret
      if (range && range.startContainer) {
        let startNode = range.startContainer.parentElement
        setTimeout(() => {
          if ($('.range-highlight').length >= 1) {
            startNode = $('.range-highlight')[0]
          }
          if (!isOverlapped(startNode) || flag) {
            startNode.scrollIntoView()
            this.editor.scrollTop = this.editor.scrollTop - 100
            this.cursorPosition = SelectionUtils.rect
          }
        }, 700)
      }
    }
  }
  highLightRemove() {
    // ios清除假滑选
    const replacedNodes = clearHighlightSelection()
    if (replacedNodes && replacedNodes.length > 0) {
      // 显示假光标到选区后面
      this.setFakeCaretAfter(replacedNodes[replacedNodes.length - 1])
    }
  }
  // 调整编辑器内多音字显隐
  async onOriginPinyinVisibleChange(value) {
    // 插入假光标到节点中，从而在dom和json来回转换后记住转换前光标到位置
    if (this.selectionAddr.anchorNode) {
      const caret = Dom.make('span', ['oldcaret'])
      this._insertHtmlStringAtCaret(caret.outerHTML)
      this.selectionAddr.anchorNode = $('.oldcaret')[0] //TODO
      this.selectionAddr.anchorOffset = 0
    }

    // 重新分词获得带有多音字拼音的articleText
    this.__getValueToState()
    await this.getWords()
    // 更新后再翻转按钮状态，防止快速连续点击
    this.originPinyinVisible = value
    // 重新渲染
    this.renderJsonToDom()

    // 重新渲染，要更新代码中引用的dom节点，自定义多音字节点，更新lastSelection.el
    const updateEl = prev => {
      if (this.lastSelection.el) {
        if ($(prev).is('.effect-multi-tone[data-value]')) {
          this.updateLastEl(prev)
        } else {
          console.log('正常情况不会走入此分支')
        }
      } else {
        // 更新选区，仅仅选中光标前面的内容
        this.removeLastRange()
        const newRange = document.createRange()
        newRange.selectNode(prev)
        newRange.collapse()
        this.updateLastRange(newRange)
      }
    }

    // 重新获取光标位置，注意getCursorPosition函数获取到的是光标后面的节点
    let position = this.getCursorPosition(this.state.articleTxt)
    if (position) {
      // 设置光标位置到前面
      let node = this.getWordNodeAt(position)
      if (node) {
        // 跳过前面的空格
        const prev = node.previousSibling
        if (prev && prev.nodeType === 3 && prev.textContent.trim() === '') {
          node = prev
        }
        this.setFakeCaretBefore(node)
        updateEl(node.previousSibling)
      }
    } else {
      // 光标定位到最后位置
      position = this.getLastWordPosition(this.state.articleTxt)
      if (position) {
        // 获取最后的word节点
        let node = this.getWordNodeAt(position)
        if (node) {
          // 后面没有空格，则主动插入空格
          const next = node.nextSibling
          if (!next || (next.nodeType === 3 && next.textContent.length === 0)) {
            $(node).after(document.createTextNode(NBSP_TEXT))
          }
          this.setFakeCaretAfter(node)
          updateEl(node)
        }
      }
    }
  }

  /**
   * 分词后，获取指定位置的word节点
   * @param position 位置
   * @param outEffect 是否跳出特效
   * @returns
   */
  getWordNodeAt(position, outEffect = true) {
    let $node = $(
      `span[data-idx="${position.p_index}-${position.s_index}-${position.w_index}"]`
    )
    // 是否跳出特效节点
    if (outEffect && $node.parents('.isTag').get(0)) {
      $node = $node.parents('.isTag')
    }
    return $node.get(0) || null
  }

  /**
   * 选择重读方式
   * @param e
   */
  changeStress(e: any) {
    if (this.playStatus) {
      this.$toast({
        message: '请点击内容区域，指定效果位置进行设置',
        position: 'top'
      })
      this.__resetArticleStatus()
      return
    }
    let idx = e.currentTarget.dataset.index
    let stressData = this.rangeSelection?.data
    let stressActive = document.querySelector('.stressActive')

    let obj = null
    if (idx == 1) {
      // 选择默认的时候移除重读
      // if (stressActive) {
      //   stressActive.className = ''
      // }
      this.removeStress(idx)
    } else {
      if (this.isAPP) {
        if (
          !stressActive &&
          this.rangeSelection.anchorOffset != this.rangeSelection.focusOffset
        ) {
          this.replaceSelectedStrByEle('span', 'stressActive')
        }
        if (
          this.rangeSelection.anchorOffset == this.rangeSelection.focusOffset
        ) {
          if (stressActive) {
            stressActive.className = ''
          }
          this.rangeSelection = {}
          this.$toast('请选择需要设置的字符')
          return
        }
      } else {
        if (!stressActive && stressData && stressData.length) {
          this.replaceSelectedStrByEle('span', 'stressActive')
        }
        if (!stressData || stressData.length < 1) {
          if (stressActive) {
            stressActive.className = ''
          }
          this.rangeSelection = {}
          this.$toast('请选择需要设置的字符')
          return
        }
      }
      let time = Date.parse(new Date() + '')
      let wordDom = ''
      let stressDomList = stressActive.childNodes || []
      if (stressDomList && stressDomList.length) {
        let _stressDomList = Array.from(stressDomList).slice(0)
        if (_stressDomList && _stressDomList.length) {
          let flag = _stressDomList.some(item => {
            return (
              item.nodeName !== '#text' &&
              item.getAttribute('data-type') == 'stress'
            )
          })
          if (flag) {
            this.insertStress(_stressDomList, stressActive)
            this.rangeSelection = {}
            this.$toast('重读不能重复设置')
            return
          }
        }
        // 处理获取选中内容
        let text = this.getTextContent(stressDomList)

        if (text.length > 10) {
          if (stressActive) {
            this.removeStressActive()
          }
          this.rangeSelection = {}
          toast('重读不能连续超过10个字', 'top')
          return
        }

        let reg = /^[\u4e00-\u9fa5 ]+$/i
        if (!reg.test(text)) {
          if (stressActive) {
            this.removeStressActive()
          }
          this.rangeSelection = {}
          toast('添加重读的文本不得跨句或含有非中文字符', 'top')
          return
        }
        this.stressObj = this.stressObj.map((item, index) => {
          item.checked = false
          if (idx == index) {
            this.stress = item.name
            item.checked = true
          }
          return item
        })
        // 处理重读
        wordDom = this.handleStress(stressDomList, time, obj)
      }
      // <span class="stress-title-close isTag" data-type="stress-close" data-stresshover="${time}"></span>
      //插入
      let stressDom = `&nbsp;<span class="icon-features-read icon-features-start isTag" data-stresshover="${time}" contentEditable="false" data-type="stress-read" data-read="startStressRead"></span>${wordDom}<span class="icon-features-read" contentEditable="false" data-type="stress-read" data-stresshover="${time}" data-read="endStressRead"></span>&nbsp;`
      document.querySelector('.stressActive').innerHTML = stressDom
      // this.tagElement = document.querySelector(".stressActive")
      //     .childNodes[1] as HTMLElement
      let stressChildrenNodes =
        document.querySelector('.stressActive').childNodes
      let _stressChildrenNodes = Array.from(stressChildrenNodes).slice(0)
      let node =
        document.querySelector('.stressActive').childNodes[
          stressChildrenNodes.length - 1
        ]
      this.insertStress(_stressChildrenNodes, stressActive)

      this.selectionAddr.anchorNode = node
      this.selectionAddr.anchorOffset = 1
      setTimeout(() => {
        this.setFitFocus(
          this.selectionAddr.anchorNode,
          this.selectionAddr.anchorOffset,
          0
        )
        this.cursorPosition = SelectionUtils.rect
      }, 100)
      this.stresshover = time
    }
    this.rangeSelection = {}
    this.__resetArticleStatus()
    this.__mockCustomCaret()
    this.debounce(this.onlySaveArticleToServer)
    customCollectEvent('editor_tools_use', {
      type: '重读'
    })
  }

  // 获取选区文本
  getRangeText(range) {
    return this.getNodeText(range.cloneContents()).trim()
  }
  // 获取节点中文本
  getNodeText(node) {
    let nodes = [node], text = ''
    while (nodes.length) {
      const node = nodes.shift()
      if (node.className?.indexOf('ignore') >= 0) continue
      if (node.nodeType === 3) {
        text += node.textContent
      } else if (node.nodeType === 1 || node.nodeType === 11) {
          node.childNodes.forEach(ele =>{
            let nodeText=this.getNodeText(ele)
            if(nodeText.trim()){
              text=text+'\n'+nodeText
            }
        })
      }
    }
    return text.trim()
  }

  // 更新上次滑动选中的选区域
  updateLastRange(range: Range) {
    if (range.toString()) {
      // range只记有内容的滑选
      this.lastSelection.range = range
      this.lastSelection.rangeText = this.getRangeText(range)
      this.lastSelection.isRangeMixed = this.isRangeMixed(range)
      // range有内容时 清除el
      this.updateLastEl(null)
    } else {
      // caret只记光标
      this.lastSelection.caret = range
    }
    // 获取光标前面的字
    this.lastSelection.wordRangeBeforeCaret = null
    this.lastSelection.wordTextBeforeCaret = ''
    if (!range.toString()) {
      // 折叠的
      const startContainer = range.startContainer
      const startOffset = range.startOffset
      if (startOffset > 0) {
        // dom情况1
        // <div>「啊|我吗」</div>
        // dom情况2 安卓下range
        // <div「><span>啊</span>|我吗<」/div>
        const wordRange = range.cloneRange()
        wordRange.setStart(startContainer, startOffset - 1)
        wordRange.setEnd(startContainer, startOffset)
        if (wordRange.toString().trim()) {
          // 光标前面有字
          this.lastSelection.wordRangeBeforeCaret = wordRange
          this.lastSelection.wordTextBeforeCaret = wordRange.toString()
        }
      } else {
        // 容器的第一个文字
        // dom情况2 ios下range
        // <div><span>啊</span>「|我吗」</div>
        const prevNonEmptyNode = getPrevSiblingNonEmptyNode(
          range.startContainer
        )
        if (prevNonEmptyNode) {
          const wordRange = document.createRange()
          wordRange.selectNode(prevNonEmptyNode)
          const wordText = wordRange.toString()
          if (wordText && wordText.trim() && wordText.length === 1) {
            this.lastSelection.wordRangeBeforeCaret = wordRange
            this.lastSelection.wordTextBeforeCaret = wordRange.toString()
          }
        }
      }
    }
  }
  // 删除上次滑动选中的选区域，聚焦时清空，处理边界情况
  removeLastRange() {
    this.lastSelection.range = null
    this.lastSelection.rangeText = ''
    this.lastSelection.isRangeMixed = false
    // ios清除高亮
    clearHighlightSelection()
  }
  // 更新上次点击选中的节点
  updateLastEl(el) {
    this.lastSelection.el = el || null
    this.lastSelection.elText = el
      ? [...el.querySelectorAll('.wc')].map(item => item.textContent).join('')
      : ''
    this.lastSelection.isElMixed = this.isElMixed(el)
    this.selectedEffectValue = el ? el.getAttribute('data-value') : ''
  }
  // 是否节点混合了多种特效
  isElMixed(el) {
    if (!el) return false
    const $el = $(el)
    if ($el.parents(TAG_SELECTOR).get(0)) return true // 被其他特效包裹
    if ($el.find(TAG_SELECTOR).get(0)) return true // 包裹了其他特效
    return false
  }
  // 是否选区混合了多种特效
  isRangeMixed(range: Range) {
    if (!range) return false
    const el = range.cloneContents()
    return this.isElMixed(el)
  }

  /**
   * 假光标移动到指定节点位置
   * @param node
   * @param visible 是否显示光标
   * @param offset 偏移，0:节点前面，1:节点后面
   * @returns
   */
  setFakeCaretAt(node, visible, offset) {
    if (!node) {
      console.log('设置假光标出错')
      return
    }

    // 定位光标
    this.setFitFocus(
      node.parentNode,
      [...node.parentNode.childNodes].indexOf(node) + offset,
      0
    )
    // 显示光标
    this.cursorVisible = visible
  }

  /**
   * 假光标移动到指定节点后面
   * @param node
   */
  setFakeCaretAfter(node, visible = true) {
    this.setFakeCaretAt(node, visible, 1)
  }

  /**
   * 假光标移动到指定节点前面
   * @param node
   */
  setFakeCaretBefore(node, visible = true) {
    this.setFakeCaretAt(node, visible, 0)
  }

  /**
   * 添加特效节点
   * @param effectType
   * @param effectValue
   * @param renderEffect
   * @param editable
   */
  addEffectHtml({
    range,
    effectType,
    effectValue,
    effectRender = null,
    editable = false,
    wrapSpace = false,
    isPlaceHolder = false
  }) {
    // 创建特效节点
    const effectNode = document.createElement('span')
    effectNode.className = `effect-${effectType} ${TAG_CLASS} ${
      isPlaceHolder ? 'isPlaceHolder' : ''
    }`
    effectNode.contentEditable = editable ? 'true' : 'false'
    effectNode.appendChild(range.extractContents())
    effectNode.setAttribute('data-type', effectType)
    effectNode.setAttribute('data-value', effectValue)
    effectNode.setAttribute('data-text', effectNode.innerText)
    // 默认将原来的文字包裹在特效节点下面
    // iosapp必须在插入fragment前修改节点，否则会出现意想不到的结果哦
    effectNode.innerHTML = effectNode.innerText
      .split('')
      .map(item => (item !== ' ' ? `<span class="wc">${item}</span>` : item))
      .join('')
    // 前后插入空格
    const node = document.createDocumentFragment()
    const spaceBefore = $('<span class="ignore">&nbsp;</span>')[0]
    const spaceAfter = $('<span class="ignore">&nbsp;</span>')[0]
    node.appendChild(spaceBefore)
    node.appendChild(effectNode)
    node.appendChild(spaceAfter)
    // 选区位置插入新的特效节点
    range.insertNode(node)
    // 渲染特效内部节点
    effectRender && effectRender(effectNode)
    // 可能是占位类型节点，可能节点内部为空，删除时空的非编辑节点无法删除，在里面放个空格吧
    if (effectNode.innerHTML === '') {
      effectNode.innerHTML = '<span style="font-size:0;">&nbsp;</span>'
    }
    // 清除特效选区
    range.collapse(false)
    // el 更新为 新插入的特效节点
    this.updateLastEl(effectNode)
    // 高亮当前特效节点
    this.highlightEffectNode(effectNode)
    // ios清除假滑选
    clearHighlightSelection()
    // range 更新到 新插入的特效节点空格后面、wordRangeBeforeCaret 更新为空
    setTimeout(() => {
      // 等待浏览器合并了零碎的text节点
      const newRange = document.createRange()
      newRange.setStart(effectNode.nextSibling, 1)
      newRange.setEnd(effectNode.nextSibling, 1)
      this.updateLastRange(newRange)
    })
    // 重新定位假光标
    this.setFakeCaretAfter(effectNode)
    this.editStatusShow = 1
    this.debounce(this.onlySaveArticleToServer)
  }

  /**
   * 添加允许包含节点特效节点
   */
  rangeAddEffectHtml(startHtml, endHtml, range, effectType, date, idName) {
    let range2 = new Range()
    range2.setStart(range.startContainer, range.startOffset)
    range2.setEnd(range.startContainer, range.startOffset)
    range2.collapse(true)
    let effectNode = document.createElement('span')
    // debugger
    effectNode.innerHTML = startHtml
    range2.insertNode(effectNode)
    if (
      $(effectNode).prev().length == 0 ||
      $(effectNode).prev().attr('contenteditable') == 'false'
    ) {
      $('<span class="ignore">&nbsp;</span>').insertBefore($(effectNode))
    }
    $(effectNode).children().unwrap()
    // let startNode=effectNode.children[0]
    // window.getSelection().removeAllRanges()
    range2.setStart(range.endContainer, range.endOffset)
    range2.setEnd(range.endContainer, range.endOffset)
    range2.collapse(true)
    let effectNode2 = document.createElement('span')
    effectNode2.innerHTML = endHtml
    range2.insertNode(effectNode2)
    if (
      $(effectNode2).next().length == 0 ||
      $(effectNode2).next().attr('contenteditable') == 'false'
    ) {
      $('<span class="ignore">&nbsp;</span>').insertAfter($(effectNode2))
    }
    $(effectNode2).children().unwrap()
    // let endNode=effectNode.children[0]
    // window.getSelection().removeAllRanges()

    let range3 = new Range()
    range3.setStartAfter($(`#${effectType}Start_${date}`)[0])
    range3.setEndBefore($(`#${effectType}End_${date}`)[0])
    let nodeRange = range3.cloneContents()
    // let span =document.createElement("span")
    updateEffctRange(effectType, idName, date, nodeRange, 0)
    range3.setStart(this.editor, 0)
    range3.setEndBefore($(`#${effectType}Start_${date}`)[0])
    nodeRange = range3.cloneContents()
    updateEffctRange(effectType, idName, date, nodeRange, 1)
  }
  // /**
  //  * 点击移除按钮 删除特效 的逻辑
  //  * @param effectType 特效類型
  //  * @param idName id名称比如speedhover
  //  * @param date id值（因为通常是日期）
  //  * @param nodeRange range
  //  * @param isType 0,1,2;0指内部嵌套自己，需要删除内部特效，1，外部嵌套自己，range传起始到特效开始，
  //  * 只需要把特效前后移动，2、判断是否包含不成对某个特效，
  //  */
  // updateEffctRange(effectType, idName, date, nodeRange, isType) {
  //   let localSpeedStartList = $(nodeRange).find(`.${effectType}Start`)
  //   let localSpeedEndList = $(nodeRange).find(`.${effectType}End`)
  //   if (localSpeedStartList.length > 0 || localSpeedEndList.length > 0) {
  //     let startEffectNodeMap = {},
  //       endEffEctNodeMap = {}
  //     for (let i = 0; i < localSpeedStartList.length; i++) {
  //       let node = localSpeedStartList[i]
  //       let id = node.getAttribute(`data-${idName}`)
  //       startEffectNodeMap[id] = $(`#${effectType}Start_${id}`)
  //     }
  //     for (let i = 0; i < localSpeedEndList.length; i++) {
  //       let node = localSpeedEndList[i]
  //       let id = node.getAttribute(`data-${idName}`)
  //       if (startEffectNodeMap[id]) {
  //         if (isType == 0) {
  //           $(`#${effectType}Start_${id}`).remove()
  //           $(`#${effectType}End_${id}`).remove()
  //         }
  //         delete startEffectNodeMap[id]
  //       } else {
  //         endEffEctNodeMap[id] = $(`#${effectType}End_${id}`)
  //       }
  //     }
  //     let startEffectNodeKey = Object.keys(startEffectNodeMap)
  //     let endEffEctNodeKey = Object.keys(endEffEctNodeMap)
  //     if (startEffectNodeKey.length > 0) {
  //       if (isType == 2) {
  //         return [startEffectNodeMap, endEffEctNodeMap]
  //       }
  //       startEffectNodeKey.forEach(key => {
  //         if (isType == 1) {
  //           let $startNode = startEffectNodeMap[key]
  //           let $startNode2 = $startNode.clone(true);
  //           $startNode2.insertAfter(`#${effectType}End_${date}`)
  //           let id = $startNode.attr(`data-${idName}`)
  //           $startNode.attr(`data-${idName}`, id + '1')
  //           $startNode.attr(`id`, `${effectType}Start_${id + '1'}`)
  //           let $endNode2 = $(`#${effectType}End_${id}`)
  //           $endNode2
  //             .clone(true)
  //             .insertBefore(`#${effectType}Start_${date}`)
  //           let $endnode = $(`#${effectType}End_${id}`)
  //           $endnode.attr(`data-${idName}`, id + '1')
  //           $endnode.attr(`id`, `${effectType}End_${id + '1'}`)

  //           this.removeEmptyEffect($startNode[0], $endnode[0])
  //           this.removeEmptyEffect($startNode2[0], $endNode2[0])
  //         } else {
  //           startEffectNodeMap[key].insertAfter(`#${effectType}End_${date}`)
  //         }
  //       })
  //     }
  //     if (endEffEctNodeKey.length > 0) {
  //       if (isType == 2) {
  //         return [startEffectNodeMap, endEffEctNodeMap]
  //       }
  //       endEffEctNodeKey.forEach(key => {
  //         $(endEffEctNodeMap[key]).insertBefore(`#${effectType}Start_${date}`)
  //       })
  //     }
  //   }
  // }
  // /**
  //  * 删除空特效
  //  * @param startNode 
  //  * @param endNode 
  //  */
  // removeEmptyEffect(startNode, endNode) {
  //   const range = new Range()
  //   range.setStartBefore(startNode)
  //   range.setEndAfter(endNode)
  //   if (range.toString().trim() === '') {
  //     $(startNode).remove()
  //     $(endNode).remove()
  //   }
  // }

  /**
   * 判断选区是否有指定特效
   * @param currentRange 选区
   * @param effectType 特效类型 
   * @param nestingType 1,2,3 1代表允许内部嵌套，2代表允许外部嵌套，3代表都不允许
   * @returns [boolean]
   * 
   */
  hasEffectRange(currentRange: Range, effectType: string | string[],nestingType:number=3) {
    if(!currentRange) return false
    if (Array.isArray(effectType)) {
      const effectTypeList = effectType
      for (let effectType of effectTypeList) {
        if (hasEffectRange(currentRange, effectType,nestingType)) return true
      }
      return false
    }
    const contents = currentRange.cloneContents();

    // 单标签嵌套
    const placeholderEffects = {
      'multi-tone': ".effect-multi-tone", // 多音字
      'stress': ".effect-stress", // 重音
      'pause': ".pause-item", //停顿
      'mute': ".effect-mute", // 静音
      // 3: ".effect-multi-tone", // 连读 todo
      // 6: ".effect-multi-tone", // 局部变速 todo
      'globalMute': ".effect-global-mute", //段落静音
      // 7: ".effect-multi-tone", //多发音人 todo
    };
    if (placeholderEffects[effectType]) {
      return !!contents.querySelector(placeholderEffects[effectType])
    }

    // 内部嵌套
    const nestableEffects = {
      'liandu': ".lianduStart", // 连读
      'localSpeed': ".localSpeedStart", // 局部变速
      'multiSpeaker': ".multiSpeakerStart", //多发音人
      'aliasChange': ".aliasChangeStart", //别名
      'phonetics': ".phoneticsStart",
    };

    if (contents.querySelector(nestableEffects[effectType])&&nestingType!==1) {
      return true
    }
    console.log('nestingType',effectType,nestingType);
    
    if(nestingType==2){//不再檢查外部嵌套

      return false
    }
    // 外部嵌套
    let range = new Range();
    range.setStart(this.editor, 0);
    range.setEnd(currentRange.startContainer, currentRange.startOffset);
    let iswrap = updateEffctRange(
      effectType,
      nestableEffectId[effectType],
      0,
      range.cloneContents(),
      2
    );
    return !!iswrap
  }
  /**
   * 获取选区指定特效信息
   * @param currentRange 选区
   * @param effectType 特效类型 
   * @returns [Object[]]
   */
  getEffectRange(currentRange: Range, effectType: string) {
    if (!currentRange) return []

    const contents = currentRange.cloneContents();

    // 单标签嵌套
    const placeholderEffects = {
      'multi-tone': ".effect-multi-tone", // 多音字
      'stress': ".effect-stress", // 重音
      'pause': ".pause-item", //停顿
      'mute': ".effect-mute", // 静音
      // 3: ".effect-multi-tone", // 连读 todo
      // 6: ".effect-multi-tone", // 局部变速 todo
      'globalMute': ".effect-global-mute", //段落静音
      // 7: ".effect-multi-tone", //多发音人 todo
    };
    if (placeholderEffects[effectType]) {
      const elList = [...contents.querySelectorAll(placeholderEffects[effectType])]
      if (effectType === 'globalMute') {
        return elList.map(el => ({
          el,
          ...el.querySelector('.effect-mute').dataset,
        }))
      }
      return elList.map(el => ({
        el,
        ...el.dataset
      }))
    }

    // 内部嵌套
    const nestableEffects = {
      'liandu': ".lianduStart", // 连读
      'localSpeed': ".localSpeedStart", // 局部变速
      'multiSpeaker': ".multiSpeakerStart", //多发音人
      'aliasChange': ".aliasChangeStart", //别名
      'phonetics': ".phoneticsStart",//音标
    };

    if (contents.querySelector(nestableEffects[effectType])) {
      const elList = [...contents.querySelectorAll(nestableEffects[effectType])]
      return elList.map(el => ({
        el,
        ...el.dataset
      }))
    }

    // 外部嵌套

    let range = new Range();
    range.setStart(this.editor, 0);
    range.setEnd(currentRange.startContainer, currentRange.startOffset);
    let iswrap = updateEffctRange(
      effectType,
      nestableEffectId[effectType],
      0,
      range.cloneContents(),
      2
    );
    if (iswrap) {
      return Object.values(iswrap[0]).map(($startNode) => {
        const el = $startNode[0]
        return {
          el,
          ...el.dataset
        }
      })
    }
    return []
  }
  /**
   * 获取选区发音人特效信息
   * @param currentRange 选区
   * @returns [Object]
   */
  getSpeakerEffectRange(currentRange: Range) {
    const speakers = this.getEffectRange(currentRange, 'multiSpeaker')
    return speakers?.map(item => {
      return {
        ...item,
        speakerInfo: this.speakerUtils.getSpeakerBySpeaker(item.speaker)
      }
    }) ?? []
  }
  /**
   * 获取选区发音人是否不支持指定特效
   * @param currentRange 
   * @param effectType 
   * @returns 
   */
  isRangeSpeakerNotSupportEffect(currentRange: Range, effectType: string) {
    const speakers = this.getSpeakerEffectRange(currentRange)
    if (speakers.length > 0) {
      const authId = this.getNavItemAuthByType(effectType)
      if(authId){
        for (let { speakerInfo } of speakers) {
            let features = speakerInfo.speakerFeature || [];
            if (!features.some((feature) => feature === authId)) {
              return speakerInfo
            }
          }
      }
    }
    return false
  }
  /**
   * 判断选区是否仅嵌套指定特效或者选区没有指定特效
   * @param currentRange 选区
   * @param effectType 特效类型 
   * @returns [boolean]
   */
  isNestEffectRange(currentRange: Range, effectType: string) {
    // 特效范围 () 选取范围 []
    // 仅当 [()]和[] 返回true

    // 情况 [(])
    let iswrap = updateEffctRange(
      effectType,
      nestableEffectId[effectType],
      0,
      currentRange.cloneContents(),
      2
    )
    if (iswrap) {
      return false
    }

    // 情况 ([]) 和 ([)]
    let range = new Range()
    range.setStart(this.editor, 0)
    range.setEnd(currentRange.startContainer, currentRange.startOffset)
    iswrap = updateEffctRange(
      effectType,
      nestableEffectId[effectType],
      0,
      range.cloneContents(),
      2
    )
    if (iswrap) {
      return false
    }

    return true
  }

  /**
   * 判断选区是否被嵌套在指定特效内部
   * @param currentRange 选区
   * @param effectType 特效类型 
   * @returns [boolean]
   */
  isNestedInEffectRange() {
    // todo
  }

  addcontainEffectHtml({ range, effectType, effectUIType, idName, param }) {
    let paramStr: string = ''
    if (param) {
      Object.keys(param).map(key => {
        paramStr += ` data-${key}="${param[key]}"`
      })
    }
    // 创建特效节点
    let date = new Date().getTime()
    let starthtml = `<span class="ignore ${effectType} ${effectType}Start isTag" id="${effectType}Start_${date}"${paramStr} data-type="${effectType}" contenteditable="false"  data-${idName}="${date}" >&nbsp;<span class="${effectUIType}Start" ${paramStr}>&nbsp;</span>&nbsp;</span>`
    let endHtml = `<span class='ignore ${effectType} ${effectType}End isTag'  id="${effectType}End_${date}" contenteditable="false" ${paramStr} data-type="${effectType}" data-${idName}="${date}">&nbsp;<span class="${effectUIType}End" ${paramStr}>&nbsp;</span>&nbsp;</span>`

    this.rangeAddEffectHtml(starthtml, endHtml, range, effectType, date, idName)

    // 高亮当前特效节点
    this.highlightEffectNode($(`#${effectType}Start_${date}`))

    // ios清除假滑选
    clearHighlightSelection()
    // 重新定位假光标
    this.continuousid = date
    let curNode = $(`#${effectType}End_${date}`)[0]
    this.lastSelection.el = curNode
    this.setFakeCaretAfter(curNode)
    this.editStatusShow = 1
    this.debounce(this.onlySaveArticleToServer)
  }
  /**
   * 点击移除按钮 删除特效 的逻辑
   * @param el 目标节点
   */
  removeEffectHtml(el) {
    const $el = $(el)
    if ($el.is('.isTag')) {
      // 删除特效前后空格
      this.removeWrapSpaceHtml(el)
      // 删除特效结构，将特效节点换成textNode
      const text = [...el.querySelectorAll('.wc')]
        .map(wc => wc.textContent)
        .join('')
      const textNode = document.createTextNode(text)
      el.parentNode.replaceChild(textNode, el)
      // 更新选区
      this.updateLastEl(null)
      const range = document.createRange()
      range.selectNode(textNode)
      this.updateLastRange(range)

      // ios添加高亮
      highlightSelection(this.lastSelection)

      // 重新定位假光标
      this.setFakeCaretAfter(textNode)
      this.editStatusShow = 1
      this.debounce(this.onlySaveArticleToServer)
    } else {
      console.log('删除非特效节点', el)
    }
  }
  /**
   * 点击移除按钮 删除特效 的逻辑
   * @param el 目标节点
   * @param idName id标记的属性，如连读是continuousId，局部变速是speedhover
   * @param effect 去除的属性，liandu
   */
  removeContainHtml(el, idName, effect) {
    let id = el.getAttribute(`data-${idName}`)
    if (!id) {
      return
    }

    let $effectStart = $(`#${effect}Start_${id}`)
    let $effectEnd = $(`#${effect}End_${id}`)
    // 重新定位假光标
    // 更新选区
    this.updateLastEl(null)
    const range = document.createRange()
    range.setStartAfter($effectStart[0])
    range.setEndBefore($effectEnd[0])
    this.updateLastRange(range)

    // ios添加高亮
    highlightSelection(this.lastSelection)

    if ($effectStart.prev().attr('class') == 'ignore') {
      $effectStart.prev().remove()
    }

    if ($effectEnd.next().attr('class') == 'ignore') {
      this.setFakeCaretAfter($effectEnd.next()[0])
      $effectEnd.next().remove()
    }

    $effectStart.remove()
    $effectEnd.remove()
    const range2 = document.createRange()
    let $rangehighlight = $('.range-highlight')
    range2.setStart($rangehighlight[0], 0)
    let lastRange = $rangehighlight[$rangehighlight.length - 1]
    range2.setEnd(lastRange, lastRange.childNodes.length)
    this.updateLastRange(range2)
    this.setFakeCaretAfter(lastRange)
    this.editStatusShow = 1
    this.debounce(this.onlySaveArticleToServer)
  }

  /**
   * 按下删除键 删除特效 的逻辑
   * 删除得时候不是整体删除，只删除一个字同时效果也取消掉
   * @param range
   */
  removeEffectOnDeleteKey(range: Range, e) {
    // 找到特效节点
    let node = null
    // 光标位置: 0a1b2c3d4
    if (range.startContainer.nodeType === 1) {
      // 元素节点
      if (range.startOffset > 0) {
        node = range.startContainer.childNodes[range.startOffset - 1]
        if (!$(node).is('.isTag') && $(node).text() === '') {
          node = getPrevSiblingEffectNode(node)
        }
      } else {
        node = getPrevSiblingEffectNode(range.startContainer)
      }
    } else if (range.startContainer.nodeType === 3 && range.startOffset === 0) {
      // 文本节点
      node = getPrevSiblingEffectNode(range.startContainer)
    }

    // 处理特效节点删除
    if ($(node).is('.isTag')) {
      if (this.sectionType == 'Caret') {
        if (node.className.indexOf('liandu') != -1) {
          this.removeCaretEffect(node, 'liandu', 'continuousid')
          e.preventDefault()
        } else if (node.className.indexOf('localSpeed') != -1) {
          this.removeCaretEffect(node, 'localSpeed', 'speedhover')
          e.preventDefault()
        } else if (node.className.indexOf("multiSpeaker") != -1) {
          this.removeCaretEffect(node, "multiSpeaker", "hover")
          e.preventDefault()
        } else if (node.className.indexOf("aliasChange") != -1) {
          this.removeCaretEffect(node, "aliasChange", "aliasgroupkey")
          e.preventDefault()
        } else if (node.className.indexOf("phonetics") != -1) {
          this.removeCaretEffect(node, "phonetics", "phoneticsid")
          e.preventDefault()
        } else if (node.className.indexOf("phonetics") != -1) {
          let dom = this.getprevnextNode(node, '#text', 'prev')
          if (
            dom &&
            dom.nextSibling &&
            dom.nextSibling.nodeName === 'SPAN' &&
            dom.nextSibling.getAttribute('data-stresshover')
          ) {
            this.stresshover = dom.nextSibling.getAttribute('data-stresshover')
            this.removeStress()
          }
        }
      }
      // 删除特效结构，将特效节点换成textNode
      const text = [...node.querySelectorAll('.wc')]
        .map(wc => wc.textContent)
        .join('')
      if (text.length > 1) {
        const textNode = document.createTextNode(text.slice(0, -1))
        $(node).before(textNode)
      }
    }
    if (this.sectionType == 'Range') {
      this.removeRangeEffect('liandu', range, 'continuousid')
      this.removeRangeEffect('localSpeed', range, 'speedhover')
      this.removeRangeEffect('multiSpeaker', range, 'hover')
      this.removeRangeEffect('aliasChange', range, 'aliasgroupkey')
      this.removeRangeEffect('phonetics', range, 'phoneticsid')
    }
  }
  /**
   *滑选删除指定特效逻辑的处理逻辑
   * @param effectName
   * @param range
   * @param idName
   */
  removeRangeEffect(effectName, range, idName) {
    let rangeNode = range.cloneContents()
    let effectList = $(rangeNode).find(`.${effectName}`)
    let idList = []
    if (effectList.length > 0) {
      for (let i = 0; i < effectList.length; i++) {
        let id = effectList[i].getAttribute(`data-${idName}`)
        idList.push(`#${effectName}Start_${id}`, `#${effectName}End_${id}`)
      }
      setTimeout(() => {
        idList.forEach(ele => {
          this.removeWrapSpaceHtml($(ele)[0])
          $(ele).remove()
        })
      })
    }
  }
  /**
   *光标删除指定特效逻辑的处理逻辑
   * @param node
   * @param range
   * @param idName
   */
  removeCaretEffect(node, effectName, idName) {
    let id = node.dataset[idName]
    if (idName) {
      setTimeout(() => {
        let $start = $(`#${effectName}Start_${id}`)
        this.removeWrapSpaceHtml($start[0])
        $start.remove()
        let $end = $(`#${effectName}End_${id}`)
        this.removeWrapSpaceHtml($end[0])
        $end.remove()
      })
    }
  }
  /**
   *滑选删除非成对逻辑的处理逻辑
   * @param effectName
   * @param range
   * @param idName
   */
  removeRangesingleEffect(effectName, range, idName) {
    let rangeNode = range.cloneContents()
    let nodeList = updateEffctRange(effectName, idName, 0, rangeNode, 2)
    if (!nodeList) {
      return
    }
    let [startEffectNodeMap, endEffectNodeMap] = nodeList
    let effectList: any = [
      ...Object.values(startEffectNodeMap),
      ...Object.values(endEffectNodeMap)
    ]
    let idList = []
    if (effectList.length > 0) {
      for (let i = 0; i < effectList.length; i++) {
        let id = effectList[i].attr(`data-${idName}`)
        idList.push(`#${effectName}Start_${id}`, `#${effectName}End_${id}`)
      }
      setTimeout(() => {
        idList.forEach(ele => {
          this.removeWrapSpaceHtml($(ele)[0])
          $(ele).remove()
        })
      })
    }
  }
  /**
   * 删除段尾最后一个字符的处理逻辑
   * @param range
   */
  removeLastCharacterOnDeleteKey(range: Range) {
    if (!this.isIOS) return // ios问题比较显著，仅仅处理ios，安卓如果这样处理光标会上下对不齐
    // 解决光标定位问题，删除时，段落尾部插入空span，防止出现段落尾部失去焦点
    const $p = $(range.startContainer).closest('div')

    // 校验下，正常div肯定存在
    if (!$p.get(0)) return

    // 是否应该插入
    const shouldInsert = $tail => {
      // 段尾不存在 或 段尾被编辑了 或 即将删除断尾
      return (
        !$tail.get(0) ||
        $tail.html() !== '&nbsp;' ||
        $(range.startContainer).closest($tail).get(0)
      )
    }

    // 多个段落时
    const nextp = getNextParagraphNode(range.startContainer)
    if (nextp) {
      // 情况1 直接在当前段落 插入段尾
      // <div>abc</div>
      // <div>efg</div>

      // 情况2 第一段大概是这种形状，敲回车也可能导致这种形状
      // <div>
      //   abc
      //   <br/>
      //   <div>efg</div>
      //   <br/>
      // </div>

      // 情况x 还有很多未知情况，比如在不同的位置回车，这边相当复杂，只能看边用边完善

      const outNextp = getNextParagraphNode($p.get(0))
      if (nextp !== outNextp) {
        // 情况2
        let insertPos = nextp

        // nextp前面有换行<br/>，则插入到换行前面
        const br = getNextSatisfyNode(
          range.startContainer,
          node => $(node).is('br'),
          () => true
        )
        if ($(br).parents($p).get(0)) {
          // br在当前段落里面
          const br2 = getNextSatisfyNode(
            nextp,
            node => $(node).is('br'),
            () => true
          )

          if (br !== br2) {
            // br在当前段落，且在嵌套段落前面
            insertPos = br
          }
        }

        // 在insertPos前面插入段尾
        if (shouldInsert($(insertPos.previousSibling))) {
          // 清除之前插入的段尾
          $p.find('.paragraph-tail').removeClass('paragraph-tail')
          // 重新插入段尾
          $(insertPos).before(`<span class="paragraph-tail">&nbsp;</span>`)
        }
        return
      } else {
        // 情况1， 走下面，和情况3相同的处理
      }
    }

    // 情况3 只有一段
    // <div>abcdefg</div>
    if (shouldInsert($p.find('>span.paragraph-tail:last-child').last())) {
      // 清除之前插入的段尾
      $p.find('.paragraph-tail').removeClass('paragraph-tail')
      // 重新插入段尾
      $p.append(`<span class="paragraph-tail">&nbsp;</span>`)
    }
  }
  /**
   * 聚焦到段尾时调整光标
   */
  adjustCaretOnFocusParagraphTail() {
    if (!this.isIOS) return // ios问题比较显著，仅仅处理ios，安卓如果这样处理光标会上下对不齐
    const selection = window.getSelection()
    // 0&nbsp;1  聚焦到 nbsp 右侧
    if (selection.type === 'Caret' && selection.focusOffset === 1) {
      const focusNode = selection.focusNode
      const $tail = $(focusNode).closest('.paragraph-tail')
      if ($tail.get(0) && $tail.html() === '&nbsp;') {
        selection.collapse(focusNode, 0)
      }
    }
  }

  /**
   * 删除节点前后包裹的一个空格
   * @param el 目标节点
   */
  removeWrapSpaceHtml(el) {
    if (el && el.parentNode) {
      const removeSpace = (node, firstOrLast: 'first' | 'last') => {
        if (node && node.nodeType === 3) {
          const text = node.textContent
          if (text === NBSP_TEXT || text.length === 0) {
            node.parentNode.removeChild(node)
          } else if (text.length > 0) {
            if (firstOrLast === 'first' && text[0] === NBSP_TEXT) {
              node.textContent = text.slice(1)
            } else if (
              firstOrLast === 'last' &&
              text[text.length - 1] === NBSP_TEXT
            ) {
              node.textContent = text.slice(0, -1)
            }
          }
        }
      }
      removeSpace(el.previousSibling, 'last')
      removeSpace(el.nextSibling, 'first')
      let $el = $(el)
      let $prev = $el.prev()
      let $next = $el.next()
      if ($prev.attr('class') == 'ignore') {
        if ($prev.text().trim().length == 0) {
          $prev.remove()
        }
      }
      if ($next.attr('class') == 'ignore') {
        if ($next.text().trim().length == 0) {
          $next.remove()
        }
      }
    }
  }

  /**
   * 获取文本内容
   * @param stressDomList
   */
  getTextContent(stressDomList) {
    let _text = ''
    stressDomList.forEach(item => {
      let type = ''
      if (item.nodeName === 'SPAN') {
        type = item.getAttribute('data-type')
      }
      if (type !== 'mute' && type !== 'pause' && item.textContent) {
        _text += item.textContent.trim()
      }
    })
    return _text
  }
  /**
   * 处理重读的逻辑
   * @param stressDomList
   * @param time
   * @param obj
   */
  handleStress(stressDomList, time, obj) {
    let wordDom = ''
    stressDomList.forEach(item => {
      if (
        (item.nodeName !== '#text' &&
          item.getAttribute('data-type') !== 'mute' &&
          item.getAttribute('data-type') !== 'pause' &&
          item.getAttribute('data-type') !== 'tone' &&
          item.textContent.trim() !== '') ||
        (item.nodeName === '#text' && item.textContent.trim() !== '')
      ) {
        let childrenList = item.childNodes
        if (childrenList && childrenList.length) {
          wordDom += this.handleStress(childrenList, time, obj)
        } else {
          let wordList = item.textContent.split('')
          wordList.forEach(_item => {
            if (_item.trim()) {
              wordDom += `<span data-type="stress" data-stress="${
                this.stress
              }" data-word="${_item}" data-stresshover="${time}" data-source=${JSON.stringify(
                obj
              )} contentEditable="false">${_item}</span>`
            }
          })
        }
      } else if (
        item.nodeName !== '#text' &&
        item.getAttribute('data-type') === 'tone'
      ) {
        let value = item.getAttribute('data-value')
        let source = item.getAttribute('data-source')
        wordDom += `<span  data-stresshover="${time}" class="tag tone-item"
             data-type="stress-tone" data-stress="强" data-value="${value}" data-word="${item.textContent}" data-source=${source} contentEditable="false">${item.textContent}</span>`
      } else if (
        item.nodeName !== '#text' &&
        (item.getAttribute('data-type') === 'mute' ||
          item.getAttribute('data-type') === 'pause')
      ) {
        wordDom += item.outerHTML
      }
    })
    return wordDom
  }

  /**
   * 插入重读
   * @param domList
   * @param stressActive
   */
  insertStress(domList, stressActive) {
    let fragment = document.createDocumentFragment()
    domList.forEach((item, i) => {
      fragment.appendChild(item)
    })
    document
      .querySelector('.stressActive')
      .parentNode.insertBefore(
        fragment,
        document.querySelector('.stressActive')
      )
    // stressActive.className = ''
    stressActive.remove()
  }
  removeStress(idx?, isDelete = false) {
    if (this.stresshover) {
      if (idx) {
        this.stressObj = this.stressObj.map((item, index) => {
          item.checked = false
          if (idx == index) {
            this.stress = item.name
            item.checked = true
          }
          return item
        })
      }

      let stresshoverList = Dom.getElementByAttr(
        'span',
        'data-stresshover',
        this.stresshover
      )
      let nextNode = stresshoverList[stresshoverList.length - 1]
        .nextSibling as HTMLElement
      let preNode = stresshoverList[0].previousSibling as HTMLElement
      if (preNode.nodeName === '#text' && preNode.textContent.trim() == '') {
        preNode.remove()
      } else if (
        preNode.nodeName === '#text' &&
        preNode.textContent.trim() != ''
      ) {
        preNode.nodeValue = preNode.nodeValue.trim()
      }
      if (!isDelete) {
        if (
          nextNode.nodeName === '#text' &&
          nextNode.textContent &&
          nextNode.textContent.trim() == ''
        ) {
          if (nextNode.nextSibling) {
            this.selectionAddr.anchorNode = nextNode.nextSibling
            this.selectionAddr.anchorOffset = 0
          } else if (nextNode.parentNode.nextSibling) {
            this.selectionAddr.anchorNode = nextNode.parentNode.nextSibling
            this.selectionAddr.anchorOffset = 0
          } else {
            setTimeout(() => {
              this.selectionAddr.anchorNode = nextNode.parentNode
              if (nextNode.parentNode) {
                this.selectionAddr.anchorOffset =
                  nextNode.parentNode.childNodes.length
              }
            }, 50)
          }
          setTimeout(() => {
            this.setFitFocus(
              this.selectionAddr.anchorNode,
              this.selectionAddr.anchorOffset,
              0
            )

            this.cursorPosition = SelectionUtils.rect
          }, 100)
          nextNode.remove()
        }
      }
      stresshoverList.forEach(item => {
        if (item.getAttribute('data-type') === 'stress-tone') {
          let span = document.createElement('span')
          span.setAttribute('data-type', 'tone')
          span.setAttribute('data-value', item.getAttribute('data-value'))
          span.setAttribute('data-source', item.getAttribute('data-source'))
          span.setAttribute('contentEditable', 'false')
          span.className = 'tone-item isTag'
          span.innerText = item.innerText
          item.parentNode.replaceChild(span, item)
        } else {
          if (item.textContent.trim()) {
            let text = document.createTextNode('text')
            text.textContent = item.textContent
            item.parentNode.replaceChild(text, item)
          } else {
            item.remove()
          }
        }
      })
      this.stresshover = ''
      this.removeStressActive()
      // let text = this.tagElement.innerText;
      // let parentNode = this.tagElement.parentNode;
      // let textNode = document.createTextNode(text);
      // parentNode.insertBefore(textNode, this.tagElement)
      // this.tagElement.remove()
      // this.tagElement = null
    } else {
      let text = $('.stressActive').text()
      if (!text && !this.rangeSelection.data) {
        toast('请选择需要设置的字符', 'top')
      }
      this.removeStressActive()
      // $(".stressActive").removeClass("stressActive")
    }
  }
  removeStressActive() {
    let dom = document.querySelector('.stressActive')
    if (dom) {
      let childrenList = dom.childNodes
      if (childrenList && childrenList.length) {
        let html = dom.innerHTML
        let _html = document.createRange().createContextualFragment(html)
        dom.parentNode.replaceChild(_html, dom)
      } else {
        dom.remove()
      }
    }
  }
  //更换停顿方式
  changePause(e: any, delFlag: false) {
    if (this.playStatus) {
      toast('请点击内容区域，指定效果位置进行设置', 'top')
      this.__resetArticleStatus()
      return
    }
 
    let idx = e.currentTarget.dataset.index
    let pauseObjs = this.pauseObjs
    let obj = null
    pauseObjs.map((item: any, index: any) => {
      item.checked = false
      if (idx == index) {
        obj = item
        item.checked = true
      }
    })
    this.pauseObjs = pauseObjs
    if (this.tagElement) {
      if (!delFlag && obj.value > -1) {
        this.tagElement.setAttribute('data-value', obj.value)
        for (let i = 0; i < this.tagElement.childNodes.length; i++) {
          let node: any = this.tagElement.childNodes[i]
          if (node.nodeName == 'IMG') {
            node.src = ImageMap[obj.value]
          }
        }
        // 高亮当前特效节点
        this.highlightEffectNode(this.tagElement, obj.value)
      } else {
        // to refact 此处拷贝的removeEffectHtml里面的 后面考虑 pause实现改为和其他特效统一
        const el = this.tagElement
        // 删除特效前后空格
        this.removeWrapSpaceHtml(el)
        // 删除特效结构，将特效节点换成textNode
        const textNode = document.createTextNode('')
        el.parentNode.replaceChild(textNode, el)
        // 更新选区
        this.updateLastEl(null)
        const range = document.createRange()
        range.selectNode(textNode)
        this.updateLastRange(range)

        // 重新定位假光标
        this.setFakeCaretAfter(textNode)
        this.tagElement = null
      }
    } else {
      this.insertPause(obj)
    }
    this.__resetArticleStatus()
    this.editStatusShow = 1
    this.debounce(this.onlySaveArticleToServer)
    let name = e.currentTarget.dataset.name
    customCollectEvent('editor_tingdun', {
      name: name
    })
  }
  removePause() {
    if (this.tagElement) {
      // to refact 此处拷贝的removeEffectHtml里面的 后面考虑 pause实现改为和其他特效统一
      const el = this.tagElement
      // 删除特效前后空格
      this.removeWrapSpaceHtml(el)
      this.tagElement.remove()
    }
  }
  closeChooseMute() {
    this.showMute = false
    this.selfMute = ''
  }
  //插入静音
  changeMute(e: any) {
    if (this.playStatus) {
      toast('请点击内容区域，指定效果位置进行设置', 'top')
      this.__resetArticleStatus()
      return
    }
    let idx = e.currentTarget.dataset.index
    let muteObjs = this.muteObjs
    let obj = null
    muteObjs.map((item: any, index: any) => {
      item.checked = false
      if (idx == index) {
        obj = item
        item.checked = true
        // //清除自定义
        this.selfMute = ''
      }
    })
    this.muteObjs = muteObjs

    if (this.tagElement) {
      this.tagElement.setAttribute('data-value', obj.value)
      this.tagElement.innerHTML = `<span class="mute-number">${
        obj.value
      }</span>${Dom.renderMuteLine(obj.value)}`
    } else {
      this.insertMute(obj)
    }
    this.__resetArticleStatus()
    this.debounce(this.onlySaveArticleToServer)
    customCollectEvent('editor_jingyin', {
      time: obj.value
    })
  }

  //自定义静音
  addCustomMills(e: any) {
    let reg = /^[1-9][0-9]*$/
    // if (e.keyCode == 13){
    let v = e.target.value.trim()
    if (!reg.test(v)) {
      this.$toast({
        icon: 'none',
        message: '静音时长必须是正整数'
      })
      return
    }
    if (v < 0 || v > 5000) {
      this.$toast({
        icon: 'none',
        message: '静音时长不能超过5000ms'
      })
      return
    }
    let muteObjs = this.muteObjs
    let obj = null
    let flag = false //填入数字是否在默认范围
    muteObjs.map((item: any, index: any) => {
      item.checked = false
      if (v == item.value) {
        obj = item
        item.checked = true
        flag = true
        this.selfMute = ''
      }
    })
    this.muteObjs = muteObjs
    if (!flag) {
      obj = { value: v }
    }
    if (this.tagElement) {
      this.tagElement.setAttribute('data-value', obj.value)
      this.tagElement.innerHTML = `<div class="mute-number">${
        obj.value
      }</div>${Dom.renderMuteLine(v)}`
    } else {
      this.insertMute(obj)
    }
    this.selfMute = ''
    this.showMute = false
    this.__resetArticleStatus()
    // }
  }

  // 插入标签
  insertTag(type: string) {
    this.showPause = false
    this.showMute = false
    if (type == 'pause') {
      this.pauseObjs = this.pauseObjs.map((item: any) => {
        item.checked = false
        item.change = false
        return item
      })

      this.showPause = true
    }

    if (type == 'mute') {
      this.muteObjs = this.muteObjs.map((item: any) => {
        item.checked = false
        item.change = false
        return item
      })
      this.selfMute = ''
      this.showMute = true
    }
    if (type == 'stress') {
      this.stressObj = this.stressObj.map((item: any) => {
        item.checked = false
        return item
      })
      this.stress = ''
      this.showStress = true
    }
  }

  // member1为svip功能，member0为vip功能
  payList = [
    {
      name: '多音字',
      member: 0,
      key: 'pinyinCount'
    },
    {
      name: '重读',
      member: 0,
      key: 'stress'
    },
    {
      name: '停顿调节',
      member: 1,
      key: 'rhythmDataCount'
    },
    {
      name: '插入静音',
      member: 0,
      key: 'isMuteCount'
    },
    {
      name: '数字符号',
      member: 1,
      key: 'tnChangeStartCount'
    },
    {
      name: '连读',
      member: 1,
      key: 'continuousStartCount'
    },
    {
      name: '重音',
      member: 1,
      key: 'isStressCount'
    },
    {
      name: '多人配音',
      member: 1,
      key: 'startSpeakerCount'
    },
    {
      name: '别名',
      member: 1,
      key: 'aliasChangeStartCount'
    },
    {
      name: '局部变速',
      member: 1,
      key: 'startSpeedCount'
    },
    {
      name: '音标',
      member: 1,
      key: 'pronChangeStartCount'
    },
    {
      name: '背景音',
      member: 0,
      key: 'bgmAmount'
    },
    {
      name: '特效音',
      member: 0,
      key: 'specialMusicCount'
    }
  ]

  // 计算支付list
  get computedPayList() {
    let list = [...this.payList]
    return list
      .map((item: any) => {
        item.value = this.state.priceData[item.key]
        return item
      })
      .filter((item: any) => item.value > 0)
  }

  /**
   * 编辑器外层容器高度
   */
  get editHeight() {
    let heightText = '100%'
    if (this.isEditorFocus) {
      heightText = `100%`
    } else if (this.showMenuContent) {
      heightText = `calc(100% - 3.6rem)`
    }else if (this.showBottomAixiaomo) {
      heightText = `calc(100% - 7.5rem)`
    }

    return heightText
  }

  get editPaddingBottom() {
    if (this.currentKeyboardHeight) {
      if (this.showMenuContent) {
          return `calc(${this.currentKeyboardHeight}px - 80px)`
      } else if (this.activeSheetType === 'sensitiveSheet') {
          return `240px`
      } else {
        if (judgeDeviceType.isIOS) {
          return `calc(${this.currentKeyboardHeight}px - 300px)`
        } else {
          return `calc(${this.currentKeyboardHeight}px)`
        }
      }
    } else if(this.activeSheetType=='sensitiveSheet') {
      return '240px'
    } else if (this.showAudioProgress) {
      return '130px'
    } else {
      return '30px'
    }
  }

  // 计算权限提示
  __getFreeTips(item: any, index: number) {
    if (
      this.state.vipInfo.type === this.computedPayList[index].member ||
      this.state.vipInfo.type === VIP_TYPE.SVIP ||
      this.state.vipInfo.type === VIP_TYPE.TRIAL
    ) {
      return '免费'
    } else {
      return item.member === 0 ? 'VIP免费' : 'SVIP免费'
    }
  }

  get isVip() {
    return this.state.vipInfo?.type === VIP_TYPE.VIP
  }
  // 超级会员每日合成60次
  get isSuperVip() {
    const type = this.state.vipInfo?.type
    return type === VIP_TYPE.SVIP || type === VIP_TYPE.TRIAL
  }

  get articleHasSvipFunc() {
    if (
      this.isVip &&
      this.computedPayList.filter(item => item.member === 1).length > 0
    ) {
      return true
    } else {
      return false
    }
  }

  onHandleDoneClick(e) {
    this.showBottomNavs = false
    this.showMenuContent = false
    this.activeSheetType = ""
    this.showAudio = false
    this.blur()
  }

  // 获取菜单权限
  computedNavItemAuth(item: any) {
    let speakerFeature = this.state.currentSelectSpeaker?.speakerFeature || []
    return speakerFeature.some((feature: any) => feature === item.authId)|| item.global
  }

  // 获取菜单的auth
  getNavItemAuthByType(effectType) {
    return this.bottomNavItems.find(item => item.type === effectType)?.authId ?? null
  }

  // 选择风格
  moodSpeakerList = []
  onStyleSpeakerConfirm({option, emotionWeight}) {
    this.state.isComposed = false
    this.state.currentSelectSpeaker = option
    this.state.emotionWeight = emotionWeight
    // 检查更新智能分句是否支持状态
    this.checkUpdateAutoMute()
    this.debounce(this.onlySaveArticleToServer)
    customCollectEvent("editor_voicepopup_style", {
      style: this.state.currentSelectSpeaker.styleName || "通用",
    })
  }
  StyleSpeakerClick() {
    if (!this.state.isLogined) {
      this.saveArticleToLocal()
      setTimeout(() => this.gotoLogin(), 500)
      return
    }
    this.showSpeakerStyle = true
    customCollectEvent("editor_voicepopup", {
      name: "风格选择",
    })
  }

  // 判断发音人是否支持智能分句
  isSpeakerSupportAutoMute(speaker) {
    return speaker.speakerFeature.some(ele => ele === 24)
  }

  // 初始化、切换发音人、合成、试听时处理
  // 检查更新智能分句是否支持状态
  checkUpdateAutoMute() {
    this.speakersNotSupportAutoMute = this.getSpeakersNotSupportAutoMute()
  }

  async validateAutoMute({ speaker }) {
    if (!this.symbolMuteChecked) return true
    if (this.isSpeakerSupportAutoMute(speaker)) {
      return true
    }
    if (!this.supportAutoMute) return true

    return true

    // return Dialog
    //   .confirm({
    //     title: `温馨提示`,
    //     confirmButtonText: '确定',
    //     message: `发音人${speaker.name}暂不支持智能分句模式，确认要切换发音人吗？`,
    //     className: 'pop-confirm',
    //     getContainer: '#page-audition',
    //     cancelButtonText: '取消'
    //   })
    //   .then(() => {
    //     return true
    //   })
    //   .catch(() => {
    //     // on cancel
    //     return false
    //   })
  }

  speakerWrapperClick() {
    const $speaker: any = this.$refs.speakerSelectPopper
    customCollectEvent("editor_voicepopup", {
      name: "选择发音人",
    })
    $speaker.open({
      speaker: this.state.currentSelectSpeaker,
      validateSpeakerAutoMute: true
    })
      .then(({ speaker, index }) => {
        if (this.state.currentSelectSpeaker && this.state.currentSelectSpeaker.speaker !== speaker.speaker) {
          this.state.isComposed = false;
        }

        this.state.currentSelectSpeaker = speaker;
        this.state.speedSlideVal = "1.0"
        this.state.pitchSlideVal = "0"
        this.state.emotionWeight = 1
        this.debounce(this.onlySaveArticleToServer)

        // 检查更新智能分句是否支持状态
        this.checkUpdateAutoMute()

        customCollectEvent('editor_voicepopup_voice', {
          'number': index,
          'name': speaker.name || ''
        })
      }).catch(() => {
        // 取消 或 未改变
      })
  }
  goToServiceWx() {
    let item = {
      code: null,
      description: '客服在线随时咨询',
      icon: 'https://mobvoi-backend-public.ticwear.com/image/moyingongfang/2021-08-09-service.png',
      id: 5,
      image:
        'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2021-08-27-3357834091647511293.png',
      name: '客服微信号',
      status: 1,
      title: '客服在线，随时咨询 福利多多，快来领取',
      type: 0
    }
    this.$navigateTo({
      url: `/mine-package/pages/service/service?detail=` + JSON.stringify(item)
    })
  }
  changePlayStatus() {
    this.playStatus = false
  }
  checkSensitiveDialog(wordAndReplaceList){
    Dialog.alert({
        confirmButtonText: '立即修改',
        message: `当前文章含有敏感词内容，请修改后再配音`,
        className: 'pop-confirm pop-alert',
        getContainer: '#page-audition',
        closeOnClickOverlay: true
      })
      .then(() => {
        this.wordAndReplaceList = wordAndReplaceList
        console.log(this.wordAndReplaceList);
        
        this.resetEditorHtml()

      })
      .catch(() => {
      })
      
  }
  resetEditorHtml(){
    this.isEffectUpdate = false
    this.activeSheetType = 'sensitiveSheet'
       // 隐藏菜单
     this.showbottomfield = false
     this.renderJsonToDom()
  }
  sensitiveClose(){
    this.activeSheetType =''
    if($('.sensitive').length>0){
      $('.sensitive').replaceWith(function() {
        return $(this).contents();
      });
    }
    this.wordAndReplaceList=[]
    setTimeout(() => {
      this.showbottomfield = true
    }, 100);
  }


  showAI() {
    this.showBottomAixiaomo = true;
    this.showBottomNavs = false;
    this.showbottomfield = true;
    this.editor.contentEditable = false
    let range =this.lastSelection.range
    if (range) {
      this.aiText=this.lastSelection.rangeText
      this.addHighlightSelection()
      this.cursorVisible = false
    } else {
      let range = new Range()
      let childNodes=this.editor.childNodes
      range.setStart(this.editor, 0)
      range.setEnd(this.editor, childNodes.length)
      this.updateLastRange(range)
      this.aiText = this.lastSelection.rangeText
      this.addHighlightSelection()
      this.cursorVisible = false
    }
    customCollectEvent('editor_aiarticle', {
      number:1
    })

  }
  closeAI(fragment){
    this.state.isAixiaomoEditor = false
    this.showBottomAixiaomo = false;
    this.showBottomNavs = true;
    this.showbottomfield= true;
    this.removeLastRange()
    if(fragment){
      let spandivs = this.editor.querySelectorAll('span div');
      if (spandivs.length > 0) {
        spandivs.forEach((item) => {
          $(item).parents('span').replaceWith(function() {
            return $('<div>').addClass($(this).attr('class')).append($(this).contents());
          });
        });
      }
      // this.aiTipShow = true
      this.debounce(this.onlySaveArticleToServer)
    }
    clearHighlightSelection()
    // setTimeout(() => {
      //  if(history.state||history.state.isEditor){
      //     history.go(-1)
      //   }
    // }, 100)
   
  }

}


// 发音人初始化
function speakerNormalize(targetArray: SpeakerItem[] = [],vipType,purchasedList=[],mineKeys=[]) {
  let obj: any = {}
  // 发音人本体
  let defaultSpeakerIds = []
  // 全体发音人
  let allSpeakerIds = []
  // 全部商店发音人
  let allStoreSpeakers = []
  // 发音人idMap
  let allSpeakerIdMap: any = {}
  let alLineSpeakerMap: any = {}
  // 声音转换发音人
  let vcSpeakerList = []
  // 已购发音人
  let userSpeakerList = []
  // 发音人名字和英文名字的映射 包含“我的”
  let nameToEngNameMap = {}
  // 分类对象
  let typeSpeakerMap: any = {}
  let userHasSpeakersMap: any = {}
  for (let i = 0; i < targetArray.length; i++) {
    let speaker = targetArray[i]
    alLineSpeakerMap[speaker.speaker] = speaker
    // 如果list中已经存在，即跳过
    if (
      allSpeakerIds.indexOf(speaker.speaker) > -1 ||
      speaker.speaker.indexOf('48k') !== -1
    )
      continue
    allSpeakerIds.push(speaker.speaker)
    allSpeakerIdMap[speaker.id] = speaker.speaker

    let speakerMoods = speaker.speaker.split('@')
    let defaultSpeaker = speakerMoods[0]
    let speakerMood = speakerMoods[1] || 'default'

    if ((speaker.vipAuth == VOICE_AUTH_TYPE.SVIP || speaker.vipAuth == VOICE_AUTH_TYPE.VIP) && (vipType == VIP_TYPE.SVIP || vipType == VIP_TYPE.COMPANY)) {
        speaker.usable = true
    }
    if (speaker.vipAuth == VOICE_AUTH_TYPE.VIP && vipType == VIP_TYPE.VIP) {
        speaker.usable = true
    }
        
    // 已购发音人
    if (speaker.vipAuth == VOICE_AUTH_TYPE.PAID && (purchasedList.includes(defaultSpeaker) || purchasedList.includes(defaultSpeaker.replace("_lpcnet","_meet"))||purchasedList.includes(defaultSpeaker.replace("_meet","_lpcnet")))) {
        speaker.usable = true
    }
    //缺少考虑3秒克隆的发音人 要设置为usable=true -直接将“我的”中的发音人设置为可用-todo
    if(speaker.vipAuth == VOICE_AUTH_TYPE.PRIVATE && mineKeys.includes(speaker.speaker)){
      speaker.usable = true
    }
    // 只考虑本体
    if (speakerMoods.length == 1) {
      // 只做24k的映射
      if (!speaker.speaker.includes('48k')) {
        nameToEngNameMap[`${speaker.name}~${speaker.pinyin}～${speaker.pinyinInitial}`] = speaker.speaker
      }
      // 分类归属
      if (Array.isArray(speaker.speakerType)) {
        speaker.speakerType.forEach(type => {
          typeSpeakerMap[type.id] = typeSpeakerMap[type.id] || {}
          typeSpeakerMap[type.id][defaultSpeaker] = 1
        })
      }

      // 搜集本体
      if (defaultSpeakerIds.indexOf(defaultSpeaker) == -1) {
        defaultSpeakerIds.push(defaultSpeaker)
      }

      // 声音转换发音人筛选-过滤掉48K,防止声音转换时出现两个
      if (speaker.vcSpeaker && !speaker.speaker.includes('_48k') && vcSpeakerList.indexOf(defaultSpeaker) == -1) {
        vcSpeakerList.push(defaultSpeaker)
      }

      // 已购发音人
      if (purchasedList.includes(speaker.speaker) && speaker.vipAuth == VOICE_AUTH_TYPE.PAID) {
        userSpeakerList.push(defaultSpeaker)
      }
      //商店发音人
      if (speaker.vipAuth == VOICE_AUTH_TYPE.PAID) {
        allStoreSpeakers.push(defaultSpeaker)
      }
    }
    
    if (speaker.usable == true) {
      userHasSpeakersMap[speaker.speaker] = speaker
    }
    // 风格名称
    speaker.styleName = speaker.name.split('|')[1] || '通用'
    if (obj[`${defaultSpeaker.replace('lpcnet', 'meet')}`]) {
      defaultSpeaker = defaultSpeaker.replace('lpcnet', 'meet')
    } else if (obj[`${defaultSpeaker.replace('meet', 'lpcnet')}`]) {
      defaultSpeaker = defaultSpeaker.replace('meet', 'lpcnet')
    }
    // map构造
    obj[`${defaultSpeaker}`] = obj[`${defaultSpeaker}`] || {}
    let moodsObj = obj[`${defaultSpeaker}`] || {}
    moodsObj[speakerMood] = speaker
    obj[`${defaultSpeaker}`] = moodsObj
    alLineSpeakerMap[speaker.speaker]=speaker

  }
  return {
    allSpeakersMap: obj,
    allSpeakerIdMap,
    nameToEngNameMap,
    allStoreSpeakers,
    defaultSpeakerIds,
    allSpeakerIds,
    vcSpeakerList,
    userSpeakerList,
    typeSpeakerMap,
    userHasSpeakersMap,
    alLineSpeakerMap
  }
}

